import type { Dict } from '../types';

export const esES: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in Open Design.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening Open Design so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open Open Design",
  'invite.open.opening': "Opening Open Design…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have Open Design installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download Open Design",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Este espacio de trabajo no tiene plazas disponibles. Añade plazas para invitar a tu equipo.",
  "workspaceInvite.seatsExhaustedAction": "Ver plazas y plan",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Este correo ya es miembro del equipo.",
  "workspaceInvite.errorPendingInvite": "Este correo ya tiene una invitación pendiente.",
  "workspaceInvite.errorNoSession": "Inicia sesión en tu cuenta de Vela antes de invitar a miembros.",
  "workspaceInvite.errorNoWorkspace": "Todavía no hay un espacio de equipo al que invitar miembros.",
  "workspaceInvite.errorUnreachable": "No se pudo enviar la invitación. Inténtalo de nuevo más tarde.",
  'chat.amrCard.switchTitle': 'Falló la llamada al modelo — esta ejecución está en pausa',
  'chat.amrCard.switchBody': 'Cambia al servicio oficial de modelos de Open Design Cloud — sin configurar API Key. Tras iniciar sesión, autorizar y recargar, esta ejecución se reintentará automáticamente.',
  'chat.amrCard.chipOfficial': 'Alojamiento oficial',
  'chat.amrCard.chipNoKey': 'Sin API Key',
  'chat.amrCard.chipAutoRetry': 'Reintento automático tras iniciar sesión',
  'chat.amrCard.switchCta': 'Cambiar a Open Design Cloud y reintentar',
  'chat.amrError.authMessage': 'Tu cuenta de Open Design Cloud aún no está autorizada. Autorízala y esta ejecución se reintentará automáticamente.',
  'chat.amrError.balanceMessage': 'Tu saldo de Open Design Cloud se ha agotado. Recarga para continuar esta ejecución.',
  'chat.amrError.authorizeCta': 'Autorizar y reintentar',
  'chat.amrError.rechargeCta': 'Recargar',
  'chat.amrBalanceGate.title': 'Mejora tu plan y sigue creando',
  'chat.amrBalanceGate.message': 'Créditos insuficientes (quedan {balance}). Mejora tu plan o recarga y la tarea podrá empezar de inmediato.',
  'chat.amrBalanceGate.benefitsTitle': 'Lo que te ofrece Open Design Cloud',
  'chat.amrBalanceGate.benefit1': 'Sin claves API, gran variedad de modelos',
  'chat.amrBalanceGate.benefit2': 'Agente de diseño SOTA integrado, sin configuración',
  'chat.amrBalanceGate.benefit3': 'Servicio oficial y fiable',
  'chat.amrBalanceGate.benefit4': 'Mejora continua: despliegue en 1 clic, multimodal, equipos y más',
  'chat.amrBalanceGate.laterCta': 'Ahora no',
  'chat.amrBalanceGate.plansCta': 'Mejorar plan',
  'chat.amrBalanceGate.signedOutTitle': 'Inicia sesión para empezar a crear',
  'chat.amrBalanceGate.signedOutMessage': 'Estás usando el agente de Open Design Cloud: inicia sesión y esta tarea podrá empezar de inmediato.',
  'chat.amrBalanceGate.signInCta': 'Iniciar sesión',
  'chat.amrBalanceGate.watchingWallet': 'Continuaremos automáticamente en cuanto se actualice tu saldo.',
  'chat.amrLowBalance.title': 'Te quedan pocos créditos',
  'chat.amrLowBalance.message': 'Solo quedan {balance}: probablemente no alcance para terminar esta tarea. Recarga o mejora tu plan primero.',
  'chat.amrLowBalance.rechargeCta': 'Recargar',
  'chat.amrLowBalance.proceedCta': 'Iniciar de todos modos',
  'chat.amrLowBalance.dontRemind': 'No volver a preguntar',
  'chat.amrArtifactUpgrade.title': 'Sigue perfeccionando con modelos más potentes',
  'chat.amrArtifactUpgrade.message': 'Desbloquea modelos avanzados, más tareas en paralelo y más créditos mensuales.',
  'chat.amrArtifactUpgrade.benefit1': 'Más modelos avanzados, como Fable 5 y GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Hasta 10 veces más tareas simultáneas',
  'chat.amrArtifactUpgrade.benefit3': 'Hasta 300 veces más créditos mensuales',
  'chat.amrArtifactUpgrade.benefit4': 'Cola prioritaria en horas punta para generar más rápido',
  'chat.amrArtifactUpgrade.promoBanner': 'Por tiempo limitado: ahorra hasta un 67 % en los planes de suscripción',
  'chat.amrArtifactUpgrade.countdownLabel': 'Termina en',
  'chat.amrArtifactUpgrade.plansCta': 'Mejora tu plan ahora, hasta un 67 % de descuento',
  'chat.amrArtifactUpgrade.homePlansCta': 'Ahorra un 67 %',
  'chat.amrArtifactUpgrade.laterCta': 'Seguir con Free y enviar',
  'chat.amrArtifactUpgrade.homeTitle': 'Tu creación está lista. Lleva más lejos la siguiente idea.',
  'chat.amrArtifactUpgrade.homeMessage': 'Mejora tu plan para obtener modelos más potentes, más tareas en paralelo y más créditos.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Ver creación',
  'chat.antigravityError.launchTerminalCta': 'Iniciar sesión desde el terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Cambiar de modelo en el terminal',
  'chat.connectionDropped': 'La conexión con el servicio del modelo se interrumpió antes de terminar la respuesta, normalmente por una red o un proxy inestables. Vuelve a intentarlo.',
  'chat.runError.title.authRequired': 'Autorización necesaria',
  'chat.runError.title.balance': 'Saldo insuficiente',
  'chat.runError.title.connectionDropped': 'Conexión interrumpida',
  'chat.runError.title.signInRequired': 'Inicio de sesión necesario',
  'chat.runError.title.rateLimited': 'Límite de uso alcanzado',
  'chat.runError.title.modelWindowLimit': 'Mucha demanda',
  'chat.runError.title.generic': 'La tarea falló',
  'chat.runError.title.artifactMissing': 'No se generó ningún entregable',
  'chat.runError.signInMessage.amr': 'El agente de Open Design Cloud aún no ha iniciado sesión; inicia sesión para empezar a usarlo.',
  'chat.runError.signInMessage.other': '{agent} no ha iniciado sesión. Comprueba su estado de inicio de sesión en local. Recomendamos el agente de Open Design Cloud: más estable y rentable.',
  'chat.runError.agentFallback': 'el agente',
  'chat.runError.sourceLabel': 'Detalles del error',
  'chat.runError.sourceExpandAria': 'Mostrar el origen del error',
  'chat.runError.sourceCollapseAria': 'Ocultar el origen del error',
  'chat.runError.title.cliMissing': 'Agente no instalado',
  'chat.runError.title.promptTooLarge': 'Entrada demasiado larga',
  'chat.runError.title.modelUnavailable': 'Modelo no disponible',
  'chat.runError.title.upstreamUnavailable': 'Servicio temporalmente no disponible',
  'chat.runError.title.toolLoop': 'Atascado en un bucle',
  'chat.runError.title.outputInvalid': 'Salida del modelo no válida',
  'chat.runError.title.runtimeConfig': 'Error de configuración',
  'chat.runError.cliMissingMessage': 'No se encontró la herramienta de línea de comandos de {agent}. Instálala y asegúrate de que esté en el PATH, luego reinténtalo.',
  'chat.runError.promptTooLargeMessage': 'Este turno superó el límite de contexto del modelo. Acorta tu mensaje, quita adjuntos o inicia una nueva conversación y reinténtalo.',
  'chat.runError.modelUnavailableMessage': 'El modelo seleccionado no está disponible o no existe. Cambia a otro modelo en Ajustes y reinténtalo.',
  'chat.runError.rateLimitedMessage': 'Has alcanzado el límite de uso del servicio del modelo. Espera un momento y reinténtalo, o cambia a otro modelo o servicio.',
  'chat.runError.modelWindowLimitMessage': 'Hay mucha demanda ahora mismo. Inténtalo de nuevo después de {retryAt}. No se te ha cobrado esta solicitud.',
  'chat.runError.modelWindowLimitMessageNoTime': 'Hay mucha demanda ahora mismo. Inténtalo de nuevo en unos momentos. No se te ha cobrado esta solicitud.',
  'chat.runError.upstreamUnavailableMessage': 'El servicio del modelo no está disponible temporalmente, normalmente por inestabilidad del proveedor o un problema de red/proxy. Reinténtalo en un momento.',
  'chat.runError.toolLoopMessage': '{agent} repitió la misma acción sin avanzar y se detuvo. Revisa el archivo o el comando de destino y reinténtalo.',
  'chat.runError.outputInvalidMessage': 'El modelo produjo una salida no válida y este turno se interrumpió. Reintentar suele resolverlo.',
  'chat.runError.runtimeConfigMessage': 'La configuración de ejecución del agente seleccionado no es válida, por lo que no se pudo iniciar. Actualiza a la última versión o contacta con soporte.',
  'chat.runError.title.quotaExhausted': "Cuota agotada",
  'chat.runError.title.timedOut': "Tiempo agotado",
  'chat.runError.title.emptyOutput': "Sin salida",
  'chat.runError.title.sessionExpired': "Sesión caducada",
  'chat.runError.title.gitBashMissing': "Falta Git Bash",
  'chat.runError.title.cpuUnsupported': "Procesador no compatible",
  'chat.runError.quotaExhaustedMessage': "La cuota o el límite de facturación de tu servicio de modelo se ha agotado, así que reintentar no servirá. Recarga con tu proveedor o cambia a otro modelo o servicio.",
  'chat.runError.workspaceCreditsMessage': "Tu espacio de trabajo se ha quedado sin créditos. Añade créditos (o pide al propietario del espacio que recargue) o cambia a otro modelo o servicio.",
  'chat.runError.timedOutMessage': "Esta ejecución tardó demasiado y se detuvo. Inténtalo de nuevo o reduce la tarea y reintenta.",
  'chat.runError.inactivityTimeoutMessage': "El agente estuvo demasiado tiempo sin nueva salida y se detuvo por tiempo agotado. Reintentar suele reanudarlo.",
  'chat.runError.emptyOutputMessage': "El agente terminó sin producir ninguna salida. Suele ser temporal: reintenta para ejecutarlo de nuevo.",
  'chat.runError.sessionExpiredMessage': "La sesión reanudada había caducado. Se ha restablecido, así que reintenta para iniciar una ejecución nueva.",
  'chat.runError.gitBashMissingMessage': "Se necesita Git Bash para ejecutar este agente en Windows, pero no se encontró. Instala Git para Windows y reintenta.",
  'chat.runError.cpuUnsupportedMessage': "El entorno de ejecución de este agente necesita un conjunto de instrucciones de CPU (AVX2) que este dispositivo no tiene, por lo que no puede iniciarse. Actualiza Open Design a la última versión, que incluye un entorno de ejecución compatible.",
  'common.cancel': 'Cancelar',
  'chat.selectFromLibrary': 'Importar de la biblioteca',
  'chat.importFigma': 'Importar de Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Importar de la biblioteca',
  'designFiles.library.title': 'Importar de la biblioteca',
  'libraryPicker.title': 'Importar de la biblioteca',
  'libraryPicker.searchPlaceholder': 'Buscar en la biblioteca…',
  'libraryPicker.empty': 'Aún no hay recursos en tu biblioteca',
  'libraryPicker.allKinds': 'Todos',
  'libraryPicker.add': 'Importar',
  'libraryPicker.loading': 'Cargando…',
  'common.save': 'Guardar',
  'common.close': 'Cerrar',
  'common.clear': 'Limpiar',
  'common.delete': 'Eliminar',
  'common.rename': 'Renombrar',
  'common.edit': 'Editar',
  'common.preview': 'Vista previa',
  'common.share': 'Compartir',
  'common.search': 'Buscar',
  'common.searchEllipsis': 'Buscar…',
  'common.loading': 'Cargando…',
  'common.all': 'Todos',
  'common.none': 'Ninguno',
  'common.default': 'Predeterminado',
  'common.installed': 'instalado',
  'common.notInstalled': 'no instalado',
  'common.active': 'activo',
  'common.inactive': 'inactivo',
  'common.offline': 'sin conexión',
  'common.selected': 'seleccionado',
  'common.create': 'Crear',
  'common.openPreview': 'Abrir vista previa',
  'common.exitFullscreen': 'Salir de pantalla completa',
  'common.fullscreen': 'Pantalla completa',
  'common.openInNewTab': 'Abrir en pestaña nueva',
  'common.exportPdf': 'Exportar como PDF',
  'common.exportZip': 'Descargar como .zip',
  'common.exportHtml': 'Exportar como HTML independiente',
  'common.exportImage': 'Exportar como imagen',
  'common.exportImageFailed': 'Error al capturar la imagen. Inténtalo de nuevo o usa la herramienta de captura de pantalla de tu navegador.',
  'common.justNow': 'justo ahora',
  'common.minutesAgo': 'hace {n} min',
  'common.hoursAgo': 'hace {n} h',
  'common.daysAgo': 'hace {n} d',
  'common.weeksAgo': 'hace {n} sem',
  'common.now': 'ahora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} d',
  'common.untitled': 'Sin título',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'Escritorio',
  'designBrowser.viewport.desktopTitle': 'Usar el tamaño completo de la pestaña',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Vista previa a 820 px de ancho',
  'designBrowser.viewport.mobile': 'Móvil',
  'designBrowser.viewport.mobileTitle': 'Vista previa a 390 px de ancho',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Añadir al chat',
  'designBrowser.status.imageAddedToChat': 'Imagen añadida al chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Procedencia',
  'plugins.availableDetails.provenanceLine': 'de {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'de {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Instalar',
  'plugins.availableDetails.version': 'Versión',
  'plugins.availableDetails.pluginVersion': 'Versión del plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copiar comando de instalación',
  'plugins.availableDetails.copied': 'Copiado',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Esta versión se ha marcado como obsoleta.',
  'plugins.availableDetails.yanked': 'Retirada.',
  'plugins.availableDetails.yankedWithReason': 'Retirada: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (retirada)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Permisos',
  'plugins.availableDetails.capabilitySummary': 'Resumen de capacidades',
  'plugins.actions.copyInstallCommand': 'Copiar comando de instalación',
  'plugins.actions.copyPluginId': 'Copiar ID del plugin',
  'plugins.actions.copyReadmeBadge': 'Copiar insignia README',
  'plugins.actions.openSourceGithub': 'Abrir código fuente en GitHub',
  'plugins.actions.openSource': 'Abrir código fuente',
  'plugins.actions.openHomepage': 'Abrir página de inicio',
  'plugins.actions.openMarketplace': 'Abrir en el marketplace',
  'app.brand': 'Open Design',
  'app.brandPill': 'Vista previa de investigación',
  'app.brandSubtitle': 'por Nexu Labs',
  'app.welcomeLoading': 'Cargando espacio de trabajo…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Te damos la bienvenida a Open Design',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Empezar a partir de un brief',
  'settings.onboardingCreateBody': 'Describe el sitio web, la app, la presentación, la imagen o el vídeo que quieres. Open Design creará un proyecto y mantendrá el trabajo editable.',
  'settings.onboardingMemoryTitle': 'Guardar el contexto de trabajo',
  'settings.onboardingMemoryBody': 'Añade preferencias, datos del proyecto y reglas recurrentes para que los chats futuros recuperen el contexto adecuado.',
  'settings.onboardingMemoryCalloutTitle': 'Guardado en tu Memoria',
  'settings.onboardingMemoryCalloutBody': 'Estas respuestas alimentan tu perfil de Memoria. Open Design lo reutiliza en cada tarea y sigue aprendiendo mientras trabajas.',
  'settings.onboardingMemoryBenefitIntent': 'Entiende lo que quieres a partir de una petición breve',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Se salta las preguntas de configuración repetidas',
  'settings.onboardingMemoryBenefitPersonalized': 'Adapta los resultados a tu rol, tu audiencia y tu gusto',
  'settings.onboardingSystemsTitle': 'Incorpora tu sistema de diseño',
  'settings.onboardingSystemsBody': 'Elige o crea un sistema de marca para que el trabajo generado respete los colores, la tipografía y el lenguaje de producto reales.',
  'settings.onboardingExecutionTitle': 'Elige la fuente del modelo',
  'settings.onboardingExecutionBody': 'Usa Open Design Hosted, conecta un agente local o utiliza tu propia clave de modelo.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Recomendado oficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Sin despliegue',
  'settings.onboardingAmrCloudBenefitModels': 'Accede a Claude, GPT, Fable 5 y 5.6 sol con un descuento por tiempo limitado y alta concurrencia.',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Próximamente',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Imagen y video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills masivas',
  'settings.onboardingAmrCloudUpcomingRouting': 'Enrutamiento inteligente',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizar Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizado',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Crear un sistema de diseño',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Mantente al día',
  'settings.onboardingNewsletterTitle': 'No te pierdas nada',
  'settings.onboardingNewsletterBody': 'Recibe novedades de producto, nuevas plantillas, design systems y trabajo de embajadores en tu bandeja. Opcional: puedes omitirlo.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Inicia sesión en Open Design',
  'settings.onboardingCloudBody': 'Inicia sesión y empieza a diseñar al instante con IA en la nube, sin configuraciones complejas.',
  'settings.onboardingCloudSignIn': 'Inicia sesión en Open Design',
  'settings.onboardingCloudContinue': 'Continuar (sesión iniciada)',
  'settings.onboardingCloudAlternative': 'Usa una CLI local o tu propia clave de API',
  'settings.onboardingCloudRights': 'Todos los derechos reservados.',
  'settings.onboardingCloudOr': 'o',
  'settings.onboardingGateTooltipNoRuntime': 'Los siguientes pasos se ejecutan con IA: elige un runtime para continuar.',
  'settings.onboardingGateTooltipAmr': 'Los siguientes pasos se ejecutan con IA: inicia sesión en Open Design Cloud para continuar.',
  'settings.onboardingGateTooltipLocal': 'Los siguientes pasos se ejecutan con IA: selecciona una CLI local disponible para continuar.',
  'settings.onboardingGateTooltipByok': 'Los siguientes pasos se ejecutan con IA: añade y prueba tu clave de modelo para continuar.',
  'settings.onboardingRecommended': 'Recomendado',
  'settings.onboardingAmrCloudOfficialBadge': 'Oficial',
  'settings.onboardingLocalTitle': 'Agente local',
  'settings.onboardingLocalBody': 'Usa Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro y más.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Usa tu propia clave',
  'settings.onboardingByokBody': 'Conecta de forma segura tu proveedor de modelos preferido con tu propia clave de API.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Sobre ti',
  'settings.onboardingProfileBody': 'Datos opcionales para mejorar los valores por defecto.',
  'settings.onboardingRoleLabel': 'Tu rol',
  'settings.onboardingOrgSizeLabel': 'Tamaño de la organización',
  'settings.onboardingUseCaseLabel': 'Caso de uso',
  'settings.onboardingSourceLabel': '¿Cómo nos conociste?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Búsqueda (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Herramienta de IA (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Amigo o compañero',
  'settings.onboardingSourceCommunity': '💬 Discord / comunidad',
  'settings.onboardingSourceEmail': '✉️ Correo / Boletín',
  'settings.onboardingSourceBlog': '📝 Blog / artículo',
  'settings.onboardingSourceOther': '✨ Otro',
  'settings.onboardingSourceOtherPlaceholder': 'Indícanos dónde (opcional)',
  'settings.onboardingSelectPlaceholder': 'Selecciona una opción',
  'settings.onboardingSelectMultiplePlaceholder': 'Selecciona una o varias',
  'settings.onboardingOrgSolo': 'Individual / personal (1)',
  'settings.onboardingOrgTeam': 'Equipo pequeño (2-10)',
  'settings.onboardingOrgStartup': 'Startup / pyme (11-50)',
  'settings.onboardingOrgGrowth': 'Empresa en crecimiento (51-200)',
  'settings.onboardingOrgMidMarket': 'Mediana empresa (201-1000)',
  'settings.onboardingOrgEnterprise': 'Gran empresa (1000+)',
  'settings.onboardingRolePm': '📋 Gestor de producto',
  'settings.onboardingRoleDesigner': '🎨 Diseñador',
  'settings.onboardingRoleEngineer': '💻 Ingeniero',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Agencia de marketing',
  'settings.onboardingRoleGrowth': '📈 Crecimiento',
  'settings.onboardingRoleOps': '⚙️ Operaciones',
  'settings.onboardingRoleFounder': '🚀 Fundador / directivo',
  'settings.onboardingRoleStudent': '🎓 Estudiante / docente',
  'settings.onboardingRoleOther': '✨ Otro',
  'settings.onboardingUseProduct': '🎨 Diseño de producto',
  'settings.onboardingUseDesignSystem': '🧩 Sistema de diseño',
  'settings.onboardingUsePrototype': '📱 Prototipo / UI de app',
  'settings.onboardingUseLanding': '🌐 Páginas de destino',
  'settings.onboardingUseAds': '📣 Anuncios / contenido social',
  'settings.onboardingUseDashboard': '📊 Paneles / herramientas internas',
  'settings.onboardingUseDeck': '🖥️ Presentación / diapositivas',
  'settings.onboardingUseMarketing': '📈 Marketing / crecimiento',
  'settings.onboardingUseEngineering': '🤝 Traspaso a ingeniería',
  'settings.onboardingUseAgency': '💼 Agencia / trabajo con clientes',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Ajustes',
  'settings.title': 'Modelos y proveedores',
  'settings.subtitle': 'Elige entre CLI local y BYOK.',
  'settings.general': 'General',
  'settings.generalHint': 'Idioma, apariencia, notificaciones, ubicaciones de proyectos, privacidad y detalles de la app.',
  'settings.modeAria': 'Modo de ejecución',
  'settings.protocolAria': 'Protocolo de API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Ejecuta a través de una CLI de agente de código en tu máquina',
  'settings.modeDaemonOffline': 'El daemon no está en ejecución',
  'settings.modeDaemonOfflineMeta': 'daemon sin conexión',
  'settings.modeDaemonInstalledMeta': '{count} instalados',
  'settings.modeApi': 'Proveedor de API',
  'settings.cloudCalloutTitle': 'Use Open Design Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'Proveedores de API',
  'settings.byokNoFileToolsNotice': 'BYOK no puede leer, escribir ni editar archivos del proyecto. Usa la CLI local cuando necesites cambios en el código.',
  'settings.byokDraftNotice': 'Completa los campos obligatorios para guardar este proveedor. Tu configuración actual seguirá activa.',
  'settings.codeAgent': 'Agente de código',
  'settings.codeAgentHint': 'Detectado al escanear tu PATH. Elige la CLI por la que quieres que pasen las generaciones.',
  'settings.rescan': '↻ Reescanear',
  'settings.rescanTitle': 'Reescanear PATH',
  'settings.rescanRunning': 'Escaneando...',
  'settings.rescanSuccess': 'Escaneo completado. {count} disponibles.',
  'settings.designSystemRenameFailed': 'No se pudo cambiar el nombre. Comprueba el daemon e inténtalo de nuevo.',
  'settings.rescanFailed': 'El escaneo falló. Comprueba el daemon e inténtalo de nuevo.',
  'settings.test': 'Probar',
  'settings.testTitle': 'Envía un mensaje minúsculo de prueba para verificar la conexión',
  'settings.testRunning': 'Probando conexión…',
  'settings.byokReadyToTest': 'Listo para probar',
  'settings.testCancel': 'Cancelar',
  'settings.testRetry': 'Reintentar prueba',
  'settings.required': 'obligatorio',
  'settings.testMissingFields': 'Rellena {fields} para probar la conexión.',
  'settings.testSuccessApi': 'Conectado. Respondió en {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} respondió en {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Autenticación fallida. Comprueba tu clave de API.',
  'settings.testForbidden': 'Acceso prohibido. Verifica cuenta, región u organización.',
  'settings.testNotFoundModel': 'No se encontró el modelo \'{model}\' en este endpoint.',
  'settings.testInvalidModelId': 'El id de modelo \'{model}\' no es válido. Los ids personalizados deben empezar con una letra o un número y no contener espacios.',
  'settings.testInvalidBaseUrl': 'La Base URL no es válida o no es accesible.',
  'settings.testRateLimited': 'El proveedor limitó la prueba. La configuración parece válida.',
  'settings.testUpstream': 'El proveedor devolvió {status}. Inténtalo de nuevo.',
  'settings.testTimeout': 'La prueba expiró tras {ms} ms.',
  'settings.testAgentMissing': '{agentName} no está instalado o no está en el PATH.',
  'settings.testAgentSpawn': 'No se pudo iniciar {agentName}: {detail}.',
  'settings.testUnknown': 'Prueba fallida: {detail}',
  'settings.agentInstall.install': 'Instalar',
  'settings.agentInstall.docs': 'Documentación',
  'settings.agentInstall.pathHint': 'Si instalaste una CLI con npm o Homebrew y sigue apareciendo como no instalada, asegúrate de que el directorio bin de la herramienta esté en el PATH que hereda el daemon de Open Design (Terminal y apps GUI pueden diferir en macOS). Consulta QUICKSTART.md (sección "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Abre Instalar o Docs para el agente que prefieras.',
  'settings.agentInstall.stepAuth': 'Autentícate con la CLI del proveedor (inicia sesión o añade credenciales API) antes de volver a Open Design.',
  'settings.agentInstall.stepRescan': 'Haz clic en Reescanear en esta sección.',
  'settings.agentInstall.stepSelect': 'Selecciona la tarjeta del agente cuando aparezca como instalado.',
  'settings.noAgentsDetected': 'Aún no se ha detectado ningún agente. Instala Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen o GitHub Copilot CLI y pulsa Reescanear.',
  'settings.agentInstalledGroup': 'Tus CLI ({count})',
  'settings.agentInstallGroup': 'Disponibles para instalar ({count})',
  'settings.agentAuthRequired': 'Autenticación requerida',
  'settings.agentAuthUnknown': 'Estado de autenticación desconocido',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'Autorizar',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Muchos modelos',
  'settings.amrPromoBonus': 'Bonificación limitada: +100%',
  'settings.amrSignInToContinue': 'Inicia sesión para continuar',
  'settings.amrSignIn': 'Iniciar sesión',
  'settings.amrSignedIn': 'Sesión iniciada',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': 'Sin sesión iniciada',
  'settings.amrSigningIn': 'Iniciando sesión…',
  'settings.amrActivationHint': '¿No se abrió la página de inicio de sesión? Pulsa el botón de abajo para volver a abrirla.',
  'settings.amrActivationBrowserFailed': 'No se pudo abrir el navegador automáticamente. Abre la página de inicio de sesión de abajo para continuar.',
  'settings.amrActivationOpen': 'Abrir página de inicio de sesión',
  'settings.amrCancelSignIn': 'Cancelar inicio de sesión',
  'settings.amrAccountStatus': 'Estado de la cuenta Open Design Cloud',
  'settings.amrConsole': 'Gestionar',
  'settings.amrBalance': 'Cuota',
  'settings.amrPlan': 'Plan',
  'settings.amrUpgrade': 'Mejorar',
  'settings.amrModelUpgradeHint': 'Mejora para usarlo',
  'settings.amrLoginErrorCompact': 'Error al iniciar sesión en Open Design Cloud.',
  'settings.advanced': 'Avanzado',
  'settings.amrLogin': 'Iniciar sesión',
  'settings.amrLogout': 'Cerrar sesión',
  'settings.amrLoggingIn': 'Iniciando sesión…',
  'settings.amrLoggingOut': 'Cerrando sesión…',
  'settings.amrLoggedInAs': 'Sesión iniciada como {email}',
  'settings.amrLoggedInWithPlan': 'Sesión iniciada como {email} · {plan}',
  'settings.amrLoggedInPill': 'Sesión iniciada',
  'settings.amrNotLoggedIn': 'Sin sesión iniciada',
  'settings.apiSection': 'API de Anthropic',
  'settings.quickFillProvider': 'Rellenar proveedor',
  'settings.providerPreset': 'Preajuste del proveedor',
  'settings.protocolGroupProtocols': 'Protocolos',
  'settings.protocolGroupGateways': 'Pasarelas',
  'settings.customProvider': 'Proveedor personalizado',
  'settings.apiKey': 'Clave de API',
  'settings.apiKeyGetLink': 'Obtener clave ↗',
  'settings.showKey': 'Mostrar clave',
  'settings.hideKey': 'Ocultar clave',
  'settings.show': 'Mostrar',
  'settings.hide': 'Ocultar',
  'settings.model': 'Modelo',
  'settings.apiKeyInvalid': 'API key no válida.',
  'settings.apiKeyCleaned': 'Se eliminaron los espacios sobrantes de la API key.',
  'settings.modelsLoadedFromAccount': '✓ Se cargaron {count} modelos de tu cuenta.',
  'settings.modelsLoadedCount': '✓ Se cargaron {count} modelos.',
  'settings.modelSourceAccount': 'De tu cuenta',
  'settings.modelSourceSuggested': 'Sugerido',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Coste bajo',
  'modelCost.halfToOne': 'Coste medio',
  'modelCost.oneToFour': 'Coste alto',
  'modelCost.overFour': 'Coste máximo',
  'settings.fetchModels': 'Obtener modelos',
  'settings.fetchModelsTitle': 'Obtener los modelos disponibles de este proveedor',
  'settings.fetchModelsRunning': 'Obteniendo modelos…',
  'settings.fetchModelsMissingFields': 'Rellena {fields} para obtener los modelos.',
  'settings.fetchModelsInvalidBaseUrl': 'Introduce una Base URL válida para obtener los modelos.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI usa nombres de implementación, por lo que la detección de modelos no está disponible aquí.',
  'settings.fetchModelsUnsupportedOllama': 'La detección de modelos de Ollama Cloud aún no está disponible. Elige o escribe un modelo.',
  'settings.fetchModelsSuccess': 'Se obtuvieron {count} modelos.',
  'settings.fetchModelsEmpty': 'No se devolvió ningún modelo de texto compatible.',
  'settings.fetchModelsUnsupported': 'La detección de modelos no está disponible para este protocolo.',
  'settings.fetchModelsFailed': 'No se pudieron obtener los modelos: {detail}',
  'settings.suggestedModelsHint': 'Estos son modelos sugeridos para este protocolo. Tu proveedor puede admitir modelos diferentes.',
  'settings.baseUrl': 'URL base',
  'settings.baseUrlInvalid': 'Usa una URL pública http:// o https://.',
  'settings.baseUrlCustomize': 'Personalizar URL',
  'settings.baseUrlDefaultHint': 'Cámbialo solo si usas un proxy o gateway compatible.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Encuéntralo en el portal de Azure → tu recurso → Endpoint.',
  'settings.azureDeploymentModel': 'Nombre del despliegue',
  'settings.azureCustomDeploymentName': 'Nombre de implementación personalizado',
  'settings.azureDeploymentModelHint': 'Para Azure OpenAI, este campo se usa como nombre del despliegue en /openai/deployments/<model>. Introduce el nombre del despliegue que creaste en Azure.',
  'settings.azureModelFetchHint': 'Introduce el nombre de la implementación de tu recurso de Azure. Las implementaciones de Azure no se pueden obtener automáticamente.',
  'settings.apiVersion': 'Versión de API',
  'settings.byokImageModel': 'Modelo de generación de imágenes',
  'settings.byokVideoModel': 'Modelo de generación de vídeo',
  'settings.byokVideoI2vHint': 'Modelo de imagen a vídeo: se requiere una imagen de referencia (si no eliges una, se usa la más reciente del proyecto)',
  'settings.byokSpeechModel': 'Modelo de voz',
  'settings.byokSpeechVoice': 'Voz',
  'settings.byokModelDefaultOption': 'Predeterminado',
  'settings.maxTokens': 'Tokens máx. (opcional)',
  'settings.maxTokensHint': 'Longitud máxima de la respuesta. Déjalo vacío para usar el valor predeterminado del modelo.',
  'settings.apiHint': 'Se almacena localmente en este dispositivo.',
  'settings.skipForNow': 'Omitir por ahora',
  'settings.getStarted': 'Empezar',
  'settings.envConfigure': 'Modelos y proveedores',
  'settings.localCli': 'CLI local',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'Open Design will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the Open Design profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'API de Anthropic',
  'settings.noAgentSelected': 'ningún agente seleccionado',
  'settings.language': 'Idioma',
  'settings.languageHint': 'Cambia el idioma de la interfaz. Se guarda en este navegador.',
  'settings.agentModelHead': 'Modelo para:',
  'settings.modelPicker': 'Modelo',
  'settings.modelSourceLive': 'En vivo desde la CLI',
  'settings.modelUsesCliDefault': 'Predeterminado de la CLI',
  'settings.modelSourceFallback': 'Lista integrada',
  'settings.reasoningPicker': 'Esfuerzo de razonamiento',
  'settings.serviceTierPicker': 'Nivel de servicio',
  'settings.modelPickerHint': 'Se obtiene de la CLI cuando expone un comando `models`. «Predeterminado» deja la elección a la propia configuración de la CLI; «Personalizado…» permite escribir cualquier id de modelo aceptado por la CLI.',
  'settings.modelPickerLiveHint': 'Los modelos se actualizaron desde la CLI instalada. Predeterminado sigue usando la configuración de la CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Los modelos se actualizaron desde la CLI instalada.',
  'settings.modelPickerFallbackHint': 'Mostrando valores predeterminados integrados. Pulsa Reescanear para obtener modelos en vivo desde la CLI.',
  'settings.cliEnvTitle': 'Avanzado: proxy y rutas personalizadas',
  'settings.cliEnvHint': 'Usa estos campos para sobrescribir el entorno de la CLI seleccionada: API keys, base URLs de proxy, homes personalizados o rutas de binarios no estándar. Sin base URL, la CLI usa su endpoint predeterminado. Los secretos permanecen en la configuración local de la app y solo los ve la CLI seleccionada.',
  'settings.cliEnvClaudeConfigDir': 'Directorio de configuración de Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL del proxy de Claude',
  'settings.cliEnvClaudeApiKey': 'API key de Claude CLI',
  'settings.cliEnvCodexHome': 'Directorio principal de Codex',
  'settings.cliEnvCodexBin': 'Ruta del ejecutable de Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL del proxy de Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key de Codex/OpenAI CLI',
  'settings.modelCustom': 'Personalizado (escribe abajo)…',
  'settings.modelCustomLabel': 'Id de modelo personalizado',
  'settings.modelCustomPlaceholder': 'p. ej., anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Proveedores de medios',
  'settings.mediaProvidersHint': 'Claves de API para generación de imagen, vídeo y audio. Se guardan localmente y se sincronizan con el daemon local.',
  'settings.mcpServerTitle': 'Open Design MCP',
  'settings.mcpServerHint': 'Expón Open Design como servidor MCP para tu agente de código.',
  'settings.externalMcpTitle': 'MCP externo',
  'settings.externalMcpHint': 'Añade herramientas MCP desde servicios externos (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Clave de API',
  'settings.mediaProviderBaseUrl': 'URL base',
  'settings.mediaProviderConfigured': 'Configurado',
  'settings.mediaProviderUnset': 'Sin configurar',
  'settings.mediaProviderClear': 'Limpiar',
  'settings.mediaProviderClearConfirm': '¿Eliminar la configuración guardada de {name}? Tendrás que introducirla de nuevo para usar {name}.',
  'settings.mediaProviderPlaceholder': 'Pega la clave de API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sobrescribir URL base por defecto',
  'settings.mediaProviderReload': 'Recargar desde el daemon',
  'settings.mediaProviderReloadError': 'No se pudieron recargar los ajustes de los proveedores de medios desde el daemon local.',
  'settings.mediaProviderReloadSuccess': 'Se recargaron los ajustes de los proveedores de medios desde el daemon local.',
  'settings.mediaProviderLoadError': 'No se pudieron cargar los ajustes de los proveedores de medios desde el daemon local. Por ahora se usarán los ajustes guardados en el navegador.',
  'settings.mediaProviderComingSoonHint': 'Rastreamos estos para la hoja de ruta; el daemon aún no incluye un cliente, por lo que no hay nada que configurar.',
  'settings.privacy': 'Privacidad',
  'settings.privacyHint': 'Qué datos se comparten con el equipo de Open Design',
  'settings.privacyConsentKicker': 'Ayúdanos a mejorar Open Design',
  'settings.privacyConsentLead': 'Compartir datos de uso nos ayuda a entender cómo funciona Open Design en flujos de trabajo reales, para mejorar las partes que más afectan a tu experiencia.',
  'settings.privacyConsentFooter': 'Puedes cambiar estas opciones en cualquier momento en Ajustes → Privacidad.',
  'settings.privacyConsentShare': 'Compartir',
  'settings.privacyConsentDecline': 'No compartir',
  'settings.privacyConsentAccept': 'Entendido',
  'settings.privacyConsentBannerFooter': 'El uso compartido de datos está activado de forma predeterminada. Puedes desactivarlo en cualquier momento en Ajustes → Privacidad.',
  'settings.privacyConsentPolicyLink': 'Leer la política de privacidad',
  'settings.privacyMetrics': 'Métricas anónimas',
  'settings.privacyMetricsHint': 'Número de ejecuciones, uso de tokens, tasa de errores y duración como métricas básicas de uso.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Después de eliminar secretos y otra información sensible, usamos prompts, respuestas del asistente, entrada/salida de herramientas y contexto necesario para la revisión de calidad.',
  'settings.privacyInstallationId': 'ID anónimo',
  'settings.privacyOptedOut': 'sin participar',
  'settings.privacyDataDeletion': 'Eliminar mis datos',
  'settings.privacyDataDeletionHint': 'Rota tu ID anónimo y detiene el envío. Las trazas existentes caducan según nuestra política de retención.',
  'settings.about': 'Acerca de',
  'settings.aboutHint': 'Versión y detalles de ejecución',
  'settings.appVersion': 'Versión',
  'settings.appChannel': 'Canal',
  'settings.appRuntime': 'Ejecución',
  'settings.appPlatform': 'Plataforma',
  'settings.appArchitecture': 'Arquitectura',
  'settings.runtimePackaged': 'App empaquetada',
  'settings.runtimeDevelopment': 'Desarrollo',
  'settings.versionUnavailable': 'Los detalles de versión no están disponibles mientras el daemon está offline.',
  "settings.allowSilentUpdates": "Permitir instalación automática de futuras actualizaciones in-app",
  "settings.allowSilentUpdatesDesc": "Cuando haya una actualización in-app lista, instálala automáticamente al siguiente inicio. No actualiza la sesión actual. Las actualizaciones con instalador siguen pidiendo confirmación.",
  'settings.installLatest': 'Instalar la última versión',
  'settings.alreadyLatest': 'Ya tienes la última versión',
  'settings.updateCheck': 'Buscar actualizaciones',
  'settings.updateNow': 'Actualizar ahora',
  'settings.updateRecheck': 'Volver a buscar',
  'settings.updateRetry': 'Reintentar',
  'settings.updateViewReleases': 'Notas de la versión',
  'settings.updateActionFailed': 'No se pudo completar la acción de actualización.',
  'settings.updateQuitFailed': 'El instalador se abrió, pero Open Design no pudo cerrarse automáticamente.',
  'settings.updateStatusNotChecked': 'Sin comprobar',
  'settings.updateStatusDevelopment': 'Las builds de desarrollo no admiten actualizaciones dentro de la app.',
  'settings.updateStatusUnsupported': 'Este entorno no admite actualizaciones dentro de la app.',
  'settings.updateStatusChecking': 'Buscando actualizaciones...',
  'settings.updateStatusUpToDate': 'Ya tienes la última versión.',
  'settings.updateStatusAvailable': 'Nueva versión {version} encontrada. Preparando descarga.',
  'settings.updateStatusAvailableUnknown': 'Nueva versión encontrada. Preparando descarga.',
  'settings.updateStatusDownloading': 'Descargando actualización...',
  'settings.updateStatusDownloadingPercent': 'Descargando actualización {percent}%.',
  'settings.updateStatusReady': 'La versión {version} está lista para instalar.',
  'settings.updateStatusReadyUnknown': 'La actualización está lista para instalar.',
  'settings.updateStatusInstalling': 'Instalando actualización...',
  'settings.updateStatusFailed': 'Error al comprobar. Reinténtalo.',
  'settings.mcpTitle': 'Servidor MCP',
  'settings.mcpHint': 'Permite que los agentes de codificación (Cursor, Claude Code, VS Code…) lean directamente tus proyectos de Open Design.',
  'settings.mcpDaemonError': 'No se pudo contactar con el daemon local para resolver las rutas de instalación ({error}). Asegúrate de que Open Design esté en ejecución y vuelve a abrir este panel.',
  'settings.mcpBuildDaemon': 'Compila primero el daemon.',
  'settings.mcpNodeMissing': 'Falta el binario de Node.',
  'settings.mcpBuildHint': 'Falta apps/daemon/dist/cli.js. Ejecuta `pnpm --filter @open-design/daemon build` y actualiza.',
  'settings.mcpMethodCli': 'Comando de CLI',
  'settings.mcpInstructionCli': 'Ejecuta esto en tu terminal.',
  'settings.mcpMethodToml': 'Configuración TOML',
  'settings.mcpInstructionCodex': 'Añade esta tabla a {path}. La misma configuración se comparte entre el CLI de Codex y la extensión de Codex para el IDE.',
  'settings.mcpMethodOneClick': 'Instalación con un clic',
  'settings.mcpInstructionCursor': 'Haz clic en «Install in Cursor» para instalar con un cuadro de diálogo de aprobación, o fusiona este JSON en {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Instalar en Cursor',
  'settings.mcpMethodJson': 'Configuración JSON',
  'settings.mcpInstructionKiro': 'Abre {path} y combina este JSON. Para la configuración a nivel de workspace, usa .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Abre la paleta de comandos ({shortcut}), ejecuta «MCP: Open User Configuration» y fusiona este JSON. Copilot Chat debe estar en modo Agent para que las herramientas aparezcan.',
  'settings.mcpInstructionAntigravity': 'En Antigravity: menú «...» del panel del Agent → MCP Servers → Manage MCP Servers → View raw config. Combina este JSON.',
  'settings.mcpInstructionZed': 'Abre los Ajustes de Zed ({shortcut}) y fusiona esto en el objeto de nivel superior. Zed usa «context_servers», no «mcpServers».',
  'settings.mcpInstructionWindsurf': 'Abre {path} (o usa el icono de MCP en Cascade → Configure) y combina:',
  'settings.mcpCopyAria': 'Copiar fragmento de configuración de MCP',
  'settings.mcpResolvingFailed': '# error al resolver las rutas, consulta el error anterior',
  'settings.mcpLoadingPaths': '# cargando rutas de instalación desde el daemon local…',
  'settings.mcpCopied': 'Copiado',
  'settings.mcpCopy': 'Copiar',
  'settings.mcpCursorApproval': 'Cursor muestra un cuadro de diálogo de aprobación antes de escribir la configuración.',
  'settings.mcpCodexOneClickInstall': 'Instalar en Codex',
  'settings.mcpCodexOneClickUninstall': 'Quitar de Codex',
  'settings.mcpCodexOneClickUnavailable': 'No se encontró Codex CLI en el PATH: instala Codex o pega el fragmento manualmente.',
  'settings.mcpCodexInstallSuccess': 'Instalado. Reinicia Codex para cargar el nuevo servidor.',
  'settings.mcpCodexUninstallSuccess': 'Eliminado de Codex.',
  'settings.mcpCodexBusy': 'Trabajando…',
  'settings.mcpCodexInstallError': 'La operación ha fallado: {error}',
  'settings.mcpRestartNote': 'Reinicia tu cliente para detectar el nuevo servidor.',
  'settings.mcpRestartDetail': 'La mayoría de los editores solo cargan los servidores MCP al iniciarse. En Cursor / VS Code / Antigravity / Windsurf puedes ejecutar `Developer: Reload Window` desde la paleta de comandos en lugar de un reinicio completo. Zed y Claude Code requieren cerrar y volver a abrir.',
  'settings.mcpCapabilitiesTitle': 'Qué puede hacer tu agent',
  'settings.mcpCapabilityRead': 'Leer o buscar cualquier archivo de un proyecto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Obtener un paquete de diseño en una sola llamada: el archivo de entrada más cada variable CSS, componente y fuente a la que hace referencia.',
  'settings.mcpCapabilityDefault': 'Usar por defecto el proyecto y el archivo que tienes abiertos en Open Design, para que puedas decir «construye esto en mi app» sin indicar de nuevo qué diseño.',
  'settings.mcpRunningNote': 'Open Design debe estar en ejecución para que las llamadas a herramientas MCP funcionen. Si iniciaste tu agent de programación antes de abrir Open Design, reinicia el agent para que pueda contactar con el daemon activo.',
  'entry.tabDesigns': 'Diseños',
  'entry.tabTemplates': 'Plantillas',
  'entry.tabDesignSystems': 'Sistemas de diseño',
  'entry.tabConnectors': 'Conectores',
  'entry.openSettingsTitle': 'Ajustes',
  'entry.openSettingsAria': 'Abrir ajustes',
  'entry.discordLabel': 'Unirse a Discord',
  'entry.discordAria': 'Únete al Discord de Open Design',
  'entry.discordAriaWithOnline': 'Únete al Discord de Open Design - {online}',
  'entry.discordOnlineLabel': '{count} en línea',
  'entry.mailAria': 'Enviar un correo a Open Design',
  'entry.accountSettings': 'Ajustes',
  'chat.collapsePane': 'Contraer el panel de conversación',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Sigue a @OpenDesignHQ en X',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'Sigue a @opendesign.ai en Instagram',
  'entry.followLinkedinLabel': 'Sigue a Open Design en LinkedIn',
  'entry.followXiaohongshuLabel': 'Sigue a Open Design en Xiaohongshu',
  'entry.resizeAria': 'Redimensionar barra lateral',
  'entry.loadingWorkspace': 'Cargando espacio de trabajo…',
  'entry.useEverywhereTitle': 'Usar en todas partes',
  'entry.useEverywhereAria': 'Abrir la guía «Usar en todas partes» (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Proyectos personales",
  "workspaceSwitcher.allProjectsTooltip": "Proyectos del equipo",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Cuota",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Cerrar sesión",
  "signOut.confirmMessage": "¿Seguro que quieres cerrar sesión?",
  "signOut.confirmAction": "Cerrar sesión",
  "entry.navRecents": "Inicio",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace para equipos — cuéntanos qué necesita tu equipo',
  'entry.workspaceTeamsAria': 'Abrir la página de Workspace para equipos',
  'entry.navExpand': 'Mostrar barra lateral',
  'entry.navCollapse': 'Ocultar barra lateral',
  'entry.navNewProject': 'Nuevo proyecto',
  'entry.navHome': 'Inicio',
  'entry.navProjects': 'Proyectos',
  'entry.navTasks': 'Automatizaciones',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Sistemas de diseño',
  'entry.navBrands': 'Kit de marca',
  'entry.navIntegrations': 'Integraciones',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Proyectos personales',
  'entry.navAllProjects': 'Proyectos del equipo',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "Open Design Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Your sign-in has expired. Sign in to continue using Open Design Cloud.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Local service connection interrupted. Recovering automatically…',
  "entry.cloudCalloutBody": "Inicia sesión para usar Open Design Cloud y colaborar en la nube",
  "entry.cloudCalloutDismissAria": "Cerrar el aviso de Open Design Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'Open Design updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'Proyecto',
  'workspaceTabs.pluginDetails': 'Detalles del plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': '¿Qué diseñarás hoy con tu agente?',
  'homeHero.startWithTemplate': 'Empezar con una plantilla…',
  'homeHero.startBlankProject': 'empezar un proyecto en blanco',
  'homeHero.templatePicker.label': 'Tipo de creación',
  'homeHero.templatePicker.searchPlaceholder': 'Buscar plantillas',
  'homeHero.templatePicker.projectTypes': 'Tipos de proyecto',
  'homeHero.templatesScrollHint': 'Desplázate hacia arriba para explorar más plantillas',
  'homeHero.templatesCollapse': 'Contraer plantillas',
  'homeHero.subtitlePrefix': 'La alternativa a Claude Design con código fuente disponible.',
  'homeHero.placeholder': 'Describe lo que quieres generar…',
  'homeHero.placeholderActive': 'Edita la consulta de ejemplo o escribe la tuya…',
  'homeHero.carousel.hint': 'Adjunta un archivo, vincula tu design system o describe lo que quieres crear',
  'homeHero.carousel.onePageBrief': 'Redactar un brief de proyecto de una página',
  'homeHero.carousel.notesToDeck': 'Convertir mis notas en una presentación',
  'homeHero.carousel.signupFlow': 'Diseñar un flujo de registro',
  'homeHero.carousel.improveBrief': 'Mejorar un brief de proyecto existente',
  'homeHero.carousel.loadingAnimation': 'Crear una animación de carga',
  'homeHero.carousel.teamUpdateSlides': 'Diseñar diapositivas para una actualización de equipo',
  'homeHero.carousel.ordersDashboard': 'Prototipar un panel para seguir pedidos',
  'homeHero.carousel.productDetail': 'Maquetar una página de detalle de producto',
  'homeHero.carousel.caseStudy': 'Esbozar un caso de estudio',
  'homeHero.carousel.landingIntro': 'Diseñar una breve introducción para una landing page',
  'homeHero.carousel.pitchDeck': 'Crear un pitch deck para un producto nuevo',
  'homeHero.carousel.appIdea': 'Describir una idea de app',
  'homeHero.carousel.landingLayout': 'Bocetar el diseño de una landing page',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Añadir contexto',
  'homeHero.addPlugin': 'Añadir plugin',
  'homeHero.addConnectors': 'Añadir conectores',
  'homeHero.addMcp': 'Añadir servidor MCP',
  'homeHero.noPlugins': 'No hay plugins instalados',
  'homeHero.noMcp': 'No hay servidores MCP',
  'homeHero.noConnectors': 'No hay conectores conectados',
  'homeHero.applying': 'Aplicando…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Eliminar plugin',
  'homeHero.removePluginAria': 'Eliminar plugin {title}',
  'homeHero.clearActivePlugin': 'Quitar plugin activo',
  'homeHero.clearActiveSkill': 'Quitar skill activa',
  'homeHero.contextItemsResolved': '{n} elementos de contexto resueltos',
  'homeHero.removeFile': 'Eliminar archivo',
  'homeHero.contextSearchResults': 'Resultados de búsqueda de contexto',
  'homeHero.contextSurfaces': 'Fuentes de contexto',
  'homeHero.loadingContext': 'Cargando contexto…',
  'homeHero.noResults': 'No hay resultados para "{query}".',
  'homeHero.searchPrompt': 'Busca archivos, plugins, skills, servidores MCP y conectores.',
  'homeHero.parameters': '{n} parámetros',
  'homeHero.details': 'Detalles',
  'homeHero.toRun': 'para ejecutar',
  'homeHero.forNewLine': 'para nueva línea',
  'homeHero.run': 'Ejecutar',
  'homeHero.typeSomethingToRun': 'Escribe algo para ejecutar',
  'homeHero.promptExamples': 'Ejemplos',
  'homeHero.footer.designSystem': 'Estilo',
  'homeHero.footer.autoDesignSystem': 'Automático',
  'homeHero.footer.autoDesignSystemSummary': 'Elige automáticamente el sistema de diseño y estilo visual más adecuados para el prompt actual.',
  'homeHero.footer.ratio': 'Proporción',
  'homeHero.footer.duration': 'Duración',
  'homeHero.footer.resolution': 'Resolución',
  'homeHero.footer.speakerNotes': 'Notas',
  'homeHero.footer.noSpeakerNotes': 'Sin notas',
  'homeHero.footer.availableCount': '{n} disponibles',
  'homeHero.footer.noMatches': 'Sin coincidencias',
  'homeHero.moreShortcuts': 'Más',
  'homeHero.railAria': 'Elige una categoría de proyecto o un atajo inicial',
  'homeHero.subTypeAria': 'Elige un subtipo',
  'homeHero.subTypeMore': 'Más',
  'homeHero.confirmReplaceTitle': '¿Reemplazar el prompt actual?',
  'homeHero.confirmReplaceBody': 'Usar {title} reemplazará el texto que hay actualmente en la entrada.',
  'homeHero.confirmReplace': 'Reemplazar',
  'homeHero.chip.prototype': 'Prototipo',
  'homeHero.chip.webClone': 'Clon de sitio web',
  'homeHero.chip.liveArtifact': 'Artefacto en vivo',
  'homeHero.chip.deck': 'Presentación de diapositivas',
  'homeHero.chip.image': 'Imagen',
  'homeHero.chip.video': 'Vídeo',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Shaders, 3D y visuales GPU generativos',
  'homeHero.chip.worker': 'Visualizador Worker',
  'homeHero.chip.workerDesc': 'Sims fuera de hilo, partículas y data viz',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Crear kit de marca',
  'homeHero.chip.createPlugin': 'Crear plugin',
  'homeHero.chip.figma': 'Desde Figma',
  'homeHero.chip.folder': 'Desde carpeta',
  'homeHero.chip.template': 'Desde plantilla',
  'homeHero.chip.liveArtifactHint': 'Crea un artefacto interactivo de HTML/CSS/JS que puedes previsualizar en vivo.',
  'homeHero.chip.hyperframesHint': 'Crea animaciones basadas en HTML: subtítulos, elementos visuales que reaccionan al audio y transiciones de escena.',
  'homeHero.chip.createBrandKitHint': 'Extrae un kit de marca de un sitio web y aplícalo en cualquier chat.',
  'homeHero.chip.createPluginHint': 'Crea un plugin reutilizable de Open Design y añádelo a Mis plugins.',
  'homeHero.chip.figmaHint': 'Migra un marco de Figma al sistema de diseño activo.',
  'homeHero.chip.folderHint': 'Importa una carpeta local existente y continúa editando.',
  'homeHero.chip.templateHint': 'Empieza desde una plantilla incluida.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.triggerShort': 'Working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Carpeta',
  'workingDirPicker.homeTitle': 'Guardado en el almacenamiento local: haz clic para elegir una carpeta',
  'workingDirPicker.processing': 'Procesando…',
  'workingDirPicker.select': 'Almacenamiento local',
  'workingDirPicker.clearAria': 'Borrar directorio de trabajo',
  'workingDirPicker.replaceFailed': 'No se pudo reemplazar el directorio de trabajo',
  'workingDirPicker.unavailable': 'El selector de carpetas no está disponible en esta versión. Ejecuta la aplicación de escritorio para elegir una carpeta.',
  'workingDirPicker.openUnavailable': 'Abre este proyecto en la aplicación de escritorio para mostrar la carpeta.',
  'workingDirPicker.openFailed': 'No se pudo mostrar esta carpeta',
  'workingDirPicker.showInFileManager': 'Mostrar en el explorador de archivos',
  'workingDirPicker.replace': 'Elegir carpeta…',
  'workingDirPicker.recent': 'Directorios recientes',
  'workingDirPicker.defaultLabel': 'Almacenamiento local',
  'handoff.toTarget': 'Transferir a {target}',
  'handoff.openInTarget': 'Abrir en {target}',
  'handoff.openAction': 'Abrir',
  'handoff.menuTitle': '¿En qué editor abrir?',
  'handoff.action': 'Transferir',
  'handoff.fallbackTitle': 'No se han encontrado editores en $PATH: se abre en {target}',
  'handoff.chooseTargetAria': 'Elegir destino de transferencia',
  'handoff.optionsAria': 'Opciones de transferencia',
  'handoff.editorSection': 'Abrir con un editor',
  'handoff.cliSection': 'Copiar para CLI',
  'handoff.clickOpen': 'Haz clic para abrir',
  'handoff.framework': 'Framework de código',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript, HTML y CSS sin frameworks',
  'handoff.amrWebsite': 'Abrir el sitio web de Open Design Cloud',
  'handoff.copyPrompt': 'Copiar prompt',
  'handoff.copyPromptForTarget': 'Copiar prompt para {target}',
  'handoff.copied': 'Copiado',
  'handoff.projectPathUnavailable': 'La ruta del proyecto aún se está cargando. Inténtalo de nuevo en un momento.',
  'handoff.copyFailed': 'Se ha bloqueado la escritura en el portapapeles. Inténtalo de nuevo en un momento.',
  'handoff.promptIntro': 'Continuar desde esta carpeta local del proyecto de Open Design:',
  'handoff.promptTarget': 'Destino',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Vas a tomar el control en {cli}. Por favor:',
  'handoff.promptReadFiles': 'Entra en este directorio o léelo primero. Da prioridad a DESIGN.md, README, el HTML/CSS/JS existente, los recursos y package.json si está presente.',
  'handoff.promptKeepDesign': 'Conserva el diseño visual, la maquetación, las interacciones y los recursos actuales. No te detengas en un plan.',
  'handoff.promptProduceCode': 'Genera o modifica código {framework} real y ejecutable. Si el proyecto ya tiene un stack más claro, señala el conflicto y mantén el resultado ejecutable.',
  'handoff.promptVerify': 'Termina indicándome los comandos de ejecución, vista previa y verificación.',
  'handoff.promptCommandHint': 'Para empezar desde el directorio del proyecto, usa:',
  'handoff.promptProject': 'Proyecto',
  'handoff.promptProjectId': 'ID del proyecto',
  'handoff.notInstalled': 'No instalado',
  'handoff.notDetectedTitle': '{target}: no detectado en $PATH',
  'designSystemPicker.select': 'Elegir sistema de diseño',
  'designSystemPicker.loading': 'Cargando sistemas de diseño…',
  'designSystemPicker.searchPlaceholder': 'Buscar sistemas de diseño (título / categoría / resumen)',
  'designSystemPicker.searchCompactPlaceholder': 'Buscar sistemas de diseño',
  'designSystemPicker.noneTitle': 'Sin sistema de diseño',
  'designSystemPicker.noneSummary': 'Dejar que el modelo elija libremente',
  'designSystemPicker.empty': 'No hay sistemas de diseño coincidentes',
  'designSystemPicker.openPreview': 'Abrir vista previa',
  'designSystemPicker.loadingPreview': 'Cargando vista previa…',
  'designSystemPicker.noPreview': 'No hay página de vista previa. Abre Sistemas de diseño para ver la vista previa completa.',
  'designSystemPicker.previewHint': 'Pasa el cursor sobre un sistema de diseño para previsualizarlo',
  'designSystemPicker.fullscreenAria': 'Vista previa a pantalla completa de {title}',
  'designSystemPicker.closeFullscreen': 'Cerrar la vista previa a pantalla completa',
  'designSystemPicker.closeEsc': 'Cerrar (Esc)',
  'designSystemPicker.previewFrameTitle': 'Vista previa de {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Vista previa a pantalla completa de {title}',
  'recentProjects.title': 'Proyectos recientes',
  'recentProjects.viewAll': 'Ver todo',
  'recentProjects.empty': 'Aún no hay proyectos: escribe un prompt para empezar uno.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Borrar filtros',
  'pluginsHome.title': 'Comunidad',
  'pluginsHome.subtitle': 'Flujos de trabajo de Open Design listos para usar incluidos con este runtime. Elige uno para cargar un prompt inicial o explora el registro para ver más.',
  'pluginsHome.browseRegistry': 'Explorar registro',
  'pluginsHome.count': '{filtered} de {total}',
  'pluginsHome.loadingCatalog': 'Cargando catálogo…',
  'pluginsHome.emptyCatalog': 'El catálogo está vacío. Los plugins integrados se incluyen con Open Design y deberían aparecer aquí automáticamente; prueba a reiniciar el daemon si esto persiste.',
  'pluginsHome.emptyFiltered': 'Ningún plugin coincide con los filtros actuales.',
  'pluginsHome.clearFilters': 'Borrar filtros',
  'pluginsHome.modeAria': 'Modo de plugin',
  'pluginsHome.featured': 'Guardado',
  'pluginsHome.totalInCatalog': '{n} en el catálogo',
  'pluginsHome.categoryFilterAria': 'Filtro de categoría',
  'pluginsHome.subcategoryFilterAria': 'Filtro de subcategoría de {label}',
  'pluginsHome.allCategory': 'Todos: {label}',
  'pluginsHome.searchPlaceholder': 'Buscar plugins…',
  'pluginsHome.searchAria': 'Buscar plugins',
  'pluginsHome.clearSearch': 'Borrar búsqueda',
  'pluginsHome.sortAria': 'Orden de clasificación',
  'pluginsHome.sortHot': 'Populares',
  'pluginsHome.sortNewest': 'Más recientes',
  'pluginsHome.facet.import': 'Importar',
  'pluginsHome.facet.create': 'Crear',
  'pluginsHome.facet.export': 'Exportar',
  'pluginsHome.facet.share': 'Compartir',
  'pluginsHome.facet.deploy': 'Desplegar',
  'pluginsHome.facet.refine': 'Refinar',
  'pluginsHome.facet.extend': 'Ampliar',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Código / carpeta',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Captura de pantalla',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Diapositivas',
  'pluginsHome.facet.publicLink': 'Enlace público',
  'pluginsHome.facet.githubPr': 'PR de GitHub',
  'pluginsHome.facet.githubGist': 'Gist de GitHub',
  'pluginsHome.subfacet.business-dashboards': 'Paneles',
  'pluginsHome.subfacet.app-prototypes': 'Apps',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Herramientas dev',
  'pluginsHome.subfacet.docs-reports': 'Docs / informes',
  'pluginsHome.subfacet.brand-design': 'Marca / diseño',
  'pluginsHome.subfacet.pitch-business': 'Pitch / negocio',
  'pluginsHome.subfacet.course-training': 'Cursos / formación',
  'pluginsHome.subfacet.reports-briefings': 'Informes / resúmenes',
  'pluginsHome.subfacet.product-sales': 'Producto / ventas',
  'pluginsHome.subfacet.engineering-talks': 'Charlas técnicas',
  'pluginsHome.subfacet.creative-decks': 'Decks creativos',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / maquetas',
  'pluginsHome.subfacet.brand-visuals': 'Marca / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / contenido',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / retrato',
  'pluginsHome.subfacet.illustration-style': 'Ilustración / estilo',
  'pluginsHome.subfacet.motion-effects': 'Motion / efectos',
  'pluginsHome.subfacet.social-short-form': 'Social / formato corto',
  'pluginsHome.subfacet.marketing-product': 'Marketing / producto',
  'pluginsHome.subfacet.data-explainers': 'Datos / explicativos',
  'pluginsHome.subfacet.cinematic-story': 'Cinemático / narrativa',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Explora los flujos de trabajo instalados, descubre entradas del registro, gestiona fuentes y prepara plugins para distribuirlos al equipo.',
  'pluginsView.importPlugin': 'Importar plugin',
  'pluginsView.agentContext': 'Contexto del agent',
  'pluginsView.summaryAria': 'Resumen del plugin',
  'pluginsView.areasAria': 'Áreas del plugin',
  'pluginsView.loading': 'Cargando plugins…',
  'pluginsView.tab.installed': 'Instalado',
  'pluginsView.tab.available': 'Disponible',
  'pluginsView.tab.sources': 'Fuentes',
  'pluginsView.tab.team': 'Equipo',
  'pluginsView.tabHint.installed': 'Tus plugins',
  'pluginsView.tabHint.available': 'Desde fuentes',
  'pluginsView.tabHint.sources': 'Catálogos',
  'pluginsView.tabHint.team': 'Empresa',
  'pluginsView.installedTitle': 'Plugins instalados',
  'pluginsView.installedSubtitle': 'Plugins que has importado o instalado desde fuentes de marketplace.',
  'pluginsView.installedEmpty': 'Todavía no hay plugins de usuario instalados. Usa Crear / Importar o instala una entrada Disponible.',
  'pluginsView.availableTitle': 'Disponibles desde fuentes',
  'pluginsView.availableSubtitle': 'Entradas del catálogo descubiertas en los marketplaces configurados.',
  'pluginsView.availableFiltersAria': 'Filtros de plugins disponibles',
  'pluginsView.searchAvailableAria': 'Buscar plugins disponibles',
  'pluginsView.searchAvailablePlaceholder': 'Buscar plugins disponibles',
  'pluginsView.clearAvailableSearch': 'Borrar búsqueda de plugins disponibles',
  'pluginsView.source': 'Fuente',
  'pluginsView.availableEmptyInstalled': 'Todavía no hay entradas disponibles. Las entradas del catálogo instaladas se quitan de Disponible; desinstala una para volver a hacerla disponible.',
  'pluginsView.availableEmptyFiltered': 'Ninguna entrada disponible coincide con tus filtros.',
  'pluginsView.availableEmptyNoSources': 'Todavía no hay entradas disponibles. Añade una fuente en la pestaña Fuentes.',
  'pluginsView.installing': 'Instalando…',
  'pluginsView.installWaiting': 'Esperando…',
  'pluginsView.installQueuedHint': 'Se está instalando otro plugin. Las instalaciones se ejecutan de una en una: este botón estará disponible cuando termine.',
  'pluginsView.install': 'Instalar',
  'pluginsView.sourcesTitle': 'Fuentes de registro',
  'pluginsView.sourcesSubtitle': 'Catálogos del marketplace que alimentan las entradas de plugins disponibles.',
  'pluginsView.sourceUrl': 'URL de origen',
  'pluginsView.defaultTrust': 'Confianza predeterminada',
  'pluginsView.trust.restricted': 'Restringido',
  'pluginsView.trust.trusted': 'De confianza',
  'pluginsView.trust.official': 'Oficial',
  'pluginsView.adding': 'Añadiendo…',
  'pluginsView.addSource': 'Añadir fuente',
  'pluginsView.sourcesEmpty': 'Aún no hay fuentes de registro configuradas.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catálogo v{version}',
  'pluginsView.trustFor': 'Confianza para {name}',
  'pluginsView.refreshing': 'Actualizando…',
  'pluginsView.removing': 'Eliminando…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to Open Design.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "Open Design official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. Open Design will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from Open Design official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Sincronizar con el equipo",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "Se sincronizó la versión más reciente de \"{title}\" con el equipo.",
  "pluginsView.syncUnavailable": "Todavía no se pudo sincronizar \"{title}\". Confirma que estás en un espacio de trabajo de equipo.",
  "pluginsView.syncFailed": "No se pudo sincronizar \"{title}\" con el equipo. Inténtalo de nuevo más tarde.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplaces privados de equipo',
  'pluginsView.teamBody': 'Esta área está reservada para catálogos empresariales y de equipo, políticas de confianza privadas y controles compartidos del ciclo de vida de los plugins.',
  'pluginCard.details': 'Detalles',
  'pluginCard.use': 'Usar',
  'pluginCard.useWithQuery': 'Usar con consulta',
  'pluginCard.applying': 'Aplicando…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Creando remix…',
  'pluginCard.duplicateFailed': 'No se pudo remezclar esta plantilla.',
  'pluginCard.saved': 'Guardado',
  'pluginCard.publish': 'Publicar',
  'pluginCard.contribute': 'Contribuir',
  'pluginCard.starting': 'Iniciando…',
  'pluginCard.detailsAria': 'Ver detalles de {title}',
  'pluginCard.chooseUseAria': 'Elige cómo usar {title}',
  'pluginCard.useOptionsAria': 'Opciones de uso de {title}',
  'pluginCard.duplicateAria': 'Remezclar {title} como un nuevo proyecto',
  'pluginCard.saveAria': 'Guardar {title}',
  'pluginCard.savedAria': '{title} está guardado',
  'pluginCard.shareAria': 'Compartir {title}',
  'pluginCard.publishAria': 'Publicar {title} como repositorio de GitHub',
  'pluginCard.publishTitle': 'Publicar plugin como repositorio de GitHub',
  'pluginCard.contributeAria': 'Contribuir con {title} a Open Design',
  'pluginCard.contributeTitle': 'Contribuir con el plugin a Open Design mediante un pull request',
  'skillPluginCandidate.createForMe': 'Crear plugin/plantilla',
  'skillPluginCandidate.contributeToMain': 'Contribuir a open-design',
  'skillPluginCandidate.repoDescription': 'Este repositorio parece que podría funcionar como plugin.',
  'integrations.kicker': 'Integración',
  'integrations.lede': 'Conecta sistemas externos, incorpora herramientas MCP a tu bucle de agente y usa Open Design desde otros IDE, scripts y automatizaciones.',
  'integrations.agentReady': 'Listo para agentes',
  'integrations.areasAria': 'Áreas de integración',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Herramientas externas',
  'integrations.tabHint.connectors': 'Cuentas y API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integraciones de Skills',
  'integrations.skillsBody': 'La gestión de integraciones a nivel de Skill se está trasladando desde otra rama. Esta pestaña está reservada para que MCP, los conectores y la futura configuración de Skills convivan en la misma ruta de Integración.',
  'mcpClient.title': 'Servidores MCP externos',
  'mcpClient.subtitle': 'Herramientas de terceros para tu agente de programación.',
  'mcpClient.addServer': 'Añadir servidor',
  'mcpClient.emptyTitle': 'No hay servidores MCP configurados.',
  'mcpClient.emptyBody': 'Haz clic en «Añadir servidor» para empezar: elige una plantilla (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) o configura un servidor stdio / HTTP personalizado.',
  'mcpClient.saveChanges': 'Guardar cambios',
  'mcpClient.storedAt': 'Almacenado en',
  'mcpClient.daemonError': 'No se pudo conectar con el daemon local. Asegúrate de que Open Design esté en ejecución y vuelve a abrir este panel.',
  'mcpClient.saveFailed': 'Error al guardar. Comprueba que el daemon esté en ejecución e inténtalo de nuevo.',
  'useEverywhere.modalAria': 'Usa Open Design en todas partes',
  'useEverywhere.modalTitle': 'Usa Open Design en todas partes',
  'useEverywhere.modalSubtitle': 'Integra Open Design en cualquier IDE, Agent o script: CLI, HTTP, MCP y Skills. Usa «Copiar guía para un Agent» y pégala en Claude Code, Codex, Cursor, openclaw o hermes para configurarlo todo.',
  'useEverywhere.closeAria': 'Cerrar usar en todas partes',
  'useEverywhere.closeTitle': 'Cerrar (Esc)',
  'useEverywhere.tabsAria': 'Superficies de integración',
  'useEverywhere.footStrong': 'Transferencia con un solo clic.',
  'useEverywhere.footBody': 'Copia una guía estructurada en markdown sobre la que tu Agent puede actuar de inmediato: instalar, verificar y usar.',
  'useEverywhere.configureMcp': 'Configurar servidor MCP',
  'useEverywhere.copyGuide': 'Copiar guía para un agente',
  'useEverywhere.copy': 'Copiar',
  'useEverywhere.copied': 'Copiado',
  'useEverywhere.copyFailed': 'Error al copiar',
  'useEverywhere.copySnippetAria': 'Copiar fragmento: {label}',
  'useEverywhere.section.overview.tab': 'Resumen',
  'useEverywhere.section.overview.heading': 'Open Design funciona allí donde funcione tu agent',
  'useEverywhere.section.overview.intro': 'Open Design es más que una ventana: es un daemon local con privilegios (`od`) más un registro de Skills + Sistemas de diseño + Atoms. Una vez que se está ejecutando en tu máquina, cualquier Agent de código (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, tu propio script) puede impulsar generaciones, inspeccionar proyectos y producir artefactos de diseño a través de cuatro superficies intercambiables.',
  'useEverywhere.section.overview.bullet1': 'CLI: `od <command>` para scripts headless, CI y automatización de shell.',
  'useEverywhere.section.overview.bullet2': 'Servidor MCP: conecta Open Design como servidor Model Context Protocol para que cualquier Agent compatible con MCP pueda listar skills, ejecutar escenarios y leer artefactos.',
  'useEverywhere.section.overview.bullet3': 'API HTTP: endpoints REST + SSE en `http://127.0.0.1:7456/api/*`; la misma superficie que usa la interfaz web.',
  'useEverywhere.section.overview.bullet4': 'Skills: paquetes `SKILL.md` listos para usar (compatibles con Claude) que cualquier Agent que ya esté en tu PATH puede invocar sin necesidad de Open Design.',
  'useEverywhere.section.overview.bullet5': 'Artefactos estándar: genera proyectos HTML reales a partir de Skills, plugins predeterminados integrados y ejemplos de plugins de la comunidad antes de que arranque el daemon.',
  'useEverywhere.section.overview.snippet1': 'Inicia el daemon (y la interfaz web) localmente',
  'useEverywhere.section.overview.snippet2': 'Confirma que es accesible',
  'useEverywhere.section.overview.snippet3': 'Ingiere los artefactos estándar antes del arranque',
  'useEverywhere.section.overview.footer': 'El daemon escribe en `./.od/` (local del proyecto) de forma predeterminada. Define `OD_DATA_DIR=~/.open-design` para compartir datos entre proyectos.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controla Open Design desde cualquier shell',
  'useEverywhere.section.cli.intro': 'El binario `od` se incluye con el daemon y es el mismo binario que usan Claude Code / Codex cuando ejecutan una generación. La mayoría de los subcomandos son clientes ligeros que hacen POST al daemon local, por lo que funcionan igual tanto si lo lanzaste con `pnpm tools-dev` como si lo hiciste como aplicación empaquetada.',
  'useEverywhere.section.cli.bullet1': '`od` (sin argumentos): arranca el daemon y abre la interfaz web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...`: produce bytes de imagen / vídeo / audio a través del protocolo de medios unificado.',
  'useEverywhere.section.cli.bullet3': '`od run ...`: inicia la ejecución de un proyecto a partir de un prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>`: instala y aplica plugins de la comunidad.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list`: inspecciona lo que está disponible localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor`: verifica el estado del daemon y detecta CLIs de Agent en tu PATH.',
  'useEverywhere.section.cli.snippet1': 'Genera una imagen (delega en el proveedor de medios configurado)',
  'useEverywhere.section.cli.snippet2': 'Ejecuta un plugin de escenario sin interfaz y transmite eventos como líneas JSON',
  'useEverywhere.section.cli.snippet3': 'Inventaría las skills y los sistemas de diseño disponibles localmente',
  'useEverywhere.section.cli.snippet4': 'Comprueba los artefactos sembrados a través de la CLI',
  'useEverywhere.section.cli.snippet5': 'Verificar entorno + Agents detectados (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Todos los subcomandos aceptan `--daemon-url http://127.0.0.1:<port>` para apuntar a un daemon en ejecución concreto, útil cuando se ejecuta una segunda instancia aislada para pruebas.',
  'useEverywhere.section.mcp.tab': 'Servidor MCP',
  'useEverywhere.section.mcp.heading': 'Expón Open Design como servidor MCP a cualquier agent de programación',
  'useEverywhere.section.mcp.intro': 'Open Design incluye un servidor Model Context Protocol (`od mcp`) que permite a cualquier cliente compatible con MCP —Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes— descubrir las herramientas de Open Design (listar skills, renderizar vistas previas, generar medios, ejecutar plugins) sin tener que recurrir manualmente a la shell. El daemon publica un fragmento de instalación listo para pegar mediante `GET /api/mcp/install-info` para cada cliente principal.',
  'useEverywhere.section.mcp.bullet1': 'Transporte stdio: sin puerto adicional, el cliente lanza `od mcp` directamente.',
  'useEverywhere.section.mcp.bullet2': 'Detecta automáticamente la URL del daemon en ejecución a través del socket de estado IPC local cuando se lanza como sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Recurre a `--daemon-url http://127.0.0.1:<port>` en las instalaciones simples para que el proceso MCP siempre encuentre un daemon en ejecución.',
  'useEverywhere.section.mcp.bullet4': 'Fija `OD_DATA_DIR` para que el proceso MCP generado escriba en el mismo lugar que ya usa el daemon (evita EPERM en los paquetes de aplicaciones de macOS).',
  'useEverywhere.section.mcp.snippet1': 'Configuración genérica de cliente MCP (funciona en Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'O: pide al daemon el fragmento adaptado a tu instalación',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP de artefactos en vivo (leer y actualizar paneles)',
  'useEverywhere.section.mcp.footer': 'En la app de Open Design, abre Ajustes → Integraciones para copiar un comando de instalación específico del cliente (Cursor, Claude Code, Antigravity, VS Code) en lugar de editar el JSON a mano.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'La misma superficie REST + SSE que usa la interfaz web',
  'useEverywhere.section.http.intro': 'El daemon local sirve una API HTTP en `http://127.0.0.1:7456` (puerto configurable). Cada endpoint que llama la interfaz web también está disponible para tus scripts. Los endpoints de streaming (turnos de chat, ejecuciones de proyectos) emiten Server-Sent Events con los tipos de contrato de `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health`: actividad del daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` y `GET /api/design-systems`: registros disponibles.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` y `POST /api/projects`: lista y crea proyectos (POST devuelve el proyecto + la primera conversación).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat`: flujo SSE de eventos del Agent para una conversación.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply`: vincula un plugin instalado y obtén su consulta de ejemplo renderizada + las entradas.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents`: CLIs de Agent de código detectados en tu PATH.',
  'useEverywhere.section.http.snippet1': 'Lista las skills instaladas (el agent las usará como plantillas)',
  'useEverywhere.section.http.snippet2': 'Crea un proyecto a partir de un prompt (flujo completo en el servidor)',
  'useEverywhere.section.http.snippet3': 'Transmite un turno de chat (SSE: cada línea es compatible con JSON-Lines)',
  'useEverywhere.section.http.footer': 'Los tipos de TypeScript puros para cada solicitud/respuesta residen en `@open-design/contracts`: impórtalos en tu script para tener autocompletado completo sin tener que configurar un generador.',
  'useEverywhere.section.skills.tab': 'Skills y sin interfaz',
  'useEverywhere.section.skills.heading': 'Skills listas para usar con cualquier Agent, incluso sin Open Design en ejecución',
  'useEverywhere.section.skills.intro': 'Una Skill es un directorio con un `SKILL.md` compatible con Claude (front-matter YAML + cuerpo). Open Design amplía el formato con el espacio de nombres `od:` (`mode`, `preview`, `design_system`, `inputs`, …) para que el mismo artefacto pueda usarse tanto dentro de Open Design como por un Agent corriente como Claude Code, Codex, openclaw o hermes. El descubrimiento sigue una cadena de precedencia para que los proyectos puedan anular sus propias skills.',
  'useEverywhere.section.skills.bullet1': 'Descubrimiento: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (gana el proyecto).',
  'useEverywhere.section.skills.bullet2': 'Crea un enlace simbólico de una skill en varios proyectos para compartirla sin copiarla.',
  'useEverywhere.section.skills.bullet3': 'Cada skill puede declarar conectores, átomos, requisitos del sistema de diseño y un ejemplo de salida `preview` para la galería.',
  'useEverywhere.section.skills.bullet4': 'Sin interfaz: un agent con `od` en su PATH puede llamar a `od skills list` y luego ejecutar cualquier skill; el daemon es opcional para los flujos de solo lectura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` ejercita la misma forma de artefacto con ejemplos de plugins predeterminados y ejemplos de plugins de la comunidad, y luego almacena los proyectos `index.html` resultantes como datos de prueba reutilizables.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md mínimo (front matter compatible con Claude + extras de Open Design)',
  'useEverywhere.section.skills.snippet2': 'Crea un enlace simbólico de una skill compartida en un proyecto (estilo cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Sin interfaz: lista las skills que el daemon ve ahora mismo',
  'useEverywhere.section.skills.snippet4': 'Paquete de fixtures de artefactos sin interfaz',
  'useEverywhere.section.skills.footer': 'Especificación: `docs/skills-protocol.md` y `docs/agent-adapters.md` cubren toda la superficie de adaptadores (Claude Code, Codex, Cursor, agents compatibles con MCP, alternativa de API BYOK) y las estrategias de inyección de skills por adaptador.',
  'tasks.kicker': 'Espacio de trabajo de automatización',
  'tasks.comingSoon': 'Próximamente',
  'tasks.lede': 'Las automatizaciones convierten los prompts en trabajo duradero: Orbit las ejecuta, las rutinas las mantienen, las programaciones deciden cuándo se disparan y los artefactos en vivo muestran lo que ha cambiado.',
  'tasks.newAutomation': 'Nueva automatización',
  'tasks.previewNote': 'Solo superficie de vista previa. Los ajustes de Orbit ya están disponibles hoy; las rutinas, las programaciones y la conexión de artefactos en vivo llegarán a medida que se fusionen las ramas del backend.',
  'tasks.primitivesAria': 'Primitivas de automatización',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Un runtime persistente para trabajo de agent prolongado o recurrente.',
  'tasks.primitive.orbit.enabled': 'Resumen diario activado',
  'tasks.primitive.orbit.manualOnly': 'Solo manual',
  'tasks.primitive.routines.title': 'Rutinas',
  'tasks.primitive.routines.body': 'Definiciones de tareas duraderas que perduran tras finalizar un solo chat.',
  'tasks.primitive.routines.meta': 'Shell del producto lista',
  'tasks.primitive.schedules.title': 'Programaciones',
  'tasks.primitive.schedules.body': 'Disparadores de tiempo o de evento que deciden cuándo debe ejecutarse una rutina.',
  'tasks.primitive.schedules.meta': 'Rama pendiente',
  'tasks.primitive.liveArtifacts.title': 'Artefactos en vivo',
  'tasks.primitive.liveArtifacts.body': 'Informes y notas que se siguen actualizando mientras un agent trabaja.',
  'tasks.primitive.liveArtifacts.meta': 'Modelo de vista previa',
  'tasks.listAria': 'Lista de automatizaciones',
  'tasks.routinesAndRuns': '{n} rutinas y ejecuciones',
  'tasks.filtersAria': 'Filtros de automatización',
  'tasks.filter.scheduled': 'Programado',
  'tasks.filter.running': 'En ejecución',
  'tasks.filter.done': 'Hecho',
  'tasks.configurationAria': 'Configuración de la automatización',
  'tasks.slot.trigger': 'Disparador',
  'tasks.slot.pattern': 'Patrón',
  'tasks.slot.runtime': 'Entorno de ejecución',
  'tasks.slot.output': 'Salida',
  'tasks.liveArtifact': 'Artefacto en vivo',
  'tasks.viewProgress': 'Ver progreso',
  'tasks.pause': 'Pausar',
  'tasks.runNow': 'Ejecutar ahora',
  'tasks.openArtifact': 'Abrir artefacto',
  'tasks.status.dailyAt': 'Diario · {time}',
  'tasks.status.pausedManual': 'En pausa · solo manual',
  'tasks.sample.orbit.title': 'Resumen del conector de Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'El resumen del conector está programado',
  'tasks.sample.orbit.metaDisabled': 'Abre los ajustes de Orbit para activarlo',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefacto en vivo',
  'tasks.sample.orbit.previewDisabled': 'No hay ninguna ejecución programada',
  'tasks.sample.orbit.triggerEnabled': 'Programación · diariamente a las {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · ejecutar bajo demanda',
  'tasks.sample.orbit.pattern': 'Rutina · resumen de conectores',
  'tasks.sample.orbit.runtime': 'Orbit · programado por el daemon',
  'tasks.sample.orbit.output': 'Artefacto en vivo · informe actualizable',
  'tasks.sample.orbit.artifactMetaEnabled': 'Se actualiza tras cada ejecución',
  'tasks.sample.orbit.artifactMetaDisabled': 'Esperando la programación',
  'tasks.sample.orbit.body1': '# Resumen de actividad de Orbit Daily',
  'tasks.sample.orbit.body2': 'Conectores comprobados · aciertos, omisiones y fallos',
  'tasks.sample.orbit.body3': 'Los aspectos destacados se convierten en un artefacto en vivo actualizable.',
  'tasks.sample.mcp.title': 'Investigación de alternativas a MCP',
  'tasks.sample.mcp.status': 'Ejecutándose en orbit · 2h 14min',
  'tasks.sample.mcp.meta': '14 / 30 fuentes procesadas',
  'tasks.sample.mcp.preview': 'research_notes.md · en directo',
  'tasks.sample.mcp.trigger': 'Manual · una sola vez',
  'tasks.sample.mcp.pattern': 'Prompt de investigación profunda',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Informe en directo · actualización automática',
  'tasks.sample.mcp.artifactMeta': 'Actualizado hace 12 s',
  'tasks.sample.mcp.body1': '# Alternativas a MCP: hallazgos provisionales',
  'tasks.sample.mcp.body2': '14 fuentes revisadas · 3 candidatos preseleccionados',
  'tasks.sample.mcp.body3': '## Lista de preseleccionados',
  'tasks.sample.mcp.body4': '- Esquemas de llamadas a herramientas mediante JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolos de Agent basados en gRPC...',
  'tasks.sample.weekly.title': 'Resumen semanal del equipo',
  'tasks.sample.weekly.status': 'Siguiente: lun 9:00',
  'tasks.sample.weekly.meta': 'Actualiza el documento semanal del equipo',
  'tasks.sample.weekly.preview': 'team_weekly.md · siguiente artefacto',
  'tasks.sample.weekly.trigger': 'Programación · semanal',
  'tasks.sample.weekly.pattern': 'Rutina · resumen del equipo',
  'tasks.sample.weekly.runtime': 'Remoto · recurrente',
  'tasks.sample.weekly.output': 'Artefacto en directo · markdown',
  'tasks.sample.weekly.artifactMeta': 'Última actualización hace 4 d',
  'tasks.sample.weekly.body1': '# Resumen semanal del equipo',
  'tasks.sample.weekly.body2': '## En curso',
  'tasks.sample.weekly.body3': '- Revisión de integración del sistema de diseño',
  'tasks.sample.weekly.body4': '- Repaso de calidad de los conectores',
  'tasks.sample.weekly.body5': '## Riesgos',
  'tasks.sample.pr.title': 'Recordatorio de revisión de PR',
  'tasks.sample.pr.status': 'Con cada PR nuevo · activado hace 23min',
  'tasks.sample.pr.meta': 'Envía un mensaje directo de Slack',
  'tasks.sample.pr.preview': 'La última entrega se realizó correctamente',
  'tasks.sample.pr.trigger': 'Evento · PR nuevo',
  'tasks.sample.pr.pattern': 'Rutina · notificación',
  'tasks.sample.pr.runtime': 'Local · ejecución rápida',
  'tasks.sample.pr.output': 'Mensaje · mensaje directo de Slack',
  'tasks.sample.pr.artifactMeta': 'Última activación hace 23 min',
  'tasks.sample.pr.body1': 'Se abrió el PR n.º 184 para revisión',
  'tasks.sample.pr.body2': 'Revisores asignados: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Entrega: mensaje directo de Slack enviado',
  'tasks.sample.meeting.title': 'Preparación previa a la reunión',
  'tasks.sample.meeting.status': 'Mañana · 10:00',
  'tasks.sample.meeting.meta': 'Una sola vez · envía resumen',
  'tasks.sample.meeting.preview': 'meeting_brief.md · en cola',
  'tasks.sample.meeting.trigger': 'Programación · una sola vez',
  'tasks.sample.meeting.pattern': 'Prompt de preparación',
  'tasks.sample.meeting.runtime': 'Remoto · limitado',
  'tasks.sample.meeting.output': 'Artefacto + mensaje',
  'tasks.sample.meeting.artifactMeta': 'En cola para generación',
  'tasks.sample.meeting.body1': '# Resumen de la reunión',
  'tasks.sample.meeting.body2': 'Fuente del orden del día: evento del calendario + documentos vinculados',
  'tasks.sample.meeting.body3': 'La salida incluirá decisiones, bloqueos y preguntas.',
  'tasks.sample.candidate.title': 'Seguimiento de candidatos',
  'tasks.sample.candidate.status': 'Fallido · requiere atención',
  'tasks.sample.candidate.meta': 'Autenticación caducada',
  'tasks.sample.candidate.preview': 'Vuelve a conectar Greenhouse para reanudar',
  'tasks.sample.candidate.trigger': 'Programación · diaria',
  'tasks.sample.candidate.pattern': 'Rutina · sincronización de candidatos',
  'tasks.sample.candidate.runtime': 'Remoto · recurrente',
  'tasks.sample.candidate.output': 'Artefacto en directo · tabla',
  'tasks.sample.candidate.artifactMeta': 'En pausa hasta que se restablezca la autenticación',
  'tasks.sample.candidate.body1': '# Flujo de candidatos',
  'tasks.sample.candidate.body2': 'Última sincronización correcta: hace 2 d',
  'tasks.sample.candidate.body3': 'Acción requerida: vuelve a conectar la cuenta de origen.',
  'routines.title': 'Automatizaciones',
  'routines.subtitle': 'Automatizaciones programadas que se ejecutan sin supervisión.',
  'routines.newAutomation': 'Nueva automatización',
  'routines.loading': 'Cargando…',
  'routines.empty': 'Todavía no hay automatizaciones.',
  'routines.emptyHint': 'Haz clic en Nueva automatización para programar una ejecución del agent sin supervisión.',
  'routines.runHistoryLoading': 'Cargando ejecuciones…',
  'routines.runHistoryEmpty': 'Todavía no hay ejecuciones.',
  'routines.fieldName': 'Nombre',
  'routines.fieldNamePlaceholder': 'Resumen matutino',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Extrae la actividad de ayer en GitHub + Linear y resume lo que cambió.',
  'routines.fieldSchedule': 'Programación',
  'routines.fieldMinute': 'Minuto de cada hora',
  'routines.fieldTime': 'Hora',
  'routines.fieldTimezone': 'Zona horaria',
  'routines.fieldsetProject': 'Proyecto',
  'routines.kind.hourly': 'Cada hora',
  'routines.kind.daily': 'Diariamente',
  'routines.kind.weekdays': 'Días laborables',
  'routines.kind.weekly': 'Semanalmente',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Lun',
  'routines.weekday.short.2': 'Mar',
  'routines.weekday.short.3': 'Mié',
  'routines.weekday.short.4': 'Jue',
  'routines.weekday.short.5': 'Vie',
  'routines.weekday.short.6': 'Sáb',
  'routines.weekday.long.0': 'Domingo',
  'routines.weekday.long.1': 'Lunes',
  'routines.weekday.long.2': 'Martes',
  'routines.weekday.long.3': 'Miércoles',
  'routines.weekday.long.4': 'Jueves',
  'routines.weekday.long.5': 'Viernes',
  'routines.weekday.long.6': 'Sábado',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Se ejecuta cada hora en el :{minute}',
  'routines.describe.daily': 'Se ejecuta diariamente a las {time} {tz}',
  'routines.describe.weekdays': 'Se ejecuta de lun. a vie. a las {time} {tz}',
  'routines.describe.weekly': 'Se ejecuta cada {day} a las {time} {tz}',
  'routines.modeCreate': 'Crear un proyecto nuevo en cada ejecución',
  'routines.modeCreateHint': 'Un espacio de trabajo nuevo y aislado en cada disparo.',
  'routines.modeReuse': 'Reutilizar un proyecto existente',
  'routines.modeReuseHint': 'Cada ejecución se aloja como una conversación nueva dentro del proyecto.',
  'routines.pickProject': '— Elige un proyecto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nuevo proyecto en cada ejecución',
  'routines.tagPaused': 'en pausa',
  'routines.metaNext': 'siguiente: {when}',
  'routines.metaLast': 'última:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'programada',
  'routines.openProject': 'Abrir proyecto',
  'routines.openProjectTitle': 'Abrir el proyecto en el que escribió esta ejecución',
  'routines.runNow': 'Ejecutar ahora',
  'routines.edit': 'Editar',
  'routines.pause': 'Pausar',
  'routines.resume': 'Reanudar',
  'routines.history': 'Historial',
  'routines.hideHistory': 'Ocultar historial',
  'routines.delete': 'Eliminar',
  'routines.deleteTitle': 'Eliminar esta automatización',
  'routines.cancel': 'Cancelar',
  'routines.save': 'Guardar',
  'routines.saving': 'Guardando…',
  'routines.create': 'Crear',
  'routines.creating': 'Creando…',
  'routines.status.queued': 'en cola',
  'routines.status.running': 'en ejecución',
  'routines.status.succeeded': 'completada',
  'routines.status.failed': 'fallida',
  'routines.status.canceled': 'cancelado',
  'routines.confirmDelete': '¿Eliminar esta automatización? Se conservan las ejecuciones anteriores y sus proyectos.',
  'routines.errorPickProject': 'Elige un proyecto para reutilizarlo o cambia a «Crear uno nuevo en cada ejecución»',
  'routines.errorAgentEmptyOutput': 'El agent finalizó sin generar ningún resultado. Es posible que el modelo o el proveedor devolviera una respuesta vacía; revisa los registros del agent para ver si hay errores anteriores.',
  'entry.helpAria': 'Ayuda',
  'entry.helpMenuAria': 'Menú de ayuda',
  'entry.helpGetHelp': 'Obtener ayuda en GitHub',
  'entry.helpSubmitFeature': 'Enviar una sugerencia',
  'entry.helpWhatsNew': 'Novedades',
  'entry.helpDownloadDesktop': 'Descargar app de escritorio',
  'entry.githubStarLabel': 'Estrella',
  'entry.githubStarTitle': 'Haz clic para darnos una estrella en GitHub',
  'entry.githubStarAria': 'Dar una estrella a Open Design en GitHub',
  'entry.tabImageTemplates': 'Plantillas de imagen',
  'entry.tabVideoTemplates': 'Plantillas de vídeo',
  'promptTemplates.searchPlaceholder': 'Buscar plantillas…',
  'promptTemplates.countLabel': '{n} resultados',
  'promptTemplates.emptyImage': 'Aún no hay plantillas de prompt de imagen instaladas.',
  'promptTemplates.emptyVideo': 'Aún no hay plantillas de prompt de vídeo instaladas.',
  'promptTemplates.emptyNoMatch': 'Ninguna plantilla coincide con tu búsqueda.',
  'promptTemplates.attributionFooter': 'Adaptadas de bibliotecas públicas de prompts. Cada tarjeta enlaza al autor original.',
  'promptTemplates.openPreviewTitle': 'Abrir prompt y vista previa',
  'promptTemplates.sourcePrefix': 'Fuente:',
  'promptTemplates.fetchError': 'No se pudo cargar el cuerpo de esta plantilla.',
  'promptTemplates.promptLabel': 'Cuerpo del prompt',
  'promptTemplates.copyPrompt': 'Copiar prompt',
  'promptTemplates.copyDone': '¡Copiado!',
  'promptTemplates.modelHint': 'Modelo sugerido: {model}',
  'promptTemplates.openSource': 'Ver original',
  'promptTemplates.openFullscreen': 'Abrir vista previa en pantalla completa',
  'promptTemplates.closeFullscreen': 'Cerrar vista previa en pantalla completa',
  'promptTemplates.allSources': 'Todas las fuentes',
  'promptTemplates.sourceFilterAria': 'Filtrar por fuente',
  'promptTemplates.retry': 'Reintentar',
  'connectors.title': 'Conectores',
  'connectors.subtitle': 'Fuentes de datos locales y futuras que pueden alimentar artefactos en vivo.',
  'connectors.account': 'Cuenta',
  'connectors.noAccount': 'Sin conectar',
  'connectors.tools': 'Herramientas',
  'connectors.connect': 'Conectar',
  'connectors.disconnect': 'Desconectar',
  'connectors.authorizationPending': 'Esperando autorización...',
  'connectors.authorizationPendingHint': 'Completa la autorización en la ventana abierta.',
  'connectors.cancelAuthorization': 'Cancelar',
  'connectors.configure': 'Configurar',
  'connectors.unavailable': 'No disponible',
  'connectors.phaseStubTitle': 'Las API de conectores llegarán en la fase 3; esta es una superficie de vista previa.',
  'connectors.statusAvailable': 'Disponible',
  'connectors.statusConnected': 'Conectado',
  'connectors.statusError': 'Error',
  'connectors.statusDisabled': 'Desactivado',
  'connectors.gateTitle': 'Añade tu API key de Composio para continuar',
  'connectors.gateBody': 'Pega tu clave arriba y haz clic en Guardar clave para cargar las integraciones disponibles.',
  'connectors.aboutLabel': 'Acerca de',
  'connectors.detailsLabel': 'Detalles',
  'connectors.statusLabel': 'Estado',
  'connectors.category.aiAgents': 'Agents de IA',
  'connectors.category.aiInfrastructure': 'Infraestructura de IA',
  'connectors.category.accounting': 'Contabilidad',
  'connectors.category.admin': 'Administración',
  'connectors.category.advertising': 'Publicidad',
  'connectors.category.analytics': 'Analítica',
  'connectors.category.automation': 'Automatización',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendario',
  'connectors.category.commerce': 'Comercio',
  'connectors.category.communication': 'Comunicación',
  'connectors.category.contacts': 'Contactos',
  'connectors.category.dataPlatform': 'Plataforma de datos',
  'connectors.category.database': 'Base de datos',
  'connectors.category.design': 'Diseño',
  'connectors.category.developer': 'Desarrollador',
  'connectors.category.documentation': 'Documentación',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Educación',
  'connectors.category.email': 'Correo electrónico',
  'connectors.category.events': 'Eventos',
  'connectors.category.fieldService': 'Servicio de campo',
  'connectors.category.finance': 'Finanzas',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formularios',
  'connectors.category.gaming': 'Videojuegos',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hostelería',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integración',
  'connectors.category.localization': 'Localización',
  'connectors.category.logistics': 'Logística',
  'connectors.category.maps': 'Mapas',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Medios',
  'connectors.category.meetings': 'Reuniones',
  'connectors.category.nonprofit': 'Sin ánimo de lucro',
  'connectors.category.observability': 'Observabilidad',
  'connectors.category.payments': 'Pagos',
  'connectors.category.personal': 'Personal',
  'connectors.category.presentations': 'Presentaciones',
  'connectors.category.procurement': 'Compras',
  'connectors.category.product': 'Producto',
  'connectors.category.productivity': 'Productividad',
  'connectors.category.projectManagement': 'Gestión de proyectos',
  'connectors.category.recruiting': 'Selección de personal',
  'connectors.category.research': 'Investigación',
  'connectors.category.salesIntelligence': 'Inteligencia de ventas',
  'connectors.category.scheduling': 'Programación',
  'connectors.category.search': 'Búsqueda',
  'connectors.category.security': 'Seguridad',
  'connectors.category.signing': 'Firma',
  'connectors.category.social': 'Redes sociales',
  'connectors.category.spreadsheets': 'Hojas de cálculo',
  'connectors.category.storage': 'Almacenamiento',
  'connectors.category.support': 'Soporte',
  'connectors.category.surveys': 'Encuestas',
  'connectors.category.tasks': 'Tareas',
  'connectors.category.timeTracking': 'Control de tiempo',
  'connectors.category.video': 'Vídeo',
  'connectors.category.whiteboard': 'Pizarra',
  'connectors.categoryLabel': 'Categoría',
  'connectors.providerLabel': 'Proveedor',
  'connectors.toolsSection': 'Herramientas',
  'connectors.toolsLoading': 'Cargando herramientas…',
  'connectors.noToolsAvailable': 'Aún no hay herramientas disponibles. Conéctate para descubrir qué expone esta integración.',
  'connectors.toolDetailsUnavailable': 'Los detalles de las herramientas no están disponibles, pero este conector informa de {n} herramientas.',
  'connectors.loadMoreTools': 'Cargar más herramientas',
  'connectors.openDetailsAria': 'Abrir detalles de {name}',
  'connectors.toolsBadgeNone': 'Sin herramientas',
  'connectors.toolsBadgeOne': '{n} herramienta',
  'connectors.toolsBadgeMany': '{n} herramientas',
  'connectors.searchPlaceholder': 'Buscar conectores…',
  'connectors.searchAriaLabel': 'Buscar conectores por nombre, proveedor o herramienta',
  'connectors.searchClear': 'Borrar búsqueda',
  'connectors.emptyNoMatchTitle': 'Ningún conector coincide con «{query}»',
  'connectors.emptyNoMatchBody': 'Prueba con otra palabra clave o borra la búsqueda para explorar el catálogo completo.',
  'connectors.emptyNoMatchAction': 'Borrar búsqueda',
  'newproj.tabPrototype': 'Prototipo',
  'newproj.tabLiveArtifact': 'Artefacto en vivo',
  'newproj.tabDeck': 'Presentación',
  'newproj.tabTemplate': 'Desde plantilla',
  'newproj.tabMedia': 'Medios',
  'newproj.tabOther': 'Otro',
  'newproj.titlePrototype': 'Nuevo prototipo',
  'newproj.titleLiveArtifact': 'Nuevo artefacto en vivo',
  'newproj.titleDeck': 'Nueva presentación',
  'newproj.titleTemplate': 'Empezar desde una plantilla',
  'newproj.titleImage': 'Nueva imagen',
  'newproj.titleVideo': 'Nuevo vídeo',
  'newproj.titleAudio': 'Nuevo audio',
  'newproj.titleMedia': 'Nuevo medio',
  'newproj.titleOther': 'Nuevo proyecto',
  'newproj.namePlaceholder': 'Nombre del proyecto',
  'newproj.fidelityLabel': 'Fidelidad',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fidelidad',
  'newproj.toggleSpeakerNotes': 'Usar notas del orador',
  'newproj.toggleSpeakerNotesHint': 'Menos texto en las diapositivas: deja los puntos clave en las notas.',
  'newproj.toggleAnimations': 'Incluir animaciones',
  'newproj.toggleAnimationsHint': 'Añade movimiento (entrada, hover, transiciones) sobre la plantilla.',
  'newproj.targetPlatformsLabel': 'Plataformas de destino',
  'newproj.targetPlatformsHint': 'Elige una o varias. La web adaptable solo cubre los puntos de ruptura del navegador; añade iOS, Android, app para tablet o app de escritorio para variantes nativas multiplataforma.',
  'newproj.platform.responsive.label': 'Web adaptable',
  'newproj.platform.responsive.hint': 'Una experiencia web adaptada a navegadores de escritorio, tablet y móvil',
  'newproj.platform.webDesktop.label': 'Web de escritorio',
  'newproj.platform.webDesktop.hint': 'Producto o página de aterrizaje centrados en el navegador',
  'newproj.platform.mobileIos.label': 'App de iOS',
  'newproj.platform.mobileIos.hint': 'Marcos de iPhone y reglas de interacción de iOS',
  'newproj.platform.mobileAndroid.label': 'App de Android',
  'newproj.platform.mobileAndroid.hint': 'Marcos de Pixel y reglas de interacción de Material',
  'newproj.platform.tablet.label': 'App para tablet',
  'newproj.platform.tablet.hint': 'Experiencia de tablet de estilo nativo con vistas divididas',
  'newproj.platform.desktopApp.label': 'App de escritorio',
  'newproj.platform.desktopApp.hint': 'Interfaz de app de macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superficies complementarias',
  'newproj.includeLandingPage': 'Incluir página de aterrizaje',
  'newproj.includeLandingPageHint': 'Añade una página de marketing adaptable para anuncios, listas de espera, campañas de lanzamiento, descargas de apps o explicación del producto.',
  'newproj.includeOsWidgets': 'Incluir widgets del sistema operativo',
  'newproj.includeOsWidgetsHint': 'Añade widgets nativos de la plataforma para la pantalla de inicio, la pantalla de bloqueo o de acceso rápido en aplicaciones de móvil/tableta.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponible cuando se selecciona una aplicación de iOS, Android o tableta como plataforma de destino.',
  'newproj.templateLabel': 'Plantilla',
  'newproj.noTemplatesTitle': 'Aún no hay plantillas',
  'newproj.noTemplatesBody': 'Abre cualquier proyecto y usa el menú Compartir dentro del visor de archivos para convertirlo en plantilla. Las plantillas aparecerán aquí.',
  'newproj.savedTemplate': 'Plantilla guardada',
  'newproj.fileSingular': 'archivo',
  'newproj.filePlural': 'archivos',
  'newproj.create': 'Crear',
  'newproj.locationLabel': 'Guardar en',
  'newproj.locationDefault': 'Proyectos de Open Design',
  'newproj.locationExternalBase': 'Base externa',
  'newproj.createLiveArtifact': 'Crear artefacto en vivo',
  'newproj.createFromTemplate': 'Crear desde plantilla',
  'newproj.createDisabledTitle': 'Guarda primero un proyecto como plantilla (menú Compartir dentro de cualquier proyecto).',
  'newproj.openFolder': 'Abrir carpeta',
  'newproj.openingFolder': 'Abriendo…',
  'newproj.importClaudeZip': 'Importar ZIP de Claude Design',
  'newproj.importClaudeZipTitle': 'Importar una exportación .zip de Claude Design',
  'newproj.importingClaudeZip': 'Importando…',
  'newproj.privacyFooter': 'Por defecto, solo tú puedes ver tu proyecto.',
  'newproj.designSystem': 'Sistema de diseño',
  'newproj.dsNoneFreeform': 'Ninguno: estilo libre',
  'newproj.dsNoneSubtitleEmpty': 'Sin tokens de sistema, elige tu propia paleta',
  'newproj.dsNoneSubtitleSelected': 'Omitir tokens de sistema. El agente elige su propia paleta.',
  'newproj.dsCategoryFallback': 'Sistema de diseño',
  'newproj.dsSearch': 'Buscar sistemas de diseño…',
  'newproj.dsModeAria': 'Modo de selección',
  'newproj.dsModeSingle': 'Único',
  'newproj.dsModeMulti': 'Múltiple',
  'newproj.dsNoneTitle': 'Ninguno: estilo libre',
  'newproj.dsNoneSub': 'Omitir tokens de sistema. El agente elige su propia paleta.',
  'newproj.dsEmpty': 'Ningún sistema de diseño coincide con «{query}».',
  'newproj.dsFootSingular': 'es solo inspiración.',
  'newproj.dsFootPlural': 'son solo inspiración.',
  'newproj.dsFootClear': 'Limpiar',
  'newproj.dsBadgeDefault': 'PREDETERMINADO',
  'newproj.dsPrimaryFallback': 'Principal',
  'newproj.surfaceImage': 'Imagen',
  'newproj.surfaceVideo': 'Vídeo',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modelo',
  'newproj.modelSearch': 'Buscar modelos…',
  'newproj.modelEmpty': 'No hay modelos que coincidan.',
  'newproj.modelRecommended': 'Recomendado',
  'newproj.modelMissingTitle': 'Elegir un modelo',
  'newproj.modelMissingSub': 'Elige un modelo para esta superficie.',
  'newproj.aspectLabel': 'Proporción',
  'newproj.videoLengthLabel': 'Duración',
  'newproj.videoLengthSeconds': '{n} s',
  'newproj.audioKindLabel': 'Tipo de audio',
  'newproj.audioKindMusic': 'Música',
  'newproj.audioKindSpeech': 'Voz / TTS',
  'newproj.audioKindSfx': 'Efecto de sonido',
  'newproj.audioDurationLabel': 'Duración',
  'newproj.audioDurationSeconds': '{n} s',
  'newproj.voiceLabel': 'Voz',
  'newproj.voicePlaceholder': 'Id de voz del proveedor, opcional',
  'newproj.connectorsLabel': 'Conectores',
  'newproj.connectorsHint': 'Fuentes de datos de las que puede obtener datos este artefacto.',
  'newproj.connectorsEmptyTitle': 'No hay conectores configurados',
  'newproj.connectorsEmptyBody': 'Conecta una fuente de datos para que tu artefacto en vivo pueda obtener cifras reales en lugar de marcadores de posición.',
  'newproj.connectorsEmptyCta': 'Configurar conectores →',
  'newproj.connectorsLoading': 'Cargando conectores…',
  'newproj.connectorsCountOne': '{n} conectado',
  'newproj.connectorsCountMany': '{n} conectados',
  'newproj.connectorsManage': 'Gestionar',
  'newproj.promptTemplateLabel': 'Plantilla de referencia',
  'newproj.promptTemplateNoneTitle': 'Ninguna — escribe la tuya',
  'newproj.promptTemplateNoneSub': 'Sáltate la galería y describe tu propio briefing',
  'newproj.promptTemplateRefSub': 'Plantilla de referencia',
  'newproj.promptTemplateSearch': 'Buscar plantillas…',
  'newproj.promptTemplateEmpty': 'Aún no hay plantillas para este formato.',
  'newproj.promptTemplateBodyLabel': 'Prompt (editable)',
  'newproj.promptTemplateOptimizeHint': 'Edita lo que quieras — tus cambios se incorporan al briefing del agente.',
  'newproj.promptTemplateBodyEmpty': 'Cuerpo vacío — el agente no recibirá ninguna referencia de plantilla.',
  'newproj.deleteTemplateTitle': 'Eliminar plantilla',
  'newproj.deleteTemplateConfirm': '¿Eliminar «{name}»? Esta acción no se puede deshacer.',
  'newproj.deleteTemplateConfirmCta': 'Eliminar plantilla',
  'newproj.deleteTemplateError': 'No se pudo eliminar esta plantilla. Inténtalo de nuevo.',
  'designs.subRecent': 'Recientes',
  'designs.subYours': 'Tus diseños',
  'designs.filterAria': 'Filtrar proyectos',
  'designs.searchPlaceholder': 'Buscar…',
  'designs.emptyNoProjects': 'Aún no hay proyectos.',
  'designs.emptyNoMatch': 'Ningún proyecto coincide con tu búsqueda.',
  'designs.deleteTitle': 'Eliminar proyecto',
  'designs.deleteConfirm': '¿Eliminar «{name}»?',
  'designs.cardFreeform': 'estilo libre',
  'designs.badgeLive': 'En vivo',
  'designs.liveArtifactBadgesAria': 'Insignias de artefacto en vivo',
  'designs.liveCount': '{n} en vivo',
  'designs.statusLive': 'Artefacto en vivo',
  'designs.statusArchived': 'Archivado',
  'designs.statusError': 'Error',
  'designs.statusRefreshing': 'Actualizando…',
  'designs.statusRefreshFailed': 'Error al actualizar',
  'designs.statusRefreshed': 'Actualizado',
  'designs.status.notStarted': 'Sin empezar',
  'designs.status.queued': 'En cola',
  'designs.status.running': 'En ejecución',
  'designs.status.awaitingInput': 'Necesita respuesta',
  'designs.status.incomplete': 'Incompleto',
  'designs.status.succeeded': 'Completado',
  'designs.status.published': 'Publicado',
  'designs.status.failed': 'Fallido',
  'designs.status.canceled': 'Cancelado',
  'designs.viewToggleAria': 'Modo de vista',
  'designs.viewGrid': 'Vista en cuadrícula',
  'designs.viewKanban': 'Vista en tablero',
  'designs.kanbanEmptyColumn': 'Sin diseños',
  'designs.deleteAria': 'Eliminar proyecto {name}',
  'designs.menuMore': 'Más acciones',
  'designs.menuRename': 'Cambiar nombre',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Eliminar',
  'designs.renamePrompt': 'Nuevo nombre para «{name}»',
  'designs.selectMode': 'Seleccionar',
  'designs.cancelSelect': 'Cancelar',
  'designs.deleteSelected': 'Eliminar seleccionados',
  'designs.selectedCount': '{n} seleccionados',
  'designs.deleteSelectedConfirm': '¿Eliminar {n} proyecto(s)?',
  'designs.deleteSelectedSuccess': '{n} proyecto(s) eliminado(s) correctamente.',
  'designs.deleteSelectedPartial': '{deleted} proyecto(s) eliminado(s); {failed} con errores.',
  'designs.tagPrototype': 'Prototipo',
  'designs.tagLiveArtifact': 'Artefacto en vivo',
  'designs.tagWebClone': 'Clon de sitio web',
  'designs.tagSlide': 'Diapositiva',
  'designs.tagMedia': 'Multimedia',
  'designs.renameTitle': 'Cambiar nombre del proyecto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancelar',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superficie',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Imagen',
  'examples.surfaceVideo': 'Vídeo',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Escenario',
  'examples.modeAll': 'Todos',
  'examples.modePrototypeDesktop': 'Prototipos · Escritorio',
  'examples.modePrototypeMobile': 'Prototipos · Móvil',
  'examples.modeDeck': 'Diapositivas',
  'examples.modeDocument': 'Documentos y plantillas',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'En vivo',
  'examples.scenarioGeneral': 'General',
  'examples.scenarioEngineering': 'Ingeniería',
  'examples.scenarioProduct': 'Producto',
  'examples.scenarioDesign': 'Diseño',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Ventas',
  'examples.scenarioFinance': 'Finanzas',
  'examples.scenarioHr': 'RR. HH.',
  'examples.scenarioOperations': 'Operaciones',
  'examples.scenarioSupport': 'Soporte',
  'examples.scenarioLegal': 'Legal',
  'examples.scenarioEducation': 'Educación',
  'examples.scenarioPersonal': 'Personal',
  'examples.searchPlaceholder': 'Buscar ejemplos…',
  'examples.searchAria': 'Buscar ejemplos por nombre',
  'examples.emptyNoSkills': 'No hay skills disponibles. ¿Está el daemon en ejecución?',
  'examples.emptyNoMatch': 'Ningún ejemplo coincide con estos filtros.',
  'examples.openPreview': '⤢ Abrir vista previa',
  'examples.loadingPreview': 'Cargando vista previa…',
  'examples.hoverPreview': 'Pasa el cursor para ver la vista previa',
  'examples.usePrompt': 'Usar este prompt',
  'examples.previewModalTitle': 'Abrir vista previa completa (modal)',
  'examples.shareTitle': 'Compartir este ejemplo',
  'examples.shareLoadFirst': 'Pasa el cursor para cargar primero la vista previa',
  'examples.unavailablePlaceholder': 'Sin vista previa {kind} incluida — abre para saber más',
  'examples.shareUnavailable': 'Sin vista previa {kind} incluida para compartir',
  'examples.shareMenu': 'Compartir ▾',
  'examples.exportPdfAllSlides': 'Exportar como PDF (todas las diapositivas)',
  'examples.exportPptxLocked': 'Exportar como PPTX… (abre primero la plantilla)',
  'examples.tagSlideDeck': 'Presentación',
  'examples.tagTemplate': 'Plantilla',
  'examples.tagDesignSystem': 'Sistema de diseño',
  'examples.tagMobilePrototype': 'Prototipo móvil',
  'examples.tagDesktopPrototype': 'Prototipo de escritorio',
  'examples.tagImage': 'Imagen',
  'examples.tagVideo': 'Vídeo',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Vista previa',
  'ds.surfaceLabel': 'Superficie',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Imagen',
  'ds.surfaceVideo': 'Vídeo',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Buscar sistemas de diseño…',
  'ds.emptyNoMatch': 'Ningún sistema de diseño coincide con tu búsqueda.',
  'ds.badgeDefault': 'PREDETERMINADO',
  'ds.preview': 'Vista previa',
  'ds.previewTitle': 'Vista previa del sistema de diseño',
  'ds.categoryAll': 'Todos',
  'ds.categoryUncategorized': 'Sin categoría',
  'ds.showcase': 'Vitrina',
  'ds.tokens': 'Tokens',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Cargando DESIGN.md…',
  'avatar.title': 'Cuenta y ajustes',
  'avatar.localCli': 'CLI local',
  'avatar.anthropicApi': 'API de Anthropic',
  'avatar.useLocal': 'Usar CLI local',
  'avatar.useApi': 'Usar API · BYOK',
  'avatar.codeAgent': 'Agente de código',
  'avatar.rescan': 'Reescanear PATH',
  'avatar.amrConsole': 'Cuenta Open Design Cloud',
  'avatar.amrConsoleMeta': 'Saldo y recarga',
  'avatar.settings': 'Ajustes',
  'avatar.backToProjects': 'Volver a los proyectos',
  'avatar.metaActive': 'activo',
  'avatar.metaOffline': 'sin conexión',
  'avatar.metaSelected': 'seleccionado',
  'avatar.noAgentSelected': 'ningún agente seleccionado',
  'avatar.modelSection': 'Modelo',
  'avatar.modelLabel': 'Modelo',
  'avatar.reasoningLabel': 'Razonamiento',
  'avatar.serviceTierLabel': 'Nivel de servicio',
  'avatar.customSuffix': '(personalizado)',
  'socialShare.openDesignSection': 'Compartir Open Design',
  'socialShare.openDesignTitle': 'Open Design en GitHub',
  'socialShare.openDesignText': 'Open Design es un espacio de trabajo con código fuente disponible para crear, editar, desplegar y entregar artefactos de diseño.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'COMPARTIR EN REDES SOCIALES',
  'socialShare.publishPageTitle': 'Publicar página para compartir',
  'socialShare.publishPageSubtitle': 'Publica esta vista previa para poder compartirla en redes sociales.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Creado con Open Design: {title}. Consulta el artefacto desplegado y dale una estrella al repositorio: {repo}',
  'socialShare.projectCopyText': 'Creado con Open Design: {title}\n{url}\nRepositorio de Open Design: {repo}',
  'socialShare.deployFirst': 'Desplegar y compartir…',
  'socialShare.copied': 'Copiado',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Cambiar CLI / modelo',
  'inlineSwitcher.chipCli': 'CLI local',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'predeterminado',
  'inlineSwitcher.noAgent': 'sin agente',
  'inlineSwitcher.modeLabel': 'Modo',
  'inlineSwitcher.agentLabel': 'Agente',
  'inlineSwitcher.providerLabel': 'Proveedor',
  'inlineSwitcher.modelLabel': 'Modelo',
  'inlineSwitcher.useCli': 'Usar CLI local',
  'inlineSwitcher.useByok': 'Usar clave API propia',
  'inlineSwitcher.daemonOffline': 'Daemon offline — abrir ajustes',
  'inlineSwitcher.noAgentsDetected': 'No se detectó CLI en PATH',
  'inlineSwitcher.openSettingsForModel': 'Configura el proveedor en Ajustes',
  'inlineSwitcher.missingApiKey': 'Falta la clave API — abre Ajustes para añadirla.',
  'inlineSwitcher.openFullSettings': 'Abrir ajustes de ejecución',
  'inlineSwitcher.customSuffix': '(personalizado)',
  'project.backToProjects': 'Volver a los proyectos',
  'project.brandReadyTitle': 'El sistema de diseño {name} está listo',
  'project.brandReadyTitleGeneric': 'Tu sistema de diseño está listo',
  'project.brandReadyCta': 'Ver en Sistemas de diseño',
  'project.brandReadyDismiss': 'Descartar',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Vista previa del sistema de diseño abierta.',
  'project.previewCommentSaveFailed': 'No se pudo guardar el comentario. Inténtalo de nuevo.',
  'project.previewCommentReorderFailed': 'No se pudo guardar el orden de los comentarios y puede restablecerse al recargar.',
  'project.metaFreeform': 'estilo libre',
  'project.typePrototype': 'Prototipo',
  'project.typeDeck': 'Diapositivas',
  'project.typeTemplate': 'Plantilla',
  'project.typeImage': 'Imagen',
  'project.typeVideo': 'Vídeo',
  'project.typeAudio': 'Audio',
  'project.customInstructions': 'Instrucciones del proyecto',
  'project.customInstructionsPlaceholder': 'Instrucciones para este proyecto (se inyectan en cada mensaje)…',
  'project.resizeChatPanel': 'Redimensionar panel de chat',
  'project.instructionsActive': 'Activo: se incluye en cada mensaje',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comentarios',
  'chat.commentsSoon': 'Comentarios — próximamente',
  'chat.comments.attached': 'Adjunto al chat',
  'chat.comments.emptyAttached': 'No hay comentarios adjuntos.',
  'chat.comments.saved': 'Comentarios guardados',
  'chat.comments.emptySaved': 'No hay comentarios guardados.',
  'chat.comments.add': 'Añadir',
  'chat.comments.addAll': 'Añadir todo',
  'chat.comments.remove': 'Quitar',
  'chat.comments.placeholder': 'Comentar este elemento…',
  'chat.comments.addSend': 'Añadir y enviar',
  'chat.comments.updateSend': 'Actualizar y enviar',
  'chat.comments.removeAttachment': 'Quitar comentario adjunto',
  'chat.comments.removeAttachmentAria': 'Quitar comentario adjunto de {name}',
  'chat.comments.comment': 'Comentario',
  'chat.comments.sendToChat': 'Enviar al chat',
  'chat.comments.viewAll': 'Ver todos los comentarios',
  'chat.comments.sending': 'Enviando…',
  'chat.comments.edit': 'Editar',
  'chat.comments.select': 'Seleccionar',
  'chat.comments.selectAll': 'Seleccionar todo',
  'chat.comments.deselect': 'Deseleccionar',
  'chat.comments.nSelected': '{n} seleccionados',
  'chat.comments.pin': 'Fijar',
  'chat.comments.addNote': 'Añadir nota',
  'chat.comments.savedToast': 'Comentario guardado',
  'chat.comments.pinSavedToast': 'Fijación guardada',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} elementos capturados',
  'chat.comments.clear': 'Borrar',
  'chat.comments.targetImage': 'Imagen',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Enlace',
  'chat.comments.targetText': 'Texto',
  'chat.comments.targetSection': 'Sección',
  'chat.comments.targetPage': 'Página',
  'chat.comments.targetArea': 'Área',
  'chat.annotationNotePlaceholder': 'Añadir una nota para esta marca',
  'chat.annotationAttachImage': 'Adjuntar imagen',
  'chat.annotationAttachedImages': 'Imágenes adjuntas',
  'chat.annotationAttachedRemove': 'Quitar última imagen',
  'chat.annotationAddToInput': 'Añadir a la entrada',
  'chat.annotationAddingToInput': 'Añadiendo...',
  'chat.annotationQueue': 'Cola',
  'chat.annotationQueueing': 'Añadiendo a la cola...',
  'chat.annotationSubmitOptions': 'Opciones de envío',
  'chat.annotationSending': 'Enviando...',
  'chat.annotationSendDisabledReason': 'Hay una tarea en ejecución',
  'chat.annotationPreviewMissing': 'No se pudo capturar la vista previa. Inténtalo de nuevo.',
  'chat.annotationPreviewMissingInk': 'No se pudo capturar la vista previa. Inténtalo de nuevo para evitar enviar solo la anotación.',
  'chat.annotationSentWithoutScreenshot': 'No se pudo capturar la vista previa. La anotación se envió sin captura de pantalla.',
  'chat.annotationTimeout': 'Se agotó el tiempo de envío de la anotación. Inténtalo de nuevo.',
  'chat.annotationFailed': 'Error al enviar la anotación. Inténtalo de nuevo.',
  'chat.annotationProjectCreateFailed': 'No se pudo crear un proyecto, por lo que la anotación no se envió.',
  'chat.annotationUploadFailed': 'Error al subir el adjunto. Inténtalo de nuevo.',
  'chat.conversationsTitle': 'Conversaciones',
  'chat.conversationsAria': 'Historial de conversaciones',
  'chat.newConversation': 'Nueva conversación',
  'chat.newConversationsTitle': 'Nueva conversación',
  'chat.conversationsHeading': 'Conversaciones',
  'chat.new': 'Nueva',
  'chat.emptyConversations': 'Aún no hay conversaciones.',
  'chat.deleteConversation': 'Eliminar conversación',
  'chat.renameConversationLabel': 'Renombrar «{title}»',
  'chat.deleteConversationConfirm': '¿Eliminar «{title}»? Se borrarán sus mensajes.',
  'chat.untitledConversation': 'Conversación sin título',
  'chat.forkedConversationTitle': 'Bifurcación de {title}',
  'chat.forkConversationFailed': 'No se pudo bifurcar esta conversación.',
  'chat.startTitle': 'Empieza una conversación',
  'chat.startHint': 'Describe lo que quieres generar o empieza con uno de estos ejemplos:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Optimización con IA",
  'brandEnrichment.body': "Open Design ejecutará una extracción más profunda en segundo plano, aplicará automáticamente las skills de design system adecuadas y actualizará este sistema en el mismo lugar. Puede tardar entre 10 y 20 minutos; puedes seguir trabajando.",
  'brandEnrichment.cta': "Optimizar con IA",
  'brandEnrichment.busy': "Iniciando optimización con IA...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md pegado',
  'brandExtractionTranscript.user': 'Extrae un sistema de diseño de {source}.',
  'brandExtractionTranscript.doneTitle': 'La extracción programática de {name} ha terminado.',
  'brandExtractionTranscript.doneBody': 'He creado y registrado el sistema de diseño {designSystemId} desde {source}. Ya está listo para previsualizarse y usarse en nuevos diseños.',
  'brandExtractionTranscript.next': 'A continuación, puedes ejecutar AI Optimize para una extracción más profunda o crear un nuevo diseño con este sistema.',
  'chat.fillInputTitle': 'Haz clic para rellenar el campo',
  'chat.jumpToLatest': 'Ir al más reciente',
  'chat.scrollToLatest': 'Desplazar al más reciente',
  'chat.messageRail.aria': 'Navegación de mensajes del usuario',
  'chat.messageRail.jumpAria': 'Ir al mensaje de usuario {index}',
  'chat.messageRail.empty': '(Sin contenido)',
  'chat.you': 'Tú',
  'chat.openFile': 'Abrir {name}',
  'chat.copyPrompt': 'Copiar prompt',
  'chat.copyErrorDiagnostic': 'Copiar diagnóstico del error',
  'chat.copyDone': '¡Copiado!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Describe lo que quieres generar…',
  'chat.activeFileEditingLabel': 'Editando',
  'chat.activeFilePlaceholder': 'Pide a Open Design que cambie {file}...',
  'chat.designArtifactsShowMore': 'Mostrar {count} archivos de diseño más',
  'chat.mode.chat.label': 'Preguntar',
  'chat.mode.chat.title': 'Modo Ask',
  'chat.mode.chat.summary': 'Para respuestas rápidas, cambios, planificación y conversación sin asumir que hay que crear un artefacto de diseño.',
  'chat.mode.chat.solves': 'Úsalo para aclarar ideas, ajustar prompts, comparar opciones o preguntar sobre trabajo existente.',
  'chat.mode.chat.query1': 'Resume este borrador y señala los huecos.',
  'chat.mode.chat.query2': 'Ayúdame a decidir la mejor estructura para esta landing page.',
  'chat.mode.chat.query3': 'Revisa este diseño y sugiere mejoras concretas.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Diseño',
  'chat.mode.design.title': 'Modo Design',
  'chat.mode.design.summary': 'Para crear o cambiar resultados concretos: páginas, prototipos, artefactos en vivo, diapositivas, imágenes, vídeos, HyperFrames, audio, paneles y archivos de proyecto.',
  'chat.mode.design.solves': 'Úsalo cuando quieras que Open Design genere archivos, actualice el workspace o convierta un brief en entregables multimodales.',
  'chat.mode.design.query1': 'Crea una landing page de lanzamiento y un prototipo HyperFrames a partir de este brief.',
  'chat.mode.design.query2': 'Haz un deck para inversores de 10 diapositivas con notas de presentación.',
  'chat.mode.design.query3': 'Genera conceptos de imagen, vídeo y audio para esta campaña.',
  'chat.mode.cardBestFor': 'Ideal para',
  'chat.mode.cardTry': 'Prueba con',
  'chat.mode.cardCost': 'Consumo típico',
  'chat.mode.chat.cost': 'Bajo',
  'chat.mode.chat.costNote': 'Solo una conversación: no se genera nada, así que consume lo mínimo.',
  'chat.mode.plan.cost': 'Estándar',
  'chat.mode.plan.costNote': 'Crea primero un documento de plan editable antes de generar nada.',
  'chat.mode.design.cost': 'Alto',
  'chat.mode.design.costNote': 'Genera archivos y contenido multimodal, por lo que una ejecución puede consumir más.',
  'chat.modePicker.choose': 'Elegir un modo',
  'chat.modePicker.current': 'Modo: {name}',
  'chat.modePicker.clear': 'Quitar el modo',
  'chat.modePicker.mode': 'Modo',
  'chat.composerHint': '⌘/Ctrl + Enter para enviar · incluye objetivo, contenido, estilo y formato',
  'chat.cliSettingsTitle': 'Ajustes de CLI y modelo',
  'chat.cliSettingsAria': 'Abrir ajustes de CLI y modelo',
  'chat.attachTitle': 'Adjuntar archivos (o pegar / soltar)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Adjuntar archivos',
  'chat.importTitle': 'Importar fuentes (próximamente)',
  'chat.importLabel': 'Importar',
  'chat.importComingSoon': 'Próximamente',
  'chat.importSoon': 'Pronto',
  'chat.importFig': 'Subir archivo .fig',
  'chat.importGitHub': 'Conectar GitHub',
  'chat.importWeb': 'Capturar elemento web',
  'chat.importFolder': 'Vincular carpeta de código',
  'chat.importSkills': 'Skills y sistemas de diseño',
  'chat.importProject': 'Referenciar otro proyecto',
  'chat.importDesignSystemHeader': 'Elegir un sistema de diseño',
  'chat.importDesignSystemBack': 'Atrás',
  'chat.importDesignSystemSearch': 'Buscar sistemas de diseño…',
  'chat.importDesignSystemEmpty': 'Ningún sistema de diseño coincide con "{query}"',
  'chat.importDesignSystemNone': 'Ninguno — libre',
  'chat.importDesignSystemNoneSub': 'No anclar a un sistema esta vez',
  'chat.importDesignSystemActive': 'Activo',
  'chat.importDesignSystemSwitched': 'Sistema de diseño cambiado a {title}',
  'chat.importDesignSystemFailed': 'No se pudo cambiar el sistema de diseño. Vuelve a intentarlo.',
  'chat.importDesignSystemLoadFailed': 'No se pudieron cargar los sistemas de diseño.',
  'browserUse.title': 'Inspiración',
  'browserUse.summary': '{count} acciones web, priorizando la extracción de recursos, el lenguaje de diseño, el movimiento, las comprobaciones visuales y la estructura de componentes.',
  'browserUse.searchAria': 'Buscar inspiración',
  'browserUse.searchPlaceholder': 'Buscar capturas, fuentes, colores, a11y...',
  'browserUse.empty': 'No hay inspiración coincidente',
  'browserUse.unavailable': 'La inspiración no está disponible aquí',
  'browserUse.added': 'Añadido al compositor',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Detener carga',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Extracción de recursos',
  'browserUse.category.tokens': 'Lenguaje de diseño',
  'browserUse.category.motion': 'Movimiento',
  'browserUse.category.visual': 'Comprobaciones visuales',
  'browserUse.category.structure': 'Componentes',
  'browserUse.category.project': 'Ejecución del proyecto',
  'browserUse.category.general': 'General',
  'browserUse.input.none': 'Sin entrada',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selector opcional',
  'browserUse.input.requirementSelector': 'Requisito, selector opcional',
  'browserUse.input.selectorOptional': 'Selector opcional',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selector, scale=2',
  'browserUse.input.gridOverlay': '12 columnas, máx. 1200, espacio 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, dominio o términos de búsqueda',
  'browserUse.input.selector': 'Selector',
  'browserUse.input.selectorText': 'Selector y texto',
  'browserUse.input.scroll': 'Píxeles, arriba, abajo o página',
  'browserUse.input.terminalRun': 'Comando, tiempo de espera 120 s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Mejores candidatos de logotipo del encabezado, navegación, nombres de clase, posición, imagen OG y favicon como alternativa.',
  'browserUse.action.list_images.output': 'Todas las imágenes de img, srcset, source y fondos CSS con dimensiones y texto alternativo.',
  'browserUse.action.download_assets.output': 'Carpeta de recursos descargados más _manifest.json con compatibilidad de referer y cookies.',
  'browserUse.action.extract_svgs.output': 'SVG en línea y archivos .svg vinculados guardados como archivos SVG individuales.',
  'browserUse.action.optimize_svgs.output': 'Archivos SVG optimizados más ratio de compresión.',
  'browserUse.action.extract_colors.output': 'Paleta ponderada más variables de color CSS :root como palette.json y palette.html.',
  'browserUse.action.extract_fonts.output': 'Principales familias de fuentes, tamaños, grosores y reglas @font-face como typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radio, sombra, espaciado y variables CSS como tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Escala tipográfica de títulos, cuerpo y botones con tamaño, grosor, interlineado y proporciones.',
  'browserUse.action.extract_buttons.output': 'Biblioteca de estilos de botón deduplicada como buttons.html y buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Contenedores de cuadrícula y flex, dirección, espacios, columnas y anchos máximos como layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Puntos de ruptura de media queries adaptables como breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradientes CSS como gradients.css, gradients.json y HTML de vista previa.',
  'browserUse.action.extract_shadows.output': 'Sombras de caja, sombras de texto y sombras paralelas como shadows.json más vista previa.',
  'browserUse.action.extract_easings.output': 'Funciones de aceleración de transiciones y animaciones como easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js y style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, reglas de transición y transformación, bibliotecas de movimiento detectadas, motion.css y motion.json.',
  'browserUse.action.validate_view.output': 'Rutas de capturas más problemas visuales y de maquetación estructurados.',
  'browserUse.action.audit_layout.output': 'Defectos de maquetación, incluidos desbordamiento, límites, solapamiento y texto recortado como audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemas de a11y con selectores, etiquetas, roles, foco, contraste y capturas cuando sea útil.',
  'browserUse.action.responsive_screenshots.output': 'Capturas de móvil 390, tableta 834 y escritorio 1440.',
  'browserUse.action.screenshot_full.output': 'Captura de página completa más allá del viewport.',
  'browserUse.action.screenshot_element.output': 'Captura de un solo elemento a 2x de forma predeterminada.',
  'browserUse.action.screenshot_with_grid.output': 'Captura con superposición de cuadrícula de maquetación.',
  'browserUse.action.screenshot_dark_mode.output': 'Captura con prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guía de estilo de una página con colores, escala tipográfica, radio y sombras.',
  'browserUse.action.extract_html.output': 'HTML limpio y autónomo sin script, noscript ni atributos de evento en línea.',
  'browserUse.action.extract_component_inventory.output': 'Patrones de componentes repetidos, selectores, recuentos y capturas.',
  'browserUse.action.extract_copy.output': 'Títulos, CTA, texto del cuerpo y descripciones como copy.md y copy.json.',
  'browserUse.action.extract_nav.output': 'Navegación principal y enlaces del pie de página como sitemap.md y nav.json.',
  'browserUse.action.extract_forms.output': 'Campos de formulario, etiquetas, sugerencias de validación y acciones de envío como forms.json.',
  'browserUse.action.run_project.output': 'URL del servidor de desarrollo detectada abierta en la pestaña Browser.',
  'browserUse.action.detect_project.output': 'Framework, gestor de paquetes, comando de instalación, comando de desarrollo y puerto.',
  'browserUse.action.page_info.output': 'URL, título, descripción, imagen OG, color del tema, favicon y viewport.',
  'browserUse.action.snapshot.output': 'Hasta 120 elementos interactivos y de texto visibles con etiqueta, rótulo, href y coordenadas.',
  'browserUse.action.navigate.output': 'Abrir la página y devolver page_info.',
  'browserUse.action.click.output': 'Hacer clic en el primer elemento coincidente tras desplazarlo a la vista.',
  'browserUse.action.type_text.output': 'Rellenar un campo de entrada y emitir eventos input y change.',
  'browserUse.action.scroll.output': 'Posición de desplazamiento actual y máxima.',
  'browserUse.action.extract_og_metadata.output': 'Título meta, descripción, URL canónica, tarjetas OG/Twitter, imagen social y color del tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr y código de salida.',
  'browserUse.action.terminal_run_background.output': 'ID de la tarea en segundo plano y salida reciente.',
  'browserUse.action.terminal_read.output': 'Salida reciente del terminal compartido.',
  'chat.designToolbox.title': 'Caja de herramientas de diseño',
  'chat.designToolbox.tooltip': 'Caja de herramientas de diseño',
  'chat.designToolbox.aria': 'Abrir caja de herramientas de diseño',
  'chat.designToolbox.searchPlaceholder': 'Buscar skills / MCP / plugins / conectores / archivos de diseño...',
  'chat.designToolbox.searchAria': 'Buscar recursos de la caja de herramientas de diseño',
  'chat.designToolbox.followupSection': 'Seguimiento',
  'chat.designToolbox.resourcesSection': 'Recursos globales',
  'chat.designToolbox.selected': 'Seleccionado',
  'chat.designToolbox.noResources': 'No se han encontrado recursos para "{query}".',
  'chat.designToolbox.badge.video': 'Vídeo',
  'chat.designToolbox.badge.image': 'Imagen',
  'chat.designToolbox.badge.motion': 'Movimiento',
  'chat.designToolbox.badge.polish': 'Pulido',
  'chat.designToolbox.action.auto-match.title': 'Asociar siguiente paso',
  'chat.designToolbox.action.auto-match.badge': 'Asociar',
  'chat.designToolbox.action.auto-match.description': 'Define primero el listón de gusto y, a continuación, asocia skills, MCP, plugins, conectores y archivos.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Añadir animación / movimiento',
  'chat.designToolbox.action.motion.badge': 'Movimiento',
  'chat.designToolbox.action.motion.description': 'Añade movimiento de entrada, de desplazamiento, de transición de estado y de microinteracción al HTML o elemento de página actual.',
  'chat.designToolbox.action.motion-polish.title': 'Pulir movimiento',
  'chat.designToolbox.action.motion-polish.badge': 'Sincronización',
  'chat.designToolbox.action.motion-polish.description': 'Revisa la sincronización, la suavización, el rendimiento y las alternativas de movimiento reducido para el movimiento existente.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Eliminar aspecto de IA',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Gusto',
  'chat.designToolbox.action.anti-ai-polish.description': 'Elimina el aspecto de plantilla, los degradados de IA, los apilamientos de tarjetas baratos y los textos imprecisos.',
  'chat.designToolbox.action.visual-polish.title': 'Pulido de diseño / listo para publicar',
  'chat.designToolbox.action.visual-polish.badge': 'Pulido',
  'chat.designToolbox.action.visual-polish.description': 'Audita la jerarquía visual, la tipografía, el espaciado, el comportamiento adaptable, la accesibilidad y la calidad de entrega.',
  'chat.designToolbox.action.image-gen.title': 'Generar imágenes / referencias visuales',
  'chat.designToolbox.action.image-gen.badge': 'Imagen',
  'chat.designToolbox.action.image-gen.description': 'Genera referencias de sección, recursos, iconos, imágenes sociales o un moodboard para la página actual.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Generar vídeo / guion de movimiento',
  'chat.designToolbox.action.video-gen.badge': 'Vídeo',
  'chat.designToolbox.action.video-gen.description': 'Convierte el diseño en un vídeo corto, un storyboard de Remotion / Hyperframes o un prompt listo para generación.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Plantilla MCP',
  'chat.designToolbox.kind.connector': 'Conector',
  'chat.designToolbox.kind.designFile': 'Archivo de diseño',
  'chat.designToolbox.context.browser': 'Navegador',
  'chat.designToolbox.context.designFiles': 'Archivos de diseño',
  'chat.designToolbox.context.designSystem': 'Sistema de diseño',
  'chat.designToolbox.context.folder': 'Carpeta',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat lateral',
  'chat.designToolbox.context.liveArtifact': 'Artefacto en vivo',
  'chat.designToolbox.context.file': 'Archivo',
  'chat.designToolbox.prompt.contextGeneric': 'Objetivo actual: el archivo HTML / archivo de diseño / elemento web abierto en este momento.',
  'chat.designToolbox.prompt.contextSpecific': 'Objetivo actual: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Conserva la intención que ya está en el editor: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill seleccionada: {skill}. Úsala como flujo de trabajo principal en este turno.',
  'chat.designToolbox.prompt.noSkill': 'Si no coincide ninguna skill específica, elige primero la mejor combinación de skills, MCP, plugins, conectores y archivos de diseño disponibles.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Actúa como el orquestador Director Creativo y completa un flujo de trabajo de diseño:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Define primero qué significa un “diseño atractivo”: audiencia, objetivo de negocio, identidad de marca, referencias de estilo, densidad de información, estándares de color/tipografía/movimiento/recursos y patrones de IA/plantillas que evitar.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Busca y haz coincidir el índice completo de recursos anterior. No uses solo las recomendaciones de la caja de herramientas de diseño; combina skills, MCP, plugins, conectores y archivos de diseño cuando resulte útil.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Completa el flujo en este orden: diagnóstico -> dirección de estilo -> selección de recursos -> edición/generación concreta -> verificación. En cada paso, explica por qué se eligieron estos recursos y qué hay que confirmar a continuación.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Revisa y pule el ritmo, la suavización, el rendimiento y la accesibilidad del movimiento existente. Elimina animaciones bruscas, baratas o que perjudiquen la legibilidad; usa una línea de tiempo más refinada cuando sea necesario.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Haz una pasada de pulido anti-aspecto-IA: elimina diseños de plantilla, degradados/brillos baratos, pilas de tarjetas sin sentido y textos vagos. Conserva la información y haz que parezca entregado por un diseñador real.',
  'chat.designToolbox.prompt.visualPolish': 'Pule este diseño hasta dejarlo listo para publicar: revisa jerarquía, tipografía, espaciado, comportamiento responsive, estados de los botones, estados vacío/de carga/de error y accesibilidad; corrige directamente los problemas más importantes.',
  'chat.designToolbox.prompt.imageGen': 'Crea el siguiente plan de recursos visuales para este diseño: referencias de sección, recursos hero, ilustraciones, iconos, imágenes para redes sociales o un moodboard. Decide primero qué tipo de imagen falta y luego proporciona prompts de generación ejecutables / un plan de archivos.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Orienta este diseño hacia el vídeo: crea un guion gráfico de vídeo corto, una estructura de frames de Hyperframes / Remotion o un prompt listo para Sora/fal. Prioriza que el contenido HTML / de página existente se convierta de forma natural en planos.',
  'chat.designToolbox.prompt.useSkill': 'Usa {skill} en el diseño actual.',
  'chat.designToolbox.prompt.skillInstruction': 'Decide primero el mejor objetivo de seguimiento y luego completa una pasada concreta. Si depende de recursos o API externas, proporciona una alternativa ejecutable o indica qué necesito aportar.',
  'chat.designToolbox.prompt.selectedResource': 'Recurso seleccionado: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descripción del recurso: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Usa este plugin como contexto principal del flujo de diseño actual. Si expone entradas o GenUI, guíame para elegir cuando sea necesario; si no encaja con el objetivo, elige un recurso global mejor y explica por qué.',
  'chat.designToolbox.prompt.mcpResource': 'Prioriza esta capacidad de MCP para el siguiente paso de diseño. Cuando se necesiten recursos externos, captura web, generación de imagen/vídeo o datos, decide primero si puede hacer el trabajo y luego ofrece un plan ejecutable.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Este MCP es una plantilla configurable. Si es la herramienta más útil para este paso de diseño, guía primero la configuración; si existe una alternativa ya configurada, continúa con esa alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Usa este conector cuando se necesiten datos reales, recursos, contenido de cuenta o acceso a flujos de trabajo externos. Antes de usarlo, explica qué se leerá o escribirá y pide confirmación cuando proceda.',
  'chat.designToolbox.prompt.fileResource': 'Usa este archivo de diseño como objetivo de diseño actual o recurso de referencia y completa el siguiente paso a partir de él. Si hay que comparar otros archivos, sigue buscando en todos los archivos de diseño.',
  'chat.designToolbox.prompt.resourceIndex': 'Índice global de recursos: skills({skills}), plugins({plugins}), MCP({mcpEnabled} activados / {mcpTemplates} plantillas), conectores({connectors} conectados), archivos de diseño({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skills disponibles para búsqueda',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugins disponibles para búsqueda',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponibles',
  'chat.designToolbox.prompt.connectedConnectors': 'Conectores conectados',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Archivos de diseño de referencia',
  'chat.designToolbox.prompt.mcpTemplateName': 'Plantilla de {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} más',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superficies de menciones',
  'chat.mentionTabAll': 'Todos',
  'chat.mentionTabTabs': 'Pestañas',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Conectores',
  'chat.mentionTabFiles': 'Archivos de diseño',
  'chat.mentionNoResults': 'No hay resultados para “{query}”.',
  'chat.mentionSearchPrompt': 'Busca archivos de diseño, pestañas, plugins, skills, servidores MCP y conectores.',
  'chat.mentionSectionTabs': 'Pestañas',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Conectores',
  'chat.mentionSectionFiles': 'Archivos de diseño',
  'chat.mentionActiveSkill': 'Activo',
  'chat.mentionUseMcpTitle': 'Usar {name}',
  'chat.mentionUseConnectorTitle': 'Usar {name}',
  'chat.mentionPluginOfficial': 'Oficial',
  'chat.mentionPluginMine': 'Mi plugin',
  'chat.linkedFolderRemoveAria': 'Eliminar carpeta vinculada {path}',
  'chat.linkedFolderNotFound': 'La carpeta no existe',
  'chat.linkedFolderAlready': 'Esta carpeta ya está vinculada',
  'chat.linkedFolderPickError': 'No se pudo abrir el selector de carpetas',
  'chat.queuedHeader': 'En cola',
  'chat.queuedToSend': 'para enviar',
  'chat.queuedEditQueuedTaskAria': 'Editar tarea en cola',
  'chat.queuedSave': 'Guardar',
  'chat.queuedCancel': 'Cancelar',
  'chat.queuedReorder': 'Arrastra para reordenar',
  'chat.queuedEdit': 'Editar',
  'chat.queuedMore': 'más en cola',
  'chat.queuedFollowUpFallback': 'Seguimiento en cola',
  'chat.send': 'Enviar',
  'chat.stop': 'Detener',
  'chat.removeAria': 'Quitar {name}',
  'chat.example1Title': 'Pitch deck editorial',
  'chat.example1Tag': 'Revista',
  'chat.example1Prompt': 'Una presentación editorial de 10 diapositivas para un estudio de diseño que levanta una ronda seed: maquetación con grid suizo, titulares serif enormes con capitulares marcadas, números de sección en monoespaciada, abundante espacio en blanco y diapositivas a sangre con foto intercaladas con otras densas en texto. Portada, visión, mercado, producto, tracción, equipo, petición y contacto.',
  'chat.example2Title': 'Dashboard de analítica SaaS',
  'chat.example2Tag': 'Datos',
  'chat.example2Prompt': 'Un dashboard denso de analítica para un SaaS de herramientas para desarrolladores: tira de KPIs con variaciones semana a semana, dos gráficos de líneas apilados (MRR y workspaces activos), un mapa de calor mundial de uso, una rejilla de retención por cohortes, un ranking de clientes principales y un feed de eventos en tiempo real. Tema oscuro, números monoespaciados tabulares, acentos con sparklines.',
  'chat.example3Title': 'Memoria anual long-scroll',
  'chat.example3Tag': 'Editorial',
  'chat.example3Prompt': 'Una memoria anual interactiva para una ONG climática: maquetación editorial long-scroll mezclando grandes bloques de citas, visualizaciones de datos (barras apiladas, contadores animados, un mapa coroplético de proyectos), separadores con fotografía, muro de donantes y llamada a la acción final. Cuerpo en serif moderna, etiquetas de gráficos en sans-serif, paleta terrosa de papel.',
  'home.recommendation.eyebrow': 'Recomendado para ti',
  'home.recommendation.primaryCta': 'Empezar a crear',
  'home.recommendation.change': 'Probar otro',
  'home.recommendation.browseAll': 'Todos los tipos',
  'home.recommendation.defaultProjectName': 'Nuevo proyecto',
  'home.recommendation.startFailed': 'No se pudo empezar a crear. Inténtalo de nuevo.',
  'studio.firstArtifactHint.title': 'Tu primer diseño está listo',
  'studio.firstArtifactHint.body': 'Prueba a editarlo y anotarlo directamente; exporta o comparte cuando estés satisfecho.',
  'studio.firstArtifactHint.dismiss': 'Entendido',
  'home.starter.product_ui_prototype.title': 'Empieza con un prototipo de producto editable',
  'home.starter.product_ui_prototype.desc': 'Según tu objetivo, empieza con una interfaz interactiva que puedes refinar.',
  'home.starter.product_ui_prototype.firstPrompt': 'Diseña un prototipo de producto editable para [tu producto] con las pantallas clave y un flujo principal claro.',
  'home.starter.product_ui_component.title': 'Empieza a partir de un componente reutilizable',
  'home.starter.product_ui_component.desc': 'Crea primero un componente y luego compónlo en pantallas completas.',
  'home.starter.product_ui_component.firstPrompt': 'Diseña un componente [nombre del componente] reutilizable con sus estados y variantes principales.',
  'home.starter.product_ui_lowfi.title': 'Empieza con un prototipo de baja fidelidad',
  'home.starter.product_ui_lowfi.desc': 'Esboza primero la estructura y luego aumenta la fidelidad.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Crea un wireframe de baja fidelidad de las pantallas principales para [tu producto].',
  'home.starter.marketing_landing.title': 'Empieza con una página de aterrizaje',
  'home.starter.marketing_landing.desc': 'Convierte tu campaña en una página de aterrizaje lista para lanzar.',
  'home.starter.marketing_landing.firstPrompt': 'Diseña una página de aterrizaje para [tu producto] con un hero, beneficios clave y una llamada a la acción clara.',
  'home.starter.marketing_multivariant.title': 'Empieza con varias variantes de página de aterrizaje',
  'home.starter.marketing_multivariant.desc': 'Genera varias versiones para comparar antes de decidir.',
  'home.starter.marketing_multivariant.firstPrompt': 'Crea 3 variantes de página de aterrizaje para [tu producto] con distintos mensajes de hero para comparar.',
  'home.starter.internal_dashboard.title': 'Empieza con un panel interno',
  'home.starter.internal_dashboard.desc': 'Parte de un diseño de panel para tu flujo de trabajo.',
  'home.starter.internal_dashboard.firstPrompt': 'Diseña un panel interno que muestre [métricas clave] con filtros y una tabla de datos.',
  'home.starter.internal_report.title': 'Empieza con un informe',
  'home.starter.internal_report.desc': 'Describe los datos y campos que quieres ver.',
  'home.starter.internal_report.firstPrompt': 'Crea una página de informe que resuma [describe los datos, campos y métricas que te interesan].',
  'home.starter.general_menu.title': 'Empieza con tu primer proyecto',
  'home.starter.general_menu.desc': 'Describe lo que quieres y generaremos una primera versión editable.',
  'home.starter.general_menu.firstPrompt': 'Crea una primera versión editable de [describe lo que quieres crear].',
  'chat.example4Title': 'Video motion de producto',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Crea un storyboard de video motion de 15 segundos para el lanzamiento de una app de productividad: gancho inicial, primeros planos de UI, tipografía cinética, transiciones de funciones, cierre con logo y CTA. Incluye tiempos, escenas, cámara y textos sobreimpresos.',
  'preview.usePlugin': 'Usar plugin',
  'preview.usePluginOnly': 'Usar sin prompt',
  'preview.usePluginOnlyDesc': 'Usa la estructura del plugin sin cargar el prompt de ejemplo',
  'preview.replicateContent': 'Usar',
  'preview.replicateContentDesc': 'Usa el prompt de ejemplo para recrear la vista previa',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remezcla este ejemplo en un nuevo proyecto editable',
  'preview.shareMenu': 'Compartir',
  'preview.exportMenu': 'Exportar',
  'preview.shareTemplateBadge': 'Plantilla',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copiar enlace de la plantilla',
  'preview.copyShareText': 'Copiar texto para compartir',
  'preview.shareSocialGroup': 'Compartir en redes sociales',
  'preview.shareCopyGroup': 'Copiar',
  'preview.shareExportGroup': 'Exportar archivos',
  'preview.shareCopied': 'Copiado',
  'preview.shareCopyFailed': 'Error al copiar',
  'preview.shareTextDefault': 'Plantilla de Open Design: {title}',
  'preview.openInNewTab': 'Abrir en pestaña nueva',
  'preview.exit': '⤓ Salir',
  'preview.fullscreen': '⤢ Pantalla completa',
  'preview.closeTitle': 'Cerrar (Esc)',
  'preview.loading': 'Cargando {label}…',
  'preview.errorTitle': 'No se pudo cargar este ejemplo.',
  'preview.errorBody': 'No se pudo obtener el HTML del ejemplo. Asegúrate de que Open Design esté en ejecución e inténtalo de nuevo.',
  'preview.retry': 'Reintentar',
  'preview.unavailableTitle': 'No hay vista previa incluida para {noun}.',
  'preview.unavailableBody': 'Ejecuta el prompt en el chat para generar un resultado {kind}.',
  'preview.nounSkill': 'esta skill',
  'preview.nounPlugin': 'este plugin',
  'preview.nounTemplate': 'esta plantilla',
  'preview.showSidebar': 'Mostrar {label}',
  'preview.hideSidebar': 'Ocultar {label}',
  'misc.savedTemplate': 'Plantilla guardada',
  'misc.primary': 'Principal',
  'misc.designSystem': 'Sistema de diseño',
  'workspace.designFiles': 'Archivos de diseño',
  'workspace.focusMode': 'Enfocar el espacio de trabajo',
  'workspace.showChat': 'Mostrar chat',
  'workspace.closeTab': 'Cerrar pestaña',
  'workspace.fileSyncDownloading': 'Descargando del equipo…',
  'workspace.fileSyncUploading': 'Sincronizando con el equipo…',
  'workspace.deleteFileConfirm': '¿Eliminar «{name}» de la carpeta del proyecto?',
  'workspace.readonlyNotice': 'Este es un proyecto compartido: puedes verlo y comentarlo, pero no modificar los artefactos mediante Chat o las herramientas de edición.',
  'workspace.readonlyNoticeBy': 'Este es un proyecto compartido creado por {owner}: puedes verlo y comentarlo, pero no modificar los artefactos mediante Chat o las herramientas de edición.',
  'workspace.deleteSelectedFilesConfirm': '¿Eliminar {n} archivo(s) seleccionado(s) de la carpeta del proyecto?',
  'workspace.deleteSelectedFilesPartial': 'No se pudieron eliminar {n} archivo(s).',
  'workspace.openFromDesignFiles': 'Abre un archivo desde',
  'workspace.designFilesLink': 'Archivos de diseño',
  'workspace.loadingSketch': 'Cargando boceto…',
  'workspace.newTab': 'Nueva pestaña',
  'workspace.searchFilesPlaceholder': 'Buscar archivos…',
  'workspace.openTabs': 'Abrir pestañas',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Abrir un archivo',
  'workspace.noFilesMatch': 'No hay archivos coincidentes',
  'workspace.allFiles': 'Todos',
  'workspace.createNew': 'Crear nuevo',
  'workspace.tabOpen': 'Abierto',
  'workspace.sideChatContextBanner': 'Contexto de la conversación actual integrado',
  'workspace.sideChatDefaultTitle': 'Chat lateral',
  'workspace.newTerminal': 'Nueva terminal',
  'workspace.newTerminalDescription': 'Abrir un shell en el directorio del proyecto en una pestaña nueva',
  'workspace.newBrowser': 'Nuevo navegador',
  'workspace.newBrowserDescription': 'Abrir una pestaña de navegador integrada para sitios de referencia y tareas',
  'workspace.newSketchDescription': 'Boceta diseños rápidos y notas para que el agente los use como contexto',
  'workspace.terminalStarting': 'Iniciando terminal…',
  'workspace.terminalStartingDescription': 'Preparando el shell del proyecto. Normalmente tarda unos segundos.',
  'workspace.terminalSessionEnded': 'Sesión finalizada',
  'workspace.terminalReconnecting': 'Reconectando…',
  'workspace.terminalStartFailed': 'No se pudo iniciar la sesión de terminal',
  'workspace.terminalRestart': 'Reiniciar',
  'designFiles.title': 'Archivos de diseño',
  'designFiles.upload': 'Subir archivos',
  'designFiles.pasteText': 'Pegar como archivo de texto',
  'designFiles.newSketch': 'Nuevo boceto',
  'designFiles.newDocument': 'Nuevo documento',
  'designFiles.newDocumentTitle': 'Crear un documento Markdown nuevo',
  'designFiles.empty': 'Las creaciones aparecerán aquí',
  'designFiles.syncing': 'Sincronizando los archivos compartidos del equipo…',
  'designFiles.refresh': 'Actualizar',
  'designFiles.delete': 'Eliminar',
  'designFiles.searchPlaceholder': 'Buscar archivos…',
  'designFiles.up': 'Subir',
  'designFiles.back': 'Atrás',
  'designFiles.crumbs': 'proyecto',
  'designFiles.rowMenu': 'Menú de la fila',
  'designFiles.openInTab': 'Abrir en pestaña',
  'designFiles.download': 'Descargar',
  'designFiles.downloadSelected': 'Descargar {n} como ZIP',
  'designFiles.deleteSelected': 'Eliminar {n}',
  'designFiles.clearSelection': 'Limpiar selección',
  'designFiles.selectPage': 'Seleccionar todo en la página',
  'designFiles.selectAll': 'Seleccionar todo',
  'designFiles.dropTitle': '⤓ Suelta archivos aquí',
  'designFiles.dropDesc': 'Imágenes, documentos, referencias o carpetas: el agente los usará como contexto.',
  'designFiles.dropLabel': 'Suelta los archivos aquí',
  'designFiles.upload.title': 'Subir archivos',
  'designFiles.paste.title': "Pegar texto como archivo",
  'designFiles.upload.label': 'Subir',
  'designFiles.paste.label': "Pegar",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Abrir',
  'designFiles.previewClose': 'Cerrar vista previa',
  'designFiles.modified': 'Modificado {time} · {size}',
  'designFiles.weeksAgo': 'hace {n} sem',
  'designFiles.groupBy': 'Agrupar por',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modificado',
  'designFiles.filterBy': 'Filtrar por tipo',
  'designFiles.filterClear': 'Borrar',
  'designFiles.filterCount': '{n} tipos',
  'designFiles.expandGroup': 'Expandir',
  'designFiles.collapseGroup': 'Contraer',
  'designFiles.sectionPages': 'Páginas',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Imágenes',
  'designFiles.sectionSketches': 'Bocetos',
  'designFiles.sectionLiveArtifacts': 'Artefactos en vivo',
  'designFiles.sectionOther': 'Otros',
  'designFiles.modifiedToday': 'Hoy',
  'designFiles.modifiedYesterday': 'Ayer',
  'designFiles.modifiedPrevious7Days': 'Últimos 7 días',
  'designFiles.modifiedPrevious30Days': 'Últimos 30 días',
  'designFiles.modifiedOlder': 'Anterior',
  'designFiles.showMore': 'Mostrar +{n} más',
  'designFiles.kindHtml': 'Página HTML',
  'designFiles.kindImage': 'Imagen',
  'designFiles.kindSketch': 'Boceto',
  'designFiles.kindText': 'Texto',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Presentación',
  'designFiles.kindSpreadsheet': 'Hoja de cálculo',
  'designFiles.kindLiveArtifact': 'Artefacto en vivo',
  'designFiles.kindBinary': 'Binario',
  'designFiles.kindFolder': 'Carpeta',
  'designFiles.folderCount': '{n} archivos',
  'designFiles.newFolderTitle': 'Nueva carpeta',
  'designFiles.newFolderLabel': 'Nombre de la carpeta',
  'designFiles.moveTitle': 'Mover a la carpeta',
  'designFiles.moveLabel': 'Carpeta de destino',
  'designFiles.moveRoot': 'Raíz del proyecto',
  'designFiles.moveNewFolder': 'Nueva carpeta…',
  'designFiles.move': 'Mover',
  'designFiles.copyPath': 'Copiar ruta',
  'designFiles.copiedPath': 'Ruta copiada',
  'designFiles.copyLocalPath': 'Copiar ruta del archivo local',
  'designFiles.copiedLocalPath': 'Ruta del archivo local copiada',
  'designFiles.deleteFolderConfirm': '¿Eliminar la carpeta "{name}" y todo su contenido?',
  'designFiles.folderCreated': 'Carpeta "{name}" creada',
  'designFiles.folderDeleted': 'Carpeta "{name}" eliminada',
  'designFiles.filesMoved': '{n} movido(s) a {dest}',
  'designFiles.colName': 'Nombre',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificado',
  'designFiles.perPage': 'Mostrar',
  'designFiles.all': 'Todos',
  'designFiles.prev': 'Anterior',
  'designFiles.next': 'Siguiente',
  'designFiles.jumpToPage': 'Ir a la página',
  'designFiles.pageInfo': '{start}–{end} de {total}',
  'designFiles.sectionFolders': 'Carpetas',
  'designFiles.sectionStylesheets': 'Hojas de estilos',
  'designFiles.sectionDocuments': 'Documentos',
  'designFiles.kindStylesheet': 'Hoja de estilos',
  'designFiles.modifiedExt': 'Modificado {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Información útil',
  'designFiles.usefulInfoTip': 'Haz doble clic en cualquier archivo para abrirlo en una pestaña completa.',
  'designFiles.usefulInfoTip2': 'Escribe @ en el chat para referenciar un archivo como contexto.',
  'designFiles.usefulInfoTip4': 'Elige un sistema de diseño para que el resultado siga tu marca.',
  'designFiles.usefulInfoTip5': '¿Sin ideas? Prueba una plantilla de plugin en Comunidad, en la página de inicio.',
  'designFiles.usefulInfoTip6': '¿Dudas o sugerencias? Únete a nuestro Discord.',
  'designFiles.usefulInfoTip7': '¿Te gusta Open Design? Danos una estrella en GitHub.',
  'designFiles.usefulInfoTip8': 'Sigue a @OpenDesignHQ en X para conocer las novedades.',
  'designFiles.usefulInfoTip9': 'Arrastra imágenes, documentos o carpetas enteras a este panel: el agente los usará como contexto.',
  'designFiles.usefulInfoTip10': 'Haz clic en «Nuevo boceto», dibuja un layout y deja que el agente lo genere.',
  'designFiles.usefulInfoTip11': 'Selecciona cualquier elemento en la vista previa para comentarlo: el agente hará cambios concretos.',
  'designFiles.usefulInfoTip12': '¿No te convence el resultado? Marcarlo es más rápido que volver a describirlo.',
  'designFiles.usefulInfoTip13': 'Exporta cualquier diseño como PDF, imagen o HTML independiente con un clic.',
  'designFiles.usefulInfoTip14': '¿Contento con un proyecto? Guárdalo como plantilla desde el menú Compartir.',
  'designFiles.usefulInfoTip15': 'Tras desplegar, genera tarjetas para redes sociales al instante.',
  'designFiles.usefulInfoTip16': 'Sigue a @opendesign.ai en Threads para novedades entre bastidores.',
  'designFiles.usefulInfoTip17': 'Sigue a @opendesign.ai en Instagram para inspirarte con diseño.',
  'designFiles.usefulInfoTip18': 'Suscríbete a Open Design en YouTube para tutoriales y demos.',
  'designFiles.usefulInfoTip19': 'Sigue a Open Design en LinkedIn para novedades del producto.',
  'designFiles.usefulInfoTip20': 'Sigue a Open Design en Xiaohongshu para consejos e inspiración.',
  'quickSwitcher.placeholder': 'Abrir archivo…',
  'quickSwitcher.empty': 'No hay archivos en este proyecto',
  'quickSwitcher.noMatches': 'Sin resultados',
  'quickSwitcher.navigate': 'navegar',
  'quickSwitcher.open': 'abrir',
  'quickSwitcher.close': 'cerrar',
  'pasteDialog.title': 'Pegar texto',
  'pasteDialog.hint': 'Se guarda en la carpeta del proyecto. Elige cualquier nombre.',
  'pasteDialog.fileNameLabel': 'Nombre del archivo',
  'pasteDialog.namePlaceholder': 'notas.txt',
  'pasteDialog.contentLabel': 'Contenido',
  'pasteDialog.contentPlaceholder': 'Pega lo que quieras…',
  'pasteDialog.save': 'Guardar',
  'pasteDialog.cancel': 'Cancelar',
  'sketch.save': 'Guardar boceto',
  'sketch.cancel': 'Cancelar',
  'sketch.saving': 'Guardando…',
  'sketch.saved': 'Guardado',
  'sketch.tooltipMainMenu': 'Menú principal: guardar, exportar, ayuda y ajustes del lienzo',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Cambios sin guardar',
  'sketch.tooltipClean': 'Guardado',
  'fileViewer.empty': 'Selecciona un archivo para verlo.',
  'fileViewer.loading': 'Cargando…',
  'fileViewer.exportPptx': 'Exportar como PPTX',
  'fileViewer.openInNewTab': 'Abrir en pestaña nueva',
  'fileViewer.copyPath': 'Copiar ruta',
  'fileViewer.copied': '¡Copiado!',
  'fileViewer.share': 'Compartir',
  'fileViewer.binaryMeta': 'Binario · {size}',
  'fileViewer.binaryNote': 'Archivo binario ({size} bytes). Descárgalo o ábrelo desde el disco para inspeccionarlo.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Presentación',
  'fileViewer.spreadsheetMeta': 'Hoja de cálculo',
  'fileViewer.previewUnavailable': 'Vista previa no disponible. Descarga o abre el archivo para inspeccionarlo.',
  'fileViewer.download': 'Descargar',
  'fileViewer.open': 'Abrir',
  'fileViewer.imageMeta': 'Imagen · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Boceto · {size}',
  'fileViewer.markdownStreamingMeta': 'Vista previa en streaming…',
  'fileViewer.markdownErrorMeta': 'La vista previa puede estar incompleta (error de generación).',
  'fileViewer.markdownStreamingStatus': 'Streaming… mostrando markdown parcial.',
  'fileViewer.markdownErrorStatus': 'Error de generación. Mostrando el último contenido disponible.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Vídeo · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Recargar',
  'fileViewer.reloadDisk': 'Recargar desde el disco',
  'fileViewer.copy': 'Copiar',
  'fileViewer.copyTitle': 'Copiar el contenido del archivo',
  'fileViewer.saveDisabled': 'Guardar (visor de solo lectura)',
  'fileViewer.save': 'Guardar',
  'fileViewer.preview': 'Vista previa',
  'fileViewer.source': 'Código fuente',
  'fileViewer.tweaks': 'Ajustes',
  'fileViewer.tweaksUnavailable': 'Sin panel de ajustes en este artefacto',
  'fileViewer.jsxModuleTitle': 'Sin vista previa independiente',
  'fileViewer.jsxModuleBody': 'Este archivo es un módulo de componente cargado por otra página.',
  'fileViewer.jsxModuleCta': 'Abre la página que lo renderiza:',
  'fileViewer.comment': 'Comentar',
  'fileViewer.edit': 'Editar',
  'fileViewer.draw': 'Dibujar',
  'fileViewer.mark': 'Marcar',
  'fileViewer.markTool': 'Herramienta de marcado',
  'fileViewer.boxSelect': 'Seleccionar área',
  'fileViewer.textTool': 'Texto',
  'fileViewer.textAnnotationRemove': 'Eliminar texto',
  'fileViewer.screenshot': 'Captura',
  'fileViewer.versions.entry': 'Versiones',
  'fileViewer.versions.entryFull': 'Historial de versiones',
  'fileViewer.versions.title': 'Versiones',
  'fileViewer.versions.countOne': '1 versión',
  'fileViewer.versions.countMany': '{count} versiones',
  'fileViewer.versions.current': 'Actual',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Versión {version}',
  'fileViewer.versions.listAria': 'Versiones del archivo',
  'fileViewer.versions.loading': 'Cargando versiones...',
  'fileViewer.versions.empty': 'Todavía no hay versiones.',
  'fileViewer.versions.loadFailed': 'No se pudieron cargar las versiones.',
  'fileViewer.versions.previewFailed': 'No se pudo cargar la vista previa de esta versión.',
  'fileViewer.versions.previewLoading': 'Cargando vista previa de la versión...',
  'fileViewer.versions.noPrompt': 'No hay prompt guardado',
  'fileViewer.versions.noPromptBody': 'No se guardó ningún prompt para esta versión.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Copiar prompt',
  'fileViewer.versions.fullscreen': 'Vista previa a pantalla completa',
  'fileViewer.versions.open': 'Abrir vista previa',
  'fileViewer.versions.currentHelp': 'Esta ya es la versión actual.',
  'fileViewer.versions.restoreHelp': 'Al cambiar, este HTML se restaura como una nueva versión actual.',
  'fileViewer.versions.restore': 'Cambiar a esta versión',
  'fileViewer.versions.restoreConfirmTitle': '¿Cambiar a esta versión?',
  'fileViewer.versions.restoreConfirmCta': 'Cambiar',
  'fileViewer.versions.restoring': 'Cambiando...',
  'fileViewer.versions.restoreFailed': 'No se pudo cambiar a esta versión.',
  'fileViewer.versions.restoreSuccess': 'Se cambió a esta versión.',
  'fileViewer.editScreenshotToChat': 'Captura al chat',
  'manualEdit.layers': 'Capas',
  'manualEdit.editableCount': '{count} editables',
  'manualEdit.hiddenBadge': 'Oculto',
  'manualEdit.title': 'Editor manual',
  'manualEdit.fallbackTitle': 'Editar',
  'manualEdit.movePanel': 'Mover el panel de edición',
  'manualEdit.editParams': 'Editar parámetros',
  'manualEdit.closePanel': 'Cerrar el panel de edición',
  'manualEdit.selectLayer': 'Selecciona una capa',
  'manualEdit.empty': 'Haz clic en un elemento de la vista previa o elige una capa.',
  'manualEdit.noEditableLayers': 'No se encontraron capas editables.',
  'manualEdit.noClass': 'sin clase',
  'manualEdit.tabsAria': 'Pestañas de edición manual',
  'manualEdit.tabContent': 'Contenido',
  'manualEdit.tabStyle': 'Estilo',
  'manualEdit.tabAttributes': 'Atributos',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Código fuente',
  'manualEdit.attributesJson': 'JSON de atributos',
  'manualEdit.selectedHtml': 'HTML del elemento seleccionado',
  'manualEdit.fullSource': 'Código fuente completo del artefacto',
  'manualEdit.applyContent': 'Aplicar contenido',
  'manualEdit.applyStyle': 'Aplicar estilo',
  'manualEdit.applyAttributes': 'Aplicar atributos',
  'manualEdit.applyHtml': 'Aplicar HTML',
  'manualEdit.applySource': 'Aplicar código fuente',
  'manualEdit.invalidAttributes': 'JSON de atributos no válido.',
  'manualEdit.changes': 'Cambios',
  'manualEdit.undo': 'Deshacer',
  'manualEdit.redo': 'Rehacer',
  'manualEdit.noChanges': 'Aún no hay ediciones manuales.',
  'manualEdit.imageUrl': 'URL de la imagen',
  'manualEdit.altText': 'Texto alternativo',
  'manualEdit.label': 'Etiqueta',
  'manualEdit.text': 'Texto',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Color del texto',
  'manualEdit.background': 'Fondo',
  'manualEdit.fontSize': 'Tamaño de fuente',
  'manualEdit.weight': 'Grosor',
  'manualEdit.align': 'Alineación',
  'manualEdit.textAlignLeft': 'Alinear a la izquierda',
  'manualEdit.textAlignCenter': 'Centrar',
  'manualEdit.textAlignRight': 'Alinear a la derecha',
  'manualEdit.padding': 'Relleno',
  'manualEdit.margin': 'Margen',
  'manualEdit.radius': 'Radio',
  'manualEdit.referenceValues': 'Valores de referencia',
  'manualEdit.referenceValuesEmpty': 'No hay valores de referencia coincidentes',
  'manualEdit.referenceValuesLoading': 'Cargando…',
  'manualEdit.lineHeight': 'Altura de línea',
  'manualEdit.letterSpacing': 'Espaciado entre letras',
  'manualEdit.borderStyle': 'Estilo de borde',
  'manualEdit.borderStyleSolid': 'Sólido',
  'manualEdit.borderStyleDashed': 'Discontinuo',
  'manualEdit.borderStyleDotted': 'Punteado',
  'manualEdit.borderStyleDouble': 'Doble',
  'manualEdit.borderStyleNone': 'Ninguno',
  'manualEdit.border': 'Borde',
  'manualEdit.width': 'Ancho',
  'manualEdit.minHeight': 'Altura mínima',
  'manualEdit.deleteElement': 'Eliminar elemento',
  'manualEdit.deleteElementConfirm': '¿Eliminar el elemento seleccionado? Esta acción se puede revertir con Deshacer.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Subir imagen',
  'manualEdit.uploadingImage': 'Subiendo imagen…',
  'manualEdit.uploadImageFailed': 'No se pudo subir la imagen.',
  'manualEdit.focusSlides': 'Enfocar diapositivas',
  'manualEdit.showPanels': 'Mostrar paneles',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Reducir zoom',
  'fileViewer.zoomIn': 'Aumentar zoom',
  'fileViewer.resetZoom': 'Restablecer zoom',
  'fileViewer.viewportAria': 'Vista previa del viewport',
  'fileViewer.viewportDesktop': 'Escritorio',
  'fileViewer.viewportDesktopTitle': 'Vista previa de escritorio a ancho completo',
  'fileViewer.viewportTablet': 'Tableta',
  'fileViewer.viewportTabletTitle': 'Vista previa de tableta a 820 × 1180 (base vertical moderna)',
  'fileViewer.viewportMobile': 'Móvil',
  'fileViewer.viewportMobileTitle': 'Vista previa de móvil a 390 × 844',
  'fileViewer.reloadAria': 'Recargar',
  'fileViewer.previousSlide': 'Diapositiva anterior',
  'fileViewer.nextSlide': 'Diapositiva siguiente',
  'fileViewer.slideNavAria': 'Navegación de diapositivas',
  'fileViewer.speakerNotes': 'Notas del orador',
  'fileViewer.speakerNotesSlide': 'Diapositiva {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'No hay notas del orador para esta diapositiva.',
  'fileViewer.speakerNotesEdit': 'Editar',
  'fileViewer.speakerNotesSave': 'Guardar notas',
  'fileViewer.speakerNotesSaving': 'Guardando…',
  'fileViewer.speakerNotesSaved': 'Guardado',
  'fileViewer.speakerNotesSaveFailed': 'No se pudieron guardar las notas del orador.',
  'fileViewer.speakerNotesPlaceholder': 'Añade notas del orador para esta diapositiva…',
  'fileViewer.previewAssetBlockedTitle': 'Recurso de vista previa bloqueado',
  'fileViewer.previewAssetBlockedDetail': 'No se pudo cargar {filePath}. Sustituye los enlaces simbólicos externos por archivos dentro de este proyecto.',
  'fileViewer.presenterReset': 'Restablecer',
  'fileViewer.present': 'Presentar',
  'fileViewer.presentInTab': 'En esta pestaña',
  'fileViewer.presentFullscreen': 'Pantalla completa',
  'fileViewer.presentNewTab': 'Pestaña nueva',
  'fileViewer.presentFromBeginning': 'Empezar desde el principio',
  'fileViewer.presentFromCurrentSlide': 'Empezar desde la diapositiva actual',
  'fileViewer.presenterMode': 'Vista del presentador',
  'fileViewer.exitPresentation': 'Salir de la presentación',
  'fileViewer.shareLabel': 'Compartir',
  'fileViewer.shareMenuShareLink': 'COMPARTIR',
  'fileViewer.shareMenuPublishOnline': 'COMPARTIR EN TU PROPIO ALOJAMIENTO',
  'fileViewer.shareMenuDownload': 'DESCARGAR',
  'fileViewer.shareMenuPresentation': 'Presentación',
  'fileViewer.shareMenuSourceFiles': 'Archivos fuente',
  'fileViewer.shareMenuSave': 'GUARDAR',
  'fileViewer.shareMenuPublishViaOd': 'COMPARTIR RÁPIDO · OPEN DESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Obtener enlace para compartir',
  'fileViewer.publishSingleFileDescription': 'Cualquiera con el enlace puede verlo en línea. Por ahora solo se puede compartir un único archivo; los recursos locales incrustados, como imágenes, aún no son compatibles.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Creando enlace…',
  'fileViewer.unpublishFile': 'Dejar de compartir',
  'fileViewer.shareEmptyStateTitle': 'Nada que compartir todavía',
  'fileViewer.shareEmptyStateDescription': 'Crea o únete a un equipo para compartir este archivo con tus compañeros',
  'fileViewer.shareEmptyStateCreateTeam': 'Crear equipo',
  'fileViewer.shareTeamMissingTitle': 'Aún no tienes un equipo con quien compartir',

  'fileViewer.publishFileRequiresTeam': 'Publicar un enlace público requiere un espacio de trabajo de equipo. Cambia a un espacio de equipo o usa Desplegar para publicar este archivo.',
  'fileViewer.publishFileRequiresWorkspace': 'Un enlace para compartir requiere un espacio de trabajo con sesión iniciada. Inicia sesión en Open Design Cloud o comparte este archivo mediante un despliegue.',
  'fileViewer.publishFileFailed': 'No se pudo crear el enlace para compartir. Inténtalo de nuevo o usa una opción de despliegue abajo.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Copiar enlace compartido',
  'fileViewer.openSharePage': 'Abrir página compartida',
  'fileViewer.shareLinkRequiresDeploy': 'Publica en línea primero para obtener un enlace',
  'fileViewer.shareLinkPublishGuide': 'Publica en línea arriba para habilitar compartir ↑',
  'fileViewer.shareAfterGenerationComplete': 'Comparte cuando termine la generación',
  'fileViewer.copyProviderLink': 'Copiar enlace de {provider}',
  'fileViewer.copyCloudflareLink': 'Copiar enlace de Cloudflare',
  'fileViewer.screenshotCopying': 'Copiando captura de pantalla...',
  'fileViewer.screenshotCopied': 'Captura de pantalla copiada al portapapeles',
  'fileViewer.screenshotClipboardDenied': 'El navegador bloqueó el acceso al portapapeles',
  'fileViewer.screenshotPreviewLoading': 'La vista previa aún se está cargando. Inténtalo de nuevo en un momento.',
  'fileViewer.screenshotCaptureFailed': 'No se pudo capturar la vista previa. Inténtalo de nuevo.',
  'fileViewer.exportPdf': 'Exportar como PDF',
  'fileViewer.exportPdfAllSlides': 'Exportar como PDF (todas las diapositivas)',
  'fileViewer.exportPptxBusy': 'Espera a que termine el turno actual.',
  'fileViewer.exportPptxHint': 'Envía una solicitud al agente para convertir este diseño a PPTX.',
  'fileViewer.exportPptxNa': 'La exportación a PPTX no está disponible aquí.',
  'fileViewer.exportZip': 'Descargar como .zip',
  'fileViewer.exportHtml': 'Exportar como HTML independiente',
  'fileViewer.exportMd': 'Exportar como Markdown',
  'fileViewer.exportImage': 'Exportar como imagen',
  'fileViewer.exportPptxImages': 'Exportar como PPTX (imágenes)',
  'fileViewer.exportPptxEditable': 'Exportar como PPTX (editable)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Exportando…',
  'fileViewer.exportSlideProgress': 'Exportando diapositiva {current}/{total}…',
  'fileViewer.exportingElapsed': 'Exportando… {seconds}s',
  'fileViewer.exportSlideEta': 'Diapositiva {current}/{total} · quedan ~{seconds}s',
  'fileViewer.exportFailed': 'La exportación falló. Inténtalo de nuevo.',
  'fileViewer.exportDone': 'Exportación completada',
  'fileViewer.exportImageFailed': 'Error al capturar la imagen. Inténtalo de nuevo o usa la herramienta de captura de pantalla de tu navegador.',
  'fileViewer.exportImageModalSubtitle': 'Elige un formato y descarga la vista previa actual como imagen.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Guardando imagen…',
  'fileViewer.exportImageSaved': 'Imagen guardada',
  'fileViewer.exportImageDownloadStarted': 'Descarga iniciada',
  'fileViewer.exportImageDownloadDetails': '{filename} está en las descargas del navegador si no apareció un cuadro de diálogo Guardar como.',
  'fileViewer.exportJsx': 'Exportar como JSX',
  'fileViewer.exportReactHtml': 'Exportar vista previa como HTML',
  'fileViewer.exportStarted': 'Exportación iniciada',
  'fileViewer.saveAsTemplate': 'Guardar como plantilla…',
  'fileViewer.savingTemplate': 'Guardando plantilla…',
  'fileViewer.savedTemplate': 'Guardado como «{name}»',
  'fileViewer.savedTemplateFail': 'No se pudo guardar la plantilla. Inténtalo de nuevo.',
  'fileViewer.templateNamePrompt': 'Nombre de la plantilla',
  'fileViewer.templateNameDefault': 'Plantilla sin título',
  'fileViewer.templateDescPrompt': 'Descripción breve (opcional: ¿qué hace útil esta plantilla?)',
  'liveArtifact.refresh.button': 'Actualizar',
  'liveArtifact.refresh.buttonTitle': 'Actualizar este artefacto en vivo',
  'liveArtifact.refresh.loadingTitle': 'Cargando artefacto en vivo…',
  'liveArtifact.refresh.noSourceTitle': 'Aún no hay ninguna fuente de actualización disponible.',
  'liveArtifact.refresh.running': 'Actualizando…',
  'liveArtifact.refresh.runningMessage': 'Actualizando datos y vista previa. Esto puede tardar un momento.',
  'liveArtifact.refresh.runningAction': 'La vista previa anterior permanece visible hasta que la actualización se complete correctamente.',
  'liveArtifact.refresh.successOne': 'Actualización completada. Datos actualizados.',
  'liveArtifact.refresh.successMany': 'Actualización completada. Datos actualizados.',
  'liveArtifact.refresh.successAction': 'La vista previa se ha recargado con los últimos datos confirmados.',
  'liveArtifact.refresh.previousFailure': 'La actualización anterior falló: {message}',
  'liveArtifact.refresh.failureAction': 'Revisa el historial de Actualizar, corrige el problema de origen o de permisos y vuelve a intentarlo.',
  'liveArtifact.refresh.networkFailure': 'La solicitud de actualización falló. Comprueba tu conexión e inténtalo de nuevo.',
  'liveArtifact.refresh.genericFailure': 'La actualización falló.',
  'liveArtifact.refresh.statusNever': 'No actualizable',
  'liveArtifact.refresh.statusReady': 'Listo para actualizar',
  'liveArtifact.refresh.statusSucceeded': 'Actualizado',
  'liveArtifact.refresh.statusFailed': 'La actualización falló',
  'liveArtifact.refresh.statusRunning': 'Actualizando',
  'liveArtifact.refresh.statusRunningDescription': 'Hay una actualización en curso actualmente.',
  'liveArtifact.refresh.statusSucceededDescription': 'La última actualización finalizó correctamente.',
  'liveArtifact.refresh.statusFailedDescription': 'El último intento de actualización no se completó correctamente.',
  'liveArtifact.refresh.statusReadyDescription': 'Hay fuentes actualizables configuradas, pero no hay ninguna ejecución en curso.',
  'liveArtifact.refresh.statusNeverDescription': 'Este artefacto en vivo aún no tiene fuente de actualización.',
  'liveArtifact.refresh.eventStarted': 'Iniciado',
  'liveArtifact.refresh.eventSucceeded': 'Correcto',
  'liveArtifact.refresh.eventFailed': 'Fallido',
  'liveArtifact.refresh.eventStartedDetail': 'Actualización iniciada…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} fuente actualizada',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} fuentes actualizadas',
  'liveArtifact.refresh.timelineEmpty': 'Aún no hay actividad de actualización en esta sesión. Activa Actualizar para registrar una cronología o espera a las ejecuciones automáticas.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Última actualización',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nunca',
  'liveArtifact.refresh.justNow': 'ahora mismo',
  'liveArtifact.refresh.factCreated': 'Creado',
  'liveArtifact.refresh.factLastUpdated': 'Última actualización',
  'liveArtifact.refresh.factUnknown': 'Desconocido',
  'liveArtifact.refresh.persistedTitle': 'Historial de actualizaciones persistente',
  'liveArtifact.refresh.persistedHint': 'Entradas cargadas desde refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Aún no hay historial de actualizaciones persistente.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'correcto',
  'liveArtifact.refresh.persistedStatusRunning': 'en ejecución',
  'liveArtifact.refresh.persistedStatusFailed': 'fallido',
  'liveArtifact.refresh.persistedStatusCancelled': 'cancelado',
  'liveArtifact.refresh.persistedStatusSkipped': 'omitido',
  'liveArtifact.refresh.sessionTitle': 'Actividad de la sesión',
  'liveArtifact.refresh.sessionHint': 'Eventos observados mientras esta pestaña está abierta',
  'liveArtifact.refresh.docSourceTitle': 'Fuente del documento',
  'liveArtifact.refresh.docSourceHint': 'Fuente configurada',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Herramienta',
  'liveArtifact.refresh.docSourceConnector': 'Conector',
  'liveArtifact.refresh.debugSummary': 'Metadatos de depuración avanzados',
  'liveArtifact.refresh.debugNote': 'Puede incluir IDs de conectores, nombres de archivo, metadatos de la fuente y rutas internas de artefactos.',
  'liveArtifact.viewer.tabPreview': 'Vista previa',
  'liveArtifact.viewer.tabCode': 'Código',
  'liveArtifact.viewer.tabData': 'Datos',
  'liveArtifact.viewer.tabRefreshHistory': 'Historial de actualizaciones',
  'liveArtifact.viewer.dataEmpty': 'No hay caché data.json disponible.',
  'liveArtifact.viewer.code.templateHeading': 'HTML de plantilla',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizado',
  'liveArtifact.viewer.code.templateHelp': 'La plantilla editable usada con data.json para generar la vista previa.',
  'liveArtifact.viewer.code.renderedHelp': 'El index.html generado que Preview carga actualmente.',
  'liveArtifact.viewer.code.variantAria': 'Variante de código',
  'liveArtifact.viewer.code.variantTemplate': 'Plantilla',
  'liveArtifact.viewer.code.variantRendered': 'Renderizado',
  'liveArtifact.viewer.code.loading': 'Cargando código…',
  'liveArtifact.viewer.code.unavailable': 'El código aún no está disponible.',
  'liveArtifact.viewer.code.empty': 'Este archivo de código está vacío.',
  'fileViewer.deployToVercel': 'Desplegar en Vercel',
  'fileViewer.redeployToVercel': 'Volver a desplegar',
  'fileViewer.deployingToVercel': 'Desplegando en Vercel…',
  'fileViewer.deployProviderLabel': 'Proveedor',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Destino',
  'fileViewer.deployTargetPreview': 'Vista previa',
  'fileViewer.deployTargetProduction': 'Producción',
  'fileViewer.deployToProvider': 'Desplegar en {provider}',
  'fileViewer.redeployToProvider': 'Volver a desplegar en {provider}',
  'fileViewer.deployingToProvider': 'Desplegando en {provider}…',
  'fileViewer.preparingPublicLink': 'Preparando enlace público…',
  'fileViewer.copyDeployLink': 'Copiar enlace',
  'fileViewer.deployModalTitle': 'Desplegar',
  'fileViewer.deployModalSubtitle': 'Usa la cuenta del proveedor seleccionado para desplegar esta vista previa HTML.',
  'fileViewer.vercelToken': 'Token de Vercel',
  'fileViewer.vercelTokenGetLink': 'Obtener token de Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Pega tu token de Vercel',
  'fileViewer.vercelTokenReuseHint': 'Se usará el token guardado. Introduce uno nuevo para sustituirlo.',
  'fileViewer.vercelTokenRequired': 'Introduce y guarda primero un token de Vercel.',
  'fileViewer.cloudflareApiToken': 'Token de API de Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Obtener token de API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Pega tu token de API de Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Se usará el token de API de Cloudflare guardado. Introduce uno nuevo para sustituirlo.',
  'fileViewer.cloudflareApiTokenRequired': 'Introduce y guarda primero un token de API de Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Selecciona Pages Edit al crear el token de API; los dominios personalizados necesitan Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID del equipo',
  'fileViewer.vercelTeamSlug': 'Slug del equipo',
  'fileViewer.cloudflareAccountId': 'ID de cuenta',
  'fileViewer.cloudflareAccountIdHint': 'Encuentra el ID de cuenta en el panel de Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Introduce y guarda primero un Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Dominio',
  'fileViewer.cloudflareZonePlaceholder': 'Guarda la configuración de Cloudflare para cargar los dominios',
  'fileViewer.cloudflareZoneRequired': 'Selecciona primero un dominio de Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Cargando dominios de Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Actualizar dominios',
  'fileViewer.cloudflareZonesLoadFailed': 'No se pudieron cargar los dominios de Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'No se encontraron dominios completos activos de Cloudflare para esta cuenta.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefijo de subdominio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Usa una sola etiqueta DNS: letras minúsculas, números y guiones.',
  'fileViewer.cloudflareHostnamePreview': 'Vista previa del dominio personalizado: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcional: vincula un dominio personalizado. Si lo dejas vacío, se seguirá creando un enlace pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL de pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Dominio personalizado',
  'fileViewer.optional': 'Opcional',
  'fileViewer.vercelPreviewOnly': 'Los despliegues son solo Preview por ahora.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages usa Direct Upload.',
  'fileViewer.savingConfig': 'Guardando…',
  'fileViewer.deployConfigSaveFailed': 'No se pudo guardar la configuración de Vercel.',
  'fileViewer.deployFailed': 'El despliegue falló. Revisa la configuración de Vercel e inténtalo de nuevo.',
  'fileViewer.deployProviderConfigSaveFailed': 'No se pudo guardar la configuración de {provider}.',
  'fileViewer.deployProviderFailed': 'El despliegue en {provider} falló. Revisa la configuración e inténtalo de nuevo.',
  'fileViewer.deployResultLabel': 'URL desplegada',
  'fileViewer.deployLinkReady': 'Listo',
  'fileViewer.deploySuccessToast': 'Despliegue subido correctamente',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Enlace público pendiente',
  'fileViewer.deployLinkDelayed': 'El sitio se ha desplegado. El proveedor aún está preparando el enlace público.',
  'fileViewer.deployLinkFailed': 'Falló el dominio personalizado',
  'fileViewer.deployLinkProtectedLabel': 'Protección del despliegue activada',
  'fileViewer.deployLinkProtected': 'El sitio se ha desplegado, pero este enlace de vista previa requiere autenticación. Desactiva Deployment Protection o usa un dominio personalizado.',
  'fileViewer.retryLink': 'Reintentar ahora',
  'questionForm.submit': 'Enviar',
  'questionForm.skip': 'Omitir',
  'questionForm.locked': 'Respondido',
  'conv.switch': 'Cambiar de conversación',
  'conv.label': 'Conversación',
  'conv.heading': 'Conversaciones',
  'conv.new': '+ Nueva',
  'conv.empty': 'Aún no hay conversaciones.',
  'conv.untitled': 'Conversación sin título',
  'conv.renameTooltip': 'Doble clic para renombrar',
  'conv.delete': 'Eliminar conversación',
  'conv.deleteConfirm': '¿Eliminar «{title}»? Se borrarán sus mensajes.',
  'agentPicker.label': 'Agente',
  'agentPicker.modeChoose': 'Elige el modo de ejecución',
  'agentPicker.localCli': 'CLI local',
  'agentPicker.daemonOff': 'daemon apagado',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Selecciona una CLI de agente de código detectada',
  'agentPicker.noAgents': 'no hay agentes en el PATH',
  'agentPicker.notInstalled': 'no instalado',
  'agentPicker.rescan': 'Reescanear el PATH local en busca de agentes',
  'tool.openInTab': 'Abrir {name} en una pestaña',
  'tool.open': 'abrir',
  'tool.todos': 'Tareas',
  'tool.todosExpand': 'Mostrar tareas',
  'tool.todosCollapse': 'Ocultar tareas',
  'tool.todosDone': 'Listo',
  'tool.todosDismiss': 'Descartar lista de tareas',
  'tool.write': 'Escribir',
  'tool.edit': 'Editar',
  'tool.read': 'Leer',
  'tool.delete': 'Eliminar',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Obtener',
  'tool.search': 'Buscar',
  'tool.lines': '{n} líneas',
  'tool.changeSingular': 'cambio',
  'tool.changePlural': 'cambios',
  'tool.in': 'en {path}',
  'tool.hide': 'ocultar',
  'tool.output': 'salida',
  'tool.running': 'ejecutando…',
  'tool.error': 'error',
  'tool.done': 'listo',
  'assistant.role': 'Asistente',
  'assistant.workingLabel': 'Trabajando',
  'assistant.doneLabel': 'Listo',
  'assistant.canceledLabel': 'Cancelado',
  'assistant.copyMarkdown': 'Copiar Markdown de la respuesta',
  'assistant.forkConversation': 'Bifurcar desde aquí',
  'assistant.forkingConversation': 'Bifurcando…',
  'assistant.shareToOpenDesign': 'Compartir con Open Design',
  'assistant.shareToOpenDesignBusy': 'Preparando paquete…',
  'assistant.feedbackPrompt': 'Comentarios',
  'assistant.feedbackPositive': 'Útil',
  'assistant.feedbackNegative': 'No útil',
  'assistant.feedbackReasonTitle': 'Dinos por qué',
  'assistant.feedbackReasonPositiveMatched': 'Entendió mi solicitud',
  'assistant.feedbackReasonPositiveVisual': 'Tiene buena pinta',
  'assistant.feedbackReasonPositiveUseful': 'Estructura útil',
  'assistant.feedbackReasonPositiveEasy': 'Fácil de seguir editando',
  'assistant.feedbackReasonPositiveDesignSystem': 'Siguió el sistema de diseño',
  'assistant.feedbackReasonNegativeMissed': 'No tuvo en cuenta mi solicitud',
  'assistant.feedbackReasonNegativeVisual': 'La calidad visual necesita mejoras',
  'assistant.feedbackReasonNegativeIncomplete': 'Resultado incompleto',
  'assistant.feedbackReasonNegativeHard': 'Difícil de usar',
  'assistant.feedbackReasonNegativeDesignSystem': 'No siguió el sistema de diseño',
  'assistant.feedbackReasonOther': 'Otro',
  'assistant.feedbackReasonPlaceholder': 'Añade una nota breve...',
  'assistant.feedbackReasonSubmit': 'Enviar',
  'assistant.emptyResponseLabel': 'Sin salida',
  'assistant.emptyResponseMessage': 'El proveedor finalizó la solicitud sin devolver texto ni un artefacto. Prueba con otro modelo o proveedor, comprueba la cuota o vuelve a intentarlo.',
  'assistant.unfinishedLabel': 'Detenido con tareas pendientes',
  'assistant.unfinishedSummary': 'quedan {n} tarea(s)',
  'assistant.unfinishedMore': '+{n} más',
  'assistant.continueRemaining': 'Continuar tareas pendientes',
  'chat.resumeRunCta': 'Continuar la ejecución',
  'assistant.outTokens': '{n} salida',
  'assistant.producedFiles': 'Archivos de este turno',
  'assistant.openFile': 'Abrir',
  'assistant.downloadFile': 'Descargar',
  'nextStep.title': 'Siguiente paso',
  'nextStep.more': 'Más',
  'nextStep.share': 'Compartir',
  'nextStep.download': 'Descargar',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Contribuir',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Creando diseño...',
  'assistant.thinking': 'Pensando',
  'assistant.thought': 'Pensó',
  'assistant.thoughtFor': 'Pensó durante {s}s',
  'assistant.systemReminder': 'Recordatorio del sistema',
  'assistant.possiblePromptInjection': 'Posible inyección de prompt',
  'assistant.waitingFirstOutput': 'Esperando la primera salida',
  'assistant.statusBootingAgent': 'Iniciando agente',
  'assistant.statusPreparing': 'Preparando...',
  'assistant.statusStarting': 'Iniciando',
  'assistant.statusRequesting': 'Enviando solicitud',
  'assistant.statusThinking': 'Pensando',
  'assistant.statusStreaming': 'Transmitiendo',
  'assistant.slowHint': 'Está tardando más de lo normal. El formulario suele aparecer en 5-10 s. Puedes pulsar Detener y reformular.',
  'assistant.verbEditing': 'Editando',
  'assistant.verbWriting': 'Escribiendo',
  'assistant.verbReading': 'Leyendo',
  'assistant.verbSearching': 'Buscando',
  'assistant.verbRunning': 'Ejecutando',
  'assistant.verbTodos': 'Tareas',
  'assistant.verbFetching': 'Obteniendo',
  'assistant.verbCalling': 'Llamando',
  'qf.answered': 'respondido',
  'qf.choose': 'Elige…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Otro',
  'qf.required': 'obligatorio',
  'qf.lockedSubmitted': 'Respuestas enviadas: el agente las usará durante el resto de la sesión.',
  'qf.lockedPrev': 'Este formulario es de un turno anterior.',
  'qf.hint': 'Elige lo que encaje. Omite los campos opcionales que no te importen: el agente usará valores predeterminados sensatos.',
  'qf.submitDefault': 'Enviar respuestas',
  'qf.submitDisabledTitle': 'Rellena primero los campos obligatorios',
  'qf.submitTitle': 'Enviar respuestas',
  'qf.cardSelected': 'seleccionado',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'El veloz murciélago hindú · 0123',
  'questions.tabLabel': 'Preguntas',
  'questions.banner': '¿Te importa si te hago un par de preguntas rápidas?',
  'questions.bannerAnswered': 'Preguntas respondidas',
  'questions.continue': 'Continuar',
  'questions.generating': 'Generando preguntas…',
  'questions.skipAll': 'Omitir todo',
  'questions.autoSkipHint': 'Continúa automáticamente cuando termina el temporizador',
  'questions.submitting': 'Enviando…',
  'sketch.toolSelect': 'Seleccionar (sin acción)',
  'sketch.toolPen': 'Lápiz',
  'sketch.toolText': 'Texto',
  'sketch.toolRect': 'Rectángulo',
  'sketch.toolArrow': 'Flecha',
  'sketch.toolEraser': 'Borrador',
  'sketch.color': 'Color',
  'sketch.strokeSize': 'Grosor del trazo',
  'sketch.undo': 'Deshacer',
  'sketch.clear': 'Limpiar',
  'sketch.close': 'Cerrar',
  'sketch.closeConfirm': '¿Cerrar el boceto y descartar los cambios sin guardar?',
  'sketch.textPrompt': 'Texto:',
  'sketch.textModalTitle': 'Añadir texto',
  'critiqueTheater.userFacingName': 'Jurado de Diseño',
  'critiqueTheater.roleDesigner': 'Diseñador',
  'critiqueTheater.roleCritic': 'Crítico',
  'critiqueTheater.roleBrand': 'Marca',
  'critiqueTheater.roleA11y': 'Accesibilidad',
  'critiqueTheater.roleCopy': 'Texto',
  'critiqueTheater.roundLabel': 'Ronda {n} de {m}',
  'critiqueTheater.mustFix': '{n} correcciones obligatorias',
  'critiqueTheater.composite': 'Compuesta',
  'critiqueTheater.threshold': 'Umbral',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interrumpir',
  'critiqueTheater.interrupting': 'Interrumpiendo…',
  'critiqueTheater.interrupted': 'Interrumpido',
  'critiqueTheater.degradedHeading': 'Panel sin conexión en esta ejecución',
  'critiqueTheater.degradedReasonMalformed': 'Salida del panel con formato incorrecto (el analizador rechazó el bloque).',
  'critiqueTheater.degradedReasonOversize': 'La salida del panel superó el presupuesto seguro de bytes.',
  'critiqueTheater.degradedReasonAdapter': 'El adaptador {adapter} no admitía el protocolo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'El adaptador {adapter} envió una versión de protocolo no admitida.',
  'critiqueTheater.degradedReasonMissingArtifact': 'La ejecución finalizó sin un artefacto final.',
  'critiqueTheater.replay': 'Reproducir',
  'critiqueTheater.replaySpeed': 'Velocidad de reproducción',
  'critiqueTheater.readOnly': 'Solo lectura',
  'critiqueTheater.shippedSummary': 'Entregado en la ronda {round} · compuesto {composite}',
  'critiqueTheater.interruptedSummary': 'Interrumpido en la ronda {round} · mejor compuesto {composite}',
  'critiqueTheater.shippedBadge': 'Publicado',
  'critiqueTheater.belowThresholdBadge': 'Por debajo del umbral',
  'critiqueTheater.timedOutBadge': 'Tiempo agotado',
  'critiqueTheater.failedHeading': 'La ejecución falló',
  'critiqueTheater.failedReasonCliExit': 'El CLI del agente terminó con un código distinto de cero antes de que el panel pudiera finalizar.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Una ronda superó su presupuesto de tiempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'La ejecución completa superó su presupuesto total de tiempo.',
  'critiqueTheater.failedReasonOrchestrator': 'Error interno del orquestador.',
  'critiqueTheater.transcriptEmpty': 'Aún no hay ninguna transcripción que reproducir. Ejecuta una crítica para grabar una.',
  'critiqueTheater.transcriptLoading': 'Cargando transcripción…',
  'critiqueTheater.transcriptError': 'No se pudo cargar la transcripción: {error}',
  'critiqueTheater.replaySpeedPaused': 'En pausa',
  'critiqueTheater.replaySpeedInstant': 'Instantáneo',
  'critiqueTheater.replaySpeedLive': 'En directo',
  'critiqueTheater.replaySpeedFast': 'Rápido',
  'critiqueTheater.settingsNav': 'Jurado de Diseño',
  'critiqueTheater.settingsNavHint': 'Revisión de diseño de cinco paneles para tus ejecuciones',
  'critiqueTheater.settingsEnabledLabel': 'Mostrar el Jurado de Diseño durante las ejecuciones del agente',
  'critiqueTheater.settingsEnabledDescription': 'Cuando está activado, aparece una revisión de cinco paneles junto a las generaciones del agente y puntúa la salida antes de publicarla. Puedes interrumpir en cualquier momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Guardado para este proyecto. Las nuevas ejecuciones de este proyecto se enrutarán a través del Jurado de Diseño en el servidor.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Abre un proyecto para conservar esto en el servidor. Hasta entonces, esto solo cambia la preferencia en el navegador.',
  'pet.title': 'Mascotas',
  'pet.subtitle': 'Adopta una mascotita que flota sobre tu workspace.',
  'pet.navTitle': 'Mascotas',
  'pet.navHint': 'Adopta o personaliza',
  'pet.tabBuiltIn': 'Integradas',
  'pet.tabBuiltInHint': 'Compañeros incluidos con Open Design — elige uno y adóptalo.',
  'pet.builtInEmpty': 'Las mascotas integradas no están disponibles ahora. Actualiza la pestaña Comunidad cuando el daemon vuelva a estar en línea.',
  'pet.tabCustom': 'Personalizada',
  'pet.tabCustomHint': 'Pon nombre, glifo, color o sube un sprite.',
  'pet.tabCommunity': 'Comunidad',
  'pet.tabCommunityHint': 'Mascotas eclosionadas de Codex — adopta o genera una con IA.',
  'pet.tabsAria': 'Fuente de la mascota',
  'pet.adopt': 'Adoptar',
  'pet.adoptedBadge': 'Adoptada',
  'pet.adoptCallout': 'Adopta una mascota',
  'pet.changePet': 'Cambiar mascota',
  'pet.wake': 'Despertar',
  'pet.tuck': 'Esconder',
  'pet.wakeTitle': 'Despertar la mascota — mostrar el overlay.',
  'pet.tuckTitle': 'Esconder la mascota — ocultar el overlay.',
  'pet.settingsTitle': 'Abrir ajustes de mascota',
  'pet.useCustom': 'Usar mi mascota',
  'pet.customTitle': 'Crea la tuya',
  'pet.customHint': 'Elige nombre, símbolo y color — el overlay se actualiza en vivo.',
  'pet.customGreetingPlaceholder': 'Saluda con tu mascota…',
  'pet.fieldName': 'Nombre',
  'pet.fieldGlyph': 'Símbolo',
  'pet.fieldGlyphHint': 'Un solo emoji va mejor (p. ej. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saludo',
  'pet.fieldAccent': 'Color de acento',
  'pet.fieldAccentCustom': 'Color personalizado',
  'pet.fieldAccentDefault': 'Color de acento predeterminado',
  'pet.overlayAria': 'Compañero',
  'pet.spriteAria': '{name} — arrastra para mover, haz clic para conversar',
  'pet.spriteTitle': '¡Hola de {name}! Haz clic para conversar.',
  'pet.taskSummarySingle': 'Se está ejecutando {count} tarea de agente.',
  'pet.taskSummaryMultiple': 'Se están ejecutando {count} tareas de agente en {projects} proyectos.',
  'pet.taskSummaryRecentSingle': '{count} tarea de agente se ha completado recientemente.',
  'pet.taskSummaryRecentMultiple': '{count} tareas de agente se han completado recientemente.',
  'pet.taskListAria': 'Tareas de agente activas',
  'pet.taskOpenProject': 'Abrir {project}',
  'pet.taskGroup.running': 'En ejecución',
  'pet.taskGroup.queued': 'En espera',
  'pet.taskGroup.recent': 'Completados recientemente',
  'pet.idleQuote.leonardo.text': 'Aprender nunca agota la mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Vi al ángel en el mármol y tallé hasta liberarlo.',
  'pet.idleQuote.michelangelo.author': 'Miguel Ángel',
  'pet.idleQuote.bernini.text': 'Hay dos recursos que pueden ayudar al escultor: la luz y la sombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Cuando uno pinta, no piensa.',
  'pet.idleQuote.raphael.author': 'Rafael',
  'pet.idleQuote.caravaggio.text': 'Todas las obras, sin importar qué representen ni quién las pinte, no son más que bagatelas y nimiedades infantiles a menos que se hagan y se pinten del natural.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Lo principal es emocionarse, amar, esperar, temblar, vivir.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Mascotas — despertar, esconder o elegir',
  'pet.composerMenuTitle': 'Mascotas',
  'pet.composerMenuHint': 'tip: escribe /pet para alternar',
  'pet.composerOpenSettings': 'Administrar mascotas',
  'pet.welcomeTeaserTitle': 'Adopta una mascota',
  'pet.welcomeTeaserBody': 'Un compañerito que flota sobre tu workspace.',
  'pet.welcomeTeaserCta': 'Elegir',
  'pet.imageUpload': 'Subir sprite',
  'pet.imageReplace': 'Reemplazar sprite',
  'pet.imageRemove': 'Usar emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF o SVG. ¿Spritesheet? Sube una tira horizontal y ajusta el número de frames.',
  'pet.imageHintActive': 'Mostrando tu sprite. Pon frames > 1 para animar un spritesheet horizontal.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = estático. > 1 = spritesheet horizontal.',
  'pet.fieldFps': 'Velocidad (fps)',
  'pet.fieldFpsHint': 'Velocidad de cambio de frames.',
  'pet.atlasImport': 'Importar sprite de Codex',
  'pet.atlasImportTitle': 'Importa un atlas hatch-pet 8x9 / 192x208 (PNG o WebP).',
  'pet.atlasPickerTitle': 'Elige una fila de animación',
  'pet.atlasPickerHint': 'Las mascotas Codex traen 9 filas de animación. Por defecto mantenemos todo el atlas para que la mascota cambie de fila al pasar el ratón, según la dirección del arrastre o tras estar inactiva. También puedes fijar un solo bucle.',
  'pet.atlasCancel': 'Descartar atlas',
  'pet.atlasAdopt': 'Fijar a esta fila',
  'pet.atlasAdoptFull': 'Usar atlas completo (animado)',
  'pet.atlasAdoptFullTitle': 'Conserva todas las filas para que la mascota reaccione al hover, a la dirección del arrastre y a la inactividad larga.',
  'pet.atlasAdoptRowTitle': 'Recorta solo la fila resaltada en una tira con bucle único.',
  'pet.atlasActiveHint': 'Atlas animado activo — la mascota elige una fila según tu interacción (hover, arrastre, inactividad).',
  'pet.atlasRow.idle': 'Inactivo',
  'pet.atlasRow.running-right': 'Corre a la derecha',
  'pet.atlasRow.running-left': 'Corre a la izquierda',
  'pet.atlasRow.waving': 'Saludo',
  'pet.atlasRow.jumping': 'Salto',
  'pet.atlasRow.failed': 'Falló',
  'pet.atlasRow.waiting': 'Espera',
  'pet.atlasRow.running': 'Corre',
  'pet.atlasRow.review': 'Revisión',
  'pet.hatchTitle': 'Eclosiona una mascota nueva con IA',
  'pet.hatchHint': 'Usa la skill hatch-pet incluida desde el chat para generar un spritesheet estilo Codex y luego impórtalo aquí.',
  'pet.hatchConcept': 'Concepto de mascota (opcional)',
  'pet.hatchConceptPlaceholder': 'p. ej. un shiba pixel-art con un suéter cómodo',
  'pet.hatchCopy': 'Copiar prompt',
  'pet.hatchCopied': '¡Copiado!',
  'pet.hatchFoot': 'Cuando la skill guarde tu mascota, vuelve y pulsa "Importar sprite de Codex".',
  'pet.slashPopoverAria': 'Comandos slash',
  'pet.slashPopoverTitle': 'Comandos',
  'pet.slashPopoverHint': '↑↓ navegar · enter elegir · esc cerrar',
  'pet.slashPet': 'Alternar, adoptar o ir a ajustes de mascota.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Despertar la mascota flotante.',
  'pet.slashPetTuck': 'Guardar la mascota por ahora.',
  'pet.slashHatch': 'Genera una mascota Codex con la skill hatch-pet.',
  'pet.slashHatchArg': '<concepto>',
  'pet.slashSearch': 'Busca en la web con el comando OD research.',
  'pet.slashSearchArg': '<consulta>',
  'pet.codexTitle': 'Recién eclosionadas',
  'pet.codexSubtitle': 'Las mascotas empaquetadas por la skill hatch-pet aparecen aquí para adopción en un clic.',
  'pet.codexSubtitleWithDir': 'Escaneando {dir} en busca de paquetes de hatch-pet.',
  'pet.codexEmpty': 'Aún no hay mascotas eclosionadas. Escribe /hatch en el chat para generar una.',
  'pet.codexLoading': 'Buscando mascotas eclosionadas…',
  'pet.codexRefresh': 'Refrescar',
  'pet.codexAdopt': 'Adoptar',
  'pet.codexAdopting': 'Adoptando…',
  'pet.communitySync': 'Descargar mascotas de la comunidad',
  'pet.communitySyncing': 'Descargando…',
  'pet.communitySyncTitle': 'Sincronizar las últimas mascotas de Codex Pet Share + j20 Hatchery en ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} mascotas nuevas sincronizadas ({total} en total).',
  'pet.communitySyncFailed': 'Error al sincronizar: {error}',
  'pet.codexBundled': 'Incluida',
  'pet.codexBundledTitle': 'Viene con Open Design — sin descarga.',
  'settings.systemPrefsTitle': 'Preferencias del sistema',
  'settings.systemPrefsHint': 'Sonido de finalización, notificaciones del navegador y avisos de estado de tareas.',
  'settings.notifications': 'Notificaciones',
  'settings.notificationsHint': 'Sonido y notificación al completar la tarea',
  'settings.notifyCompletionSound': 'Sonido al completar',
  'settings.notifyCompletionSoundHint': 'Se reproduce al terminar un turno. Desactivado por defecto.',
  'settings.notifySuccessSound': 'Sonido de éxito',
  'settings.notifyFailureSound': 'Sonido de error',
  'settings.notifyDesktop': 'Notificación de escritorio',
  'settings.notifyDesktopHint': 'Se envía cuando la ventana no está en primer plano.',
  'settings.notifyDesktopBlocked': 'Bloqueadas por el navegador. Habilítalas en la configuración del sitio.',
  'settings.notifyDesktopUnsupported': 'Las notificaciones de escritorio no están disponibles en este entorno.',
  'settings.notifyTest': 'Enviar prueba',
  'settings.notifyTestSent': 'Notificación de prueba enviada. Si no aparece el aviso, revisa las notificaciones del navegador y del sistema.',
  'settings.notifyTestFailed': 'Falló la llamada de notificación. Revisa las notificaciones del navegador y del sistema.',
  'settings.notifySoundDing': 'Tilín',
  'settings.notifySoundChime': 'Carillón',
  'settings.notifySoundTwoToneUp': 'Dos tonos ascendente',
  'settings.notifySoundPluck': 'Pulsación',
  'settings.notifySoundBuzz': 'Zumbido',
  'settings.notifySoundTwoToneDown': 'Dos tonos descendente',
  'settings.notifySoundThud': 'Golpe',
  'settings.skills': 'Habilidades',
  'settings.skillsHint': 'Habilidades funcionales que el agente puede invocar durante la tarea',
  'settings.skillsNew': 'Nueva habilidad',
  'settings.skillsEmpty': 'Selecciona una habilidad a la izquierda o crea una nueva.',
  'settings.skillsEdit': 'Editar',
  'settings.skillsDelete': 'Eliminar',
  'settings.skillsDeleteConfirm': 'Confirmar eliminación',
  'settings.skillsName': 'Nombre',
  'settings.skillsTriggers': 'Disparadores (separados por comas o saltos de línea)',
  'settings.skillsDescription': 'Descripción',
  'settings.skillsBody': 'Cuerpo de SKILL.md',
  'settings.skillsCreate': 'Crear',
  'settings.skillsSave': 'Guardar',
  'settings.skillsSaving': 'Guardando…',
  'settings.skillsOverrideCreate': 'Crear anulación de usuario',
  'settings.skillsOverrideSave': 'Guardar como anulación de usuario',
  'settings.skillsBuiltInOverrideWarning': 'Editar esta habilidad integrada crea una anulación de usuario. La entrada integrada se ocultará de la lista hasta que elimines la anulación. ¿Continuar?',
  'settings.skillsFiles': 'Archivos',
  'settings.skillsNoFiles': 'No hay archivos en esta carpeta de habilidad.',
  'settings.skillsNameRequired': 'El nombre de la habilidad es obligatorio.',
  'settings.skillsBodyRequired': 'El contenido de la habilidad es obligatorio.',
  'settings.designSystems': 'Sistemas de diseño',
  'settings.designSystemsHint': 'Explora y activa los sistemas de diseño disponibles',
  'settings.designSystemsInstalled': 'Instalados',
  'settings.designSystemsAdd': 'Añadir sistema de diseño',
  'settings.designSystemsHiddenCount': '{count} ocultos en la galería de inicio',
  'settings.designSystemsShowAll': 'Mostrar todo',
  'settings.designSystemsShowHidden': 'Mostrar ocultos',
  'settings.designSystemsSource': 'Origen',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Referencia del registro shadcn',
  'settings.designSystemsImportShadcn': 'Importar desde shadcn',
  'settings.designSystemsStructure': 'Estructura',
  'settings.designSystemsModeHybrid': 'Híbrido',
  'settings.designSystemsModeNormalized': 'Normalizado',
  'settings.designSystemsModeVerbatim': 'Literal',
  'settings.designSystemsCraft': 'Diseño',
  'settings.designSystemsCraftColor': 'Color',
  'settings.designSystemsCraftAccessibility': 'Accesibilidad',
  'settings.designSystemsGithubUrl': 'URL de GitHub',
  'settings.designSystemsProjectPath': 'Ruta del proyecto',
  'settings.designSystemsImportGithub': 'Importar desde GitHub',
  'settings.designSystemsImportProject': 'Importar desde proyecto',
  'settings.designSystemsImportedStatus': '{title} importado',
  'settings.designSystemsViewImported': 'Ver sistema de diseño importado',
  'settings.designSystemsCategory': 'Categoría',
  'settings.designSystemsAllCategories': 'Todas las categorías',
  'settings.designSystemsShowInHomeGallery': 'Mostrar en la galería de inicio',
  'settings.projectLocations': 'Ubicaciones de proyectos',
  'settings.projectLocationsHint': 'Raíces de almacenamiento del espacio de trabajo',
  'settings.projectLocationsDescription': 'Añade bases de trabajo que pueden contener varias carpetas de proyectos de Open Design. Los proyectos nuevos se guardan como una carpeta dentro de la base seleccionada.',
  'settings.projectLocationsSaveError': 'No se pudieron guardar las ubicaciones de proyectos. Comprueba que cada ruta sea una carpeta accesible.',
  'settings.projectLocationsSaved': 'Ubicaciones de proyectos guardadas.',
  'settings.projectLocationsScanError': 'No se pudieron escanear las ubicaciones de proyectos.',
  'settings.projectLocationsScanComplete': 'Escaneo completado: {imported} importados, {existing} ya registrados.',
  'settings.projectLocationsNoFolderSelected': 'No se seleccionó ninguna carpeta.',
  'settings.projectLocationsDuplicate': 'Esa base de trabajo ya está añadida.',
  'settings.projectLocationsWorkBaseMeta': 'Base de trabajo · los proyectos se crean aquí como subcarpetas',
  'settings.projectLocationsAddFolder': 'Añadir carpeta…',
  'settings.projectLocationsDefaultBadge': 'Ubicación predeterminada',
  'settings.projectLocationsMakeDefault': 'Hacer predeterminada',
  'settings.projectLocationsDefaultSaved': 'Ubicación de proyecto predeterminada actualizada.',
  'settings.librarySkills': 'Habilidades',
  'settings.libraryDesignSystems': 'Sistemas de diseño',
  'settings.librarySearch': 'Buscar...',
  'settings.libraryAll': 'Todo',
  'settings.libraryPreview': 'Vista previa',
  'settings.libraryPreviewClose': 'Cerrar',
  'settings.libraryLoading': 'Cargando...',
  'settings.libraryNoResults': 'Ningún elemento coincide con tu búsqueda.',
  'settings.libraryEnabled': 'Activado',
  'settings.libraryDisabled': 'Desactivado',
  'settings.connectorsNavHint': 'Conexiones a sistemas externos',
  'settings.connectorsHint': 'Gestiona la configuración de conectores y proveedores de herramientas para este dispositivo.',
  'settings.connectorsComposioApiKey': 'Clave API de Composio',
  'settings.connectorsSavedTitle': 'Guardada en el daemon local',
  'settings.connectorsSavedWithTail': 'Guardada · ••••{tail}',
  'settings.connectorsSaved': 'Guardada',
  'settings.connectorsGetApiKey': 'Obtener clave API',
  'settings.connectorsReplaceKeyPlaceholder': 'Pega una clave nueva para sustituir la guardada',
  'settings.connectorsApiKeyPlaceholder': 'Pega la clave API de Composio',
  'settings.connectorsClear': 'Borrar',
  'settings.connectorsClearConfirmTitle': '¿Borrar la clave de API de Composio guardada?',
  'settings.connectorsClearConfirmBody': 'Eliminar la clave desconecta todos los conectores de Composio vinculados a este espacio. Se quitarán las cuentas conectadas, los permisos OAuth y el acceso a las herramientas.',
  'settings.connectorsClearConfirmContinue': 'Continuar',
  'settings.connectorsClearFinalTitle': 'Esto desconectará todos los conectores',
  'settings.connectorsClearFinalBody': 'No hay vuelta atrás. Tendrás que volver a conectar cada integración desde cero después de pegar una clave nueva.',
  'settings.connectorsClearFinalConfirm': 'Borrar clave y desconectar',
  'settings.connectorsClearArming': 'Un momento…',
  'settings.connectorsClearCancel': 'Cancelar',
  'settings.connectorsSaveKey': 'Guardar clave',
  'settings.connectorsSaveKeyTitle': 'Enviar esta clave al daemon local',
  'settings.connectorsKeySaving': 'Guardando…',
  'settings.connectorsKeySaved': 'Guardado ✓',
  'settings.connectorsKeyError': 'No se pudo guardar la clave. Comprueba que el daemon local está activo y vuelve a intentarlo.',
  'settings.connectorsHelpSaved': 'Tu clave desbloquea el catálogo de abajo y permanece en el daemon local. Pega una clave nueva para sustituirla o bórrala.',
  'settings.connectorsHelpUnsaved': 'Cambios sin guardar — pulsa Guardar clave para almacenar esta credencial en el daemon local y desbloquear el catálogo de abajo.',
  'settings.connectorsHelpEmpty': 'Añade una clave para desbloquear el catálogo de abajo. Las claves se guardan localmente en el daemon y nunca se envían mediante variables de entorno.',
  'settings.connectorsLoadingSavedKey': 'Buscando una clave guardada en el daemon local…',
  'settings.autosaveSaving': 'Guardando…',
  'settings.autosaveSaved': 'Todos los cambios guardados',
  'settings.autosaveError': 'No se pudieron guardar los cambios. Es posible que el daemon local esté desconectado.',
  'settings.libraryToggleLabel': 'Alternar',
  'settings.memory': 'Memoria',
  'settings.memoryHint': 'Datos personales extraídos automáticamente de los chats',
  'settings.customInstructionsTitle': 'Reglas globales',
  'settings.customInstructionsHint': 'Instrucciones fijas que Open Design debe seguir en cada chat. Guarda hechos, preferencias y el contexto del proyecto como memorias.',
  'settings.customInstructionsPlaceholder': 'p. ej. «Usa siempre TypeScript. Prefiere componentes funcionales. Mantén las respuestas concisas.»',
  'settings.memoryDescription': 'Datos sobre tus preferencias extraídos automáticamente, guardados como Markdown e inyectados en cada chat.',
  'settings.memoryEnabled': 'Activada',
  'settings.memoryDisabled': 'Desactivada',
  'settings.memoryEnableLabel': 'Activar inyección de memoria',
  'settings.memoryDisabledBanner': 'La memoria está desactivada. Los datos existentes permanecen en disco pero no se inyectarán en nuevos chats.',
  'settings.memoryNew': 'Nueva memoria',
  'settings.memoryEdit': 'Editar',
  'settings.memoryDelete': 'Eliminar',
  'settings.memoryPreview': 'Vista previa',
  'settings.memoryEmpty': 'Aún no hay memoria.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Prefiero el modo oscuro',
  'settings.memoryName': 'Nombre',
  'settings.memoryDesc': 'Descripción en una línea',
  'settings.memoryBody': 'Cuerpo (Markdown compatible)',
  'settings.memoryBodyHint': 'La regla primero, luego Why y How to apply.',
  'settings.memoryStartersLabel': '¿Necesitas un punto de partida? Haz clic para rellenar el formulario:',
  'settings.memoryStarterUserName': 'Mi rol',
  'settings.memoryStarterUserDesc': 'Soy ingeniero de frontend y trabajo en una herramienta de diseño SaaS',
  'settings.memoryStarterUserBody': '- Rol: ingeniero frontend sénior\n- Stack: React, TypeScript, Vite\n- Dominio: herramientas de diseño / colaboración\n- Zona horaria: GMT+8 (Asia/Shanghai)\n\nCuándo aplicarlo: cualquier chat — plantea los ejemplos en torno al frontend web.',
  'settings.memoryStarterFeedbackName': 'Preferencias de interfaz',
  'settings.memoryStarterFeedbackDesc': 'Modo oscuro, texto de cuerpo grande, baja densidad de información',
  'settings.memoryStarterFeedbackBody': '- Tema: oscuro por defecto\n- Texto del cuerpo: ≥ 18px\n- Densidad de información: prioriza el espacio en blanco, menos elementos por pantalla\n\nPor qué: menos fatiga visual durante sesiones largas.\nCuándo aplicarlo: siempre que generes interfaces, páginas web o diapositivas.',
  'settings.memoryStarterProjectName': 'Proyecto actual',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — editor de diseño guiado por chat',
  'settings.memoryStarterProjectBody': '- Objetivo: lanzar el editor basado en chat este trimestre\n- Prioridades: renderizado en streaming, multimodal local, offline-first\n- Stack: Next.js 16, daemon de Express, SQLite\n\nCuándo aplicar: en cualquier conversación sobre este proyecto.',
  'settings.memorySaveHint': 'No se guarda automáticamente — haz clic en Crear / Guardar para aplicar.',
  'settings.memoryIndexSaveHint': 'Las ediciones del índice no se guardan automáticamente — haz clic en Guardar índice para aplicar.',
  'settings.memoryIndexUnsaved': 'Cambios sin guardar',
  'settings.memoryFlashCreated': '✓ Memoria creada',
  'settings.memoryFlashSaved': '✓ Memoria guardada',
  'settings.memoryFlashDeleted': '✓ Memoria eliminada',
  'settings.memoryFlashIndexSaved': '✓ Índice guardado',
  'settings.memoryFlashPathCopied': '✓ Ruta copiada',
  'settings.memoryNameLabel': 'Título',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descripción',
  'settings.memoryBodyLabel': 'Contenido',
  'settings.memoryTypeUser': 'Usuario',
  'settings.memoryTypeFeedback': 'Retroalimentación',
  'settings.memoryTypeProject': 'Proyecto',
  'settings.memoryTypeReference': 'Referencia',
  'settings.memoryTypeProfile': 'Perfil',
  'settings.memoryTypeRule': 'Regla',
  'settings.memoryTabMemories': 'Memorias',
  'settings.memoryTabMemoriesCaption': 'Ver y gestionar la memoria guardada',
  'settings.memoryTabHow': 'Cómo funciona',
  'settings.memoryTabHowCaption': 'Los dos bucles y sus controles',
  'settings.memoryAddDisclosure': 'Añadir o importar memorias',
  'settings.memoryAddDisclosureHint': 'Perfil, entrada manual o apps conectadas',
  'settings.memoryProfileTab': 'Perfil de trabajo',
  'settings.memoryProfileTabCaption': 'Quién eres y tus valores por defecto',
  'settings.memoryProfileTitle': 'Tu perfil de trabajo',
  'settings.memoryProfileHint':
    'Unos pocos datos sobre ti y tus valores por defecto. La memoria los inyecta antes de cada tarea para que el agente deduzca lo que quieres a partir de una petición breve.',
  'settings.memoryProfileName': 'Perfil de trabajo',
  'settings.memoryProfileDescription':
    'Rol, empresa, dominio, audiencia, gustos y valores por defecto que el asistente debería reutilizar.',
  'settings.memoryProfileSave': 'Guardar perfil',
  'settings.memoryProfileSaving': 'Guardando…',
  'settings.memoryProfileSaved': 'Perfil guardado',
  'settings.memoryProfileRole': 'Rol',
  'settings.memoryProfileRolePlaceholder': 'p. ej. fundador, diseñador, PM',
  'settings.memoryProfileCompany': 'Empresa / Equipo',
  'settings.memoryProfileCompanyPlaceholder': 'p. ej. Acme, equipo de crecimiento',
  'settings.memoryProfileDomain': 'Dominio',
  'settings.memoryProfileDomainPlaceholder': 'p. ej. SaaS B2B, fintech, devtools',
  'settings.memoryProfileAudience': 'Audiencia principal',
  'settings.memoryProfileAudiencePlaceholder': 'p. ej. directivos, ingenieros, usuarios finales',
  'settings.memoryProfileAesthetic': 'Estética / gusto',
  'settings.memoryProfileAestheticPlaceholder':
    'p. ej. limpia y editorial, fondos claros, espacios en blanco generosos',
  'settings.memoryProfileDeliverables': 'Entregables por defecto',
  'settings.memoryProfileDeliverablesPlaceholder': 'p. ej. páginas de aterrizaje, presentaciones, one-pagers',
  'settings.memoryProfileLocale': 'Configuración regional / Idioma',
  'settings.memoryProfileLocalePlaceholder': 'p. ej. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Objetivos actuales',
  'settings.memoryProfileGoalsPlaceholder':
    'p. ej. lanzar la nueva página de precios, mejorar la conversión del flujo de prueba',
  'settings.memoryHooksTitle': 'Hooks de memoria',
  'settings.memoryHooksHint':
    'Elige qué partes de la memoria se ejecutan automáticamente. El interruptor principal de arriba las desactiva todas.',
  'settings.memoryHooksProfileLabel': 'Usar mi perfil',
  'settings.memoryHooksProfileDesc': 'Inyecta tu perfil de trabajo en cada tarea.',
  'settings.memoryHooksRewriteLabel': 'Reescribir peticiones breves',
  'settings.memoryHooksRewriteDesc': 'PRE: amplía una petición breve en un brief de tarea completo.',
  'settings.memoryHooksVerifyLabel': 'Autoverificar el resultado',
  'settings.memoryHooksVerifyDesc': 'POST: comprueba el resultado frente a tus reglas y luego muestra una tarjeta de evaluación.',
  'settings.memoryHooksExtractionLabel': 'Aprender de los chats',
  'settings.memoryHooksExtractionDesc': 'Captura datos y preferencias útiles de los turnos de chat.',
  'artifact.odCardTaskBriefChip': 'Memoria aplicada · ver brief',
  'artifact.odCardScorecardTitle': 'Autocomprobación',
  'artifact.odCardScorecardStatusPass': 'Superada',
  'artifact.odCardScorecardStatusPartial': 'Parcial',
  'artifact.odCardScorecardStatusFail': 'Necesita trabajo',
  'artifact.odCardRuleKicker': 'Regla propuesta',
  'artifact.odCardRuleNameLabel': 'Nombre',
  'artifact.odCardRuleDescriptionLabel': 'Descripción',
  'artifact.odCardRuleAssertionLabel': 'Debe cumplirse',
  'artifact.odCardRuleCheckLabel': 'Cómo comprobarlo',
  'artifact.odCardRuleRationaleLabel': 'Por qué',
  'artifact.odCardRuleKeep': 'Conservar',
  'artifact.odCardRuleEdit': 'Editar',
  'artifact.odCardRuleDone': 'Hecho',
  'artifact.odCardRuleDiscard': 'Descartar',
  'artifact.odCardRuleSaving': 'Guardando…',
  'artifact.odCardRuleSaved': 'Se guardó “{name}” como regla',
  'artifact.odCardRuleError': 'No se pudo guardar la regla. Inténtalo de nuevo.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryIndex': 'MEMORY.md (índice)',
  'settings.memoryIndexSave': 'Guardar índice',
  'settings.memoryIndexReset': 'Restablecer',
  'settings.memoryToastChanged': 'Memoria actualizada',
  'settings.memoryToastClickHint': 'Ver',
  'settings.memoryAll': 'Todo',
  'settings.memoryExtractions': 'Historial de extracciones',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Aún no hay extracciones. El próximo turno del chat poblará esta lista.',
  'settings.memoryExtractionsRefresh': 'Actualizar',
  'settings.memoryExtractionsRefreshing': 'Actualizando…',
  'settings.memoryExtractionPhaseRunning': 'Ejecutando…',
  'settings.memoryExtractionPhaseSuccess': 'Correcto',
  'settings.memoryExtractionPhaseSkipped': 'Omitido',
  'settings.memoryExtractionPhaseFailed': 'Fallido',
  'settings.memoryExtractionSkipNoProvider': 'No hay ninguna API key configurada para la extracción de memoria con LLM.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'La memoria está desactivada.',
  'settings.memoryExtractionSkipEmpty': 'Mensaje de usuario vacío — no hay nada que extraer.',
  'settings.memoryExtractionSkipNoMatch': 'Ningún patrón de regex coincidió en este turno.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'ajustes de medios',
  'settings.memoryExtractionProviderOverride': 'ajustes de memoria',
  'settings.memoryExtractionProposed': 'propuesto',
  'settings.memoryExtractionWritten': 'escrito',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Eliminar',
  'settings.memoryExtractionsClear': 'Borrar',
  'settings.memoryExtractionsClearTitle': 'Borrar todo el historial de extracciones',
  'settings.memoryExtractionsClearConfirm': '¿Borrar todo el historial de extracciones? Esta acción no se puede deshacer.',
  'settings.memoryNoProviderBannerTitle': 'La extracción de memoria con LLM no se está ejecutando',
  'settings.memoryNoProviderBannerBody': 'No se encontró ninguna API key para el extractor de memoria. Añade una clave de OpenAI en Proveedores de medios, o define ANTHROPIC_API_KEY / OPENAI_API_KEY en el entorno, para habilitar la extracción basada en LLM. La extracción heurística por regex sigue activa.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Instalar',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Ruta local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Instalar',
  'settings.libraryUninstall': 'Desinstalar',
  'settings.libraryBuiltIn': 'Integrado',
  'settings.libraryInstalled': 'Instalado',
  'notify.successTitle': 'Tarea completada',
  'notify.failureTitle': 'La tarea falló',
  'notify.successBody': 'Un turno ha terminado.',
  'notify.failureBody': 'La tarea terminó con un error.',
  'updater.available': 'Actualización disponible',
  'updater.activeRunsTitle': 'Open Design sigue trabajando',
  'updater.activeRunsBody': 'Aún hay {count} tareas activas. Reiniciar ahora las interrumpirá.',
  'updater.activeRunsUnknownBody': 'Open Design no pudo confirmar si hay tareas en curso. Reiniciar ahora podría interrumpir el trabajo activo.',
  'updater.availableBody': 'Open Design {version} está disponible. Se descargará antes de abrir el instalador.',
  'updater.checking': 'Buscando actualizaciones',
  'updater.download': 'Descargar actualización',
  'updater.downloading': 'Descargando actualización',
  'updater.downloadingPercent': 'Descargando actualización {percent}%',
  'updater.done': 'Listo',
  'updater.failed': 'Error de actualización',
  'updater.installerOpenBody': 'El instalador está abierto. Open Design se está cerrando para que puedas completar la actualización.',
  'updater.installerOpened': 'Instalador abierto',
  'updater.later': 'Más tarde',
  "updater.allowSilentUpdates": "Permitir instalación automática de futuras actualizaciones in-app",
  'updater.openFailedFallback': 'No se pudo abrir el instalador.',
  'updater.installRestart': 'Instalar y reiniciar',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Instalar actualización',
  'updater.opening': 'Abriendo instalador...',
  'updater.dialogAvailableGeneric': 'Hay una nueva versión disponible.\nDescárgala para instalar la actualización.',
  'updater.dialogAvailableVersion': 'La v{version} está disponible.\nDescárgala para instalar la actualización.',
  'updater.dialogCheckFailed': 'No se pudieron buscar actualizaciones.\nInténtalo de nuevo en unos instantes.',
  'updater.dialogReadyGeneric': 'Hay una nueva versión lista.\nMejor experiencia y diseño más inteligente.',
  'updater.dialogReadyVersion': 'v{version} está listo.\nMejor experiencia y diseño más inteligente.',
  'updater.dialogUnsupported': 'La actualización en la app no está disponible.\nDescarga la última versión manualmente.',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Salir de Open Design',
  'updater.quitFailedBody': 'El instalador está abierto, pero Open Design no pudo cerrarse. Cierra Open Design antes de reemplazar la app.',
  'updater.quitFailedTitle': 'No se pudo salir',
  'updater.quitting': 'Cerrando...',
  'updater.ready': 'Actualización lista',
  'updater.readyGeneric': 'Hay una nueva versión lista. Open Design se cerrará y abrirá el instalador.',
  'updater.readyVersion': 'Open Design {version} está listo. Open Design se cerrará y abrirá el instalador.',
  'updater.reinstallLearnMore': 'Más información',
  'updater.reinstallReadyGeneric': 'Esta actualización requiere una reinstalación completa. Open Design se cerrará y abrirá el instalador.',
  'updater.reinstallReadyVersion': 'Open Design {version} requiere una reinstalación completa. Open Design se cerrará y abrirá el instalador.',
  'updater.restartAnyway': 'Reiniciar de todos modos',
  'updater.upToDate': 'Ya tienes la versión más reciente.',
  'updater.viewVersionFeatures': 'Descubrir las novedades',
  'updater.manualDownload': 'Descargar manualmente',
  'whatsNew.updatedTitle': 'Open Design {version} ya está aquí',
  'whatsNew.cta': 'Ver las notas de la versión',
  'newsletter.label': 'Newsletter (opcional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatización',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Resumen diario de conectores',
  'settings.orbit.lede': 'Recopila actividad de conectores según una programación y publica el resultado como un live artifact actualizable.',
  'settings.orbit.statusOnTitle': 'Las ejecuciones diarias programadas están activadas',
  'settings.orbit.statusOffTitle': 'Las ejecuciones diarias programadas están desactivadas',
  'settings.orbit.statusActive': 'Activo',
  'settings.orbit.statusOff': 'Desactivado',
  'settings.orbit.runTitle': 'Iniciar una ejecución de Orbit y abrir la conversación en vivo',
  'settings.orbit.running': 'Ejecutando…',
  'settings.orbit.runOpen': 'Ejecutar ahora',
  'settings.orbit.dailySummaryTitle': 'Resumen diario',
  'settings.orbit.dailySummarySub': 'Se ejecuta una vez al día a la hora local programada.',
  'settings.orbit.on': 'Activado',
  'settings.orbit.off': 'Desactivado',
  'settings.orbit.runTimeTitle': 'Hora de ejecución',
  'settings.orbit.runTimeSub': 'Predeterminada 08:00. Guarda para aplicar la programación del daemon.',
  'settings.orbit.runTimeAria': 'Hora de ejecución diaria de Orbit',
  'settings.orbit.nextRun': 'Próxima ejecución',
  'settings.orbit.nextRunScheduledAfterSave': 'Programada después de guardar',
  'settings.orbit.schedule': 'Programación',
  'settings.orbit.pausedManualOnly': 'Pausado — solo ejecuciones manuales',
  'settings.orbit.templateTitle': 'Plantilla de prompt',
  'settings.orbit.templateMissing': 'La plantilla {id} no está instalada.',
  'settings.orbit.templateMissingOption': '{id} (falta)',
  'settings.orbit.templateMissingInstall': 'Instala una skill de Orbit para dirigir el prompt.',
  'settings.orbit.templateMissingPickAnother': 'Elige otra plantilla en el desplegable.',
  'settings.orbit.templateResetTitle': 'Restablecer a {id}',
  'settings.orbit.templateReset': 'Restablecer',
  'settings.orbit.templateHelp': 'Dirige Orbit con una skill: el prompt de ejemplo de la plantilla seleccionada se inyecta en cada ejecución de Orbit para que los resúmenes sigan esa forma.',
  'settings.orbit.templateAria': 'Plantilla de prompt de Orbit',
  'settings.orbit.templatesLoading': 'Cargando plantillas…',
  'settings.orbit.templatesOptgroup': 'Plantillas de skills de Orbit',
  'settings.orbit.lastRun': 'Última ejecución',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Programada',
  'settings.orbit.meterAria': '{succeeded} correctos, {skipped} omitidos, {failed} fallidos de {checked} comprobados',
  'settings.orbit.countChecked': 'Comprobados',
  'settings.orbit.countSucceeded': 'Correctos',
  'settings.orbit.countSkipped': 'Omitidos',
  'settings.orbit.countFailed': 'Fallidos',
  'settings.orbit.runError': 'No se pudo ejecutar Orbit. Asegúrate de que el daemon local esté en ejecución y los conectores estén configurados.',
  'settings.orbit.gateAriaLabel': 'Se necesitan conectores para usar Orbit',
  'settings.orbit.gateEyebrow': 'Configuración requerida',
  'settings.orbit.gateTitle': 'Conecta una herramienta para impulsar Orbit',
  'settings.orbit.gateBody': 'Orbit resume la actividad de tus conectores. Aún no has conectado ninguno — añade al menos una integración para que Orbit tenga algo que informar.',
  'settings.orbit.gateBodyNoKey': 'Orbit resume la actividad de tus conectores, y los conectores funcionan a través de Composio. Añade una clave de API de Composio en Conectores para desbloquear el catálogo y elegir tu primera integración.',
  'settings.orbit.gateAction': 'Abrir Conectores',
  'settings.orbit.gateActionNoKey': 'Configurar Composio',
  'settings.orbit.gateLoading': 'Comprobando tus conectores…',
  'settings.orbit.controlsLockedBadge': 'Bloqueado',
  'settings.orbit.controlsLockedHint': 'Conecta una herramienta para desbloquear la programación y la plantilla de Orbit.',
  'settings.orbit.artifactKickerLive': 'artefacto en vivo',
  'settings.orbit.artifactKickerLegacy': 'Resumen heredado',
  'settings.orbit.artifactTitle': 'Resumen diario de actividad de Orbit',
  'settings.orbit.artifactMetaLive': 'Artefacto HTML actualizable generado a partir de actividad de conectores.',
  'settings.orbit.artifactMetaLegacy': 'Generado antes de activar la compatibilidad con live artifact; ejecuta Orbit de nuevo para publicar uno.',
  'settings.orbit.copyMarkdownTitle': 'Copiar resumen Markdown al portapapeles',
  'settings.orbit.copied': 'Copiado',
  'settings.orbit.copy': 'Copiar',
  'settings.orbit.openArtifact': 'Abrir artefacto',
  'settings.orbit.sourceMarkdown': 'Markdown fuente',
  'settings.memoryModelInlineHintByokNeutral': 'La memoria usa un modelo distinto al del chat. Por defecto, usa el modelo de tu chat.',
  'diagnostics.exportTitle': 'Exportar diagnósticos',
  'diagnostics.exportButton': 'Exportar diagnósticos',
  'diagnostics.exportHint': 'Empaqueta los registros recientes y la información del equipo en un zip para enviar al soporte.',
  'diagnostics.exporting': 'Exportando…',
  'diagnostics.exportSuccess': 'Diagnósticos guardados en {path}',
  'diagnostics.exportFailed': 'No se pudieron exportar los diagnósticos: {message}',
  'automations.eyebrow': 'Sesiones de agente programadas',
  'automations.title': 'Automatizaciones',
  'automations.lede': 'Planifica conversaciones recurrentes para el trabajo de proyectos, resúmenes de Orbit y artefactos en vivo.',
  'automations.summaryAria': 'Resumen de automatización',
  'automations.metricActive': 'Activas',
  'automations.metricPaused': 'En pausa',
  'automations.metricTemplates': 'Plantillas',
  'automations.newAutomation': 'Nueva automatización',
  'automations.yourAutomations': 'Tus automatizaciones',
  'automations.loading': 'Cargando',
  'automations.emptyTitle': 'Aún no hay automatizaciones',
  'automations.emptyBody': 'Crea una a partir de una plantilla o empieza con una programación en blanco.',
  'automations.targetNewEachRun': 'Proyecto nuevo en cada ejecución',
  'automations.targetCreateEachRun': 'Proyecto nuevo en cada ejecución',
  'automations.lastRun': 'Última ejecución {time}',
  'automations.openResult': 'Abrir resultado',
  'automations.run': 'Ejecutar',
  'automations.runNowTitle': 'Ejecutar ahora y abrir la conversación',
  'automations.history': 'Historial',
  'automations.hideHistory': 'Ocultar historial',
  'automations.edit': 'Editar',
  'automations.pause': 'Pausar',
  'automations.resume': 'Reanudar',
  'automations.deleteAria': 'Eliminar automatización',
  'automations.deleteTitle': 'Eliminar esta automatización',
  'automations.deleteConfirm': '¿Eliminar esta automatización? Se conservan las ejecuciones anteriores y sus proyectos.',
  'automations.proposalsTitle': 'Propuestas de evolución',
  'automations.proposalsSub': 'Revisa el resultado de la automatización antes de que cambie la memoria, las habilidades o los sistemas de diseño.',
  'automations.proposalsPending': '{n} pendientes',
  'automations.apply': 'Aplicar',
  'automations.reject': 'Rechazar',
  'automations.proposalsDismissReason': 'Descartada en Automatizaciones',
  'automations.templatesTitle': 'Plantillas',
  'automations.templatesSub': 'Orbit y los artefactos en vivo son plantillas dentro del mismo flujo de automatización.',
  'automations.templatesCount': '{filtered} de {total}',
  'automations.templateFiltersAria': 'Filtros de plantillas',
  'automations.templatesEmptyTitle': 'Aún no hay plantillas en esta categoría.',
  'automations.templatesEmptyBody': 'Prueba con otro filtro o empieza desde una automatización en blanco.',
  'automations.useTemplate': 'Usar plantilla',
  'automations.runHistoryLoading': 'Cargando historial de ejecuciones...',
  'automations.runHistoryEmpty': 'Aún no hay ejecuciones.',
  'automations.runHistoryTitle': 'Historial de ejecuciones',
  'automations.runHistoryLatest': 'Últimas 10',
  'automations.crystallize': 'Cristalizar',
  'automations.crystallizing': 'Cristalizando',
  'automations.crystallizeTitle': 'Redacta propuestas de habilidades y memoria a partir de esta ejecución',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Abrir conversación',
  'automations.runHistoryAria': 'Historial de ejecuciones de la automatización',
  'automations.proposalsAria': 'Propuestas de evolución de la automatización',
  'automations.templatesAria': 'Plantillas de automatización',
  'automations.runInProgress': 'En curso',
  'automations.promptPlaceholder': 'Extrae la actividad de ayer en GitHub + Linear y resume lo que cambió.',
  'automations.scheduleStatusPaused': 'En pausa',
  'automations.nextRunManualOnly': 'Solo manual',
  'automations.nextRunScheduled': 'Programada',
  'automations.nextRunAt': 'Próxima {time}',
  'automations.statusSucceeded': 'Correcta',
  'automations.statusFailed': 'Fallida',
  'automations.statusRunning': 'En ejecución',
  'automations.statusQueued': 'En cola',
  'automations.statusCanceled': 'Cancelada',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefacto en vivo',
  'automations.kindAutomation': 'Automatización',
  'automations.proposalTargetMemory': 'Memoria',
  'automations.proposalTargetDesignSystem': 'Sistema de diseño',
  'automations.proposalTargetSkill': 'Habilidad',
  'automations.proposalTargetTemplate': 'Plantilla de automatización',
  'automations.proposalActionCreate': 'Crear',
  'automations.proposalActionUpdate': 'Actualizar',
  'automations.proposalActionMerge': 'Combinar',
  'automations.proposalActionMove': 'Mover',
  'automations.proposalActionDelete': 'Eliminar',
  'automations.proposalActionPromote': 'Promover',
  'automations.filterAll': 'Todas',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefactos en vivo',
  'automations.filterMemory': 'Memoria',
  'automations.filterDesignSystems': 'Sistemas de diseño',
  'automations.filterSkills': 'Habilidades',
  'automations.filterConnectors': 'Conectores',
  'automations.filterCompression': 'Compresión',
  'automations.filterRelease': 'Lanzamiento',
  'automations.filterQuality': 'Calidad',
  'automations.tpl.memoryRefresh.title': 'Actualiza la memoria del proyecto a partir del trabajo reciente.',
  'automations.tpl.memoryRefresh.desc': 'Convierte decisiones, preferencias y comentarios repetidos en actualizaciones de memoria reutilizables.',
  'automations.tpl.designSystemRefresh.title': 'Actualiza los sistemas de diseño a partir de los artefactos entregados.',
  'automations.tpl.designSystemRefresh.desc': 'Encuentra tokens, componentes y reglas reutilizables en el trabajo de diseño reciente.',
  'automations.tpl.liveArtifactRegistry.title': 'Audita los artefactos en vivo y actualiza las versiones obsoletas.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantiene actualizados los paneles, informes y vistas previas persistentes en lugar de duplicarlos.',
  'automations.tpl.orbitDashboard.title': 'Crea un panel de actividad de conectores.',
  'automations.tpl.orbitDashboard.desc': 'Agrega los conectores seleccionados en un panel en vivo de estilo Orbit.',
  'automations.tpl.releaseNotes.title': 'Redacta notas de lanzamiento a partir del trabajo de diseño entregado.',
  'automations.tpl.releaseNotes.desc': 'Conecta los PR fusionados, los artefactos y los cambios visibles para el usuario en notas de lanzamiento.',
  'automations.tpl.qualityRegressionWatch.title': 'Vigila las regresiones de diseño e implementación.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compara los cambios recientes con los puntos de referencia, las trazas y las referencias aceptadas.',
  'automations.tpl.orbitDaily.title': 'Resumen diario de conectores.',
  'automations.tpl.orbitDaily.desc': 'Actualiza un resumen de actividad de conectores según una programación.',
  'automations.tpl.liveStatusBoard.title': 'Mantén actualizado un artefacto de estado en vivo.',
  'automations.tpl.liveStatusBoard.desc': 'Actualiza un único artefacto persistente en lugar de crear un informe nuevo en cada ejecución.',
  'dsManager.areaAria': 'Área de sistemas de diseño',
  'dsManager.tabDesignSystem': 'Sistema de diseño',
  'dsManager.tabTemplate': 'Plantilla',
  'dsManager.sourceAria': 'Origen del sistema de diseño',
  'dsManager.templateSourceAria': 'Origen de la plantilla',
  'dsManager.yourSystems': 'Tus sistemas',
  'dsManager.officialPresets': 'Ajustes preestablecidos oficiales',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Sincronizar con el equipo',
  'dsManager.syncToTeamFailed': 'No se pudo sincronizar con el equipo',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Empresa',
  'dsManager.yourTemplates': 'Tus plantillas',
  'dsManager.yourSystemsAria': 'Tus sistemas de diseño',
  'dsManager.eyebrowDesignSystems': 'Sistemas de diseño',
  'dsManager.yourSystemsHeading': 'Tus sistemas',
  'dsManager.filterAria': 'Filtrar sistemas de diseño',
  'dsManager.filterAll': 'Todos',
  'dsManager.filterPublished': 'Publicados',
  'dsManager.filterDraft': 'Borrador',
  'dsManager.createTitle': 'Crear nuevo sistema de diseño',
  'dsManager.createBody': 'Enseña a Open Design tu marca, producto, código, recursos y referencias de diseño.',
  'dsManager.createAction': 'Crear',
  'dsManager.emptyMine': 'Aún no hay sistemas de diseño. Crea uno a partir de contexto real del producto, revisa el borrador y publícalo para futuros proyectos.',
  'dsManager.badgeDefault': 'Predeterminado',
  'dsManager.rowMetaUpdated': 'Tú · actualizado {date}',
  'dsManager.edit': 'Editar',
  'dsManager.openSystem': 'Abrir',
  'dsManager.editWithAgent': 'Editar con Agent',
  'dsManager.downloadTitle': 'Descargar sistema de diseño (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Descargar {title} como .zip',
  'dsManager.downloadFailed': 'No se pudo descargar el sistema de diseño. Inténtalo de nuevo.',
  'dsManager.deleteConfirm': '¿Eliminar "{title}"? Esto quitará el borrador del sistema de diseño de este dispositivo.',
  'dsManager.makeDefault': 'Establecer como predeterminado',
  'dsManager.statusPublished': 'Publicado',
  'dsManager.statusDraft': 'Borrador',
  'dsManager.openSystemAria': 'Abrir {title}',
  'dsManager.deleteSystemAria': 'Eliminar {title}',
  'dsManager.deletePermissionDenied': 'No tienes permiso para eliminar este sistema de diseño.',
  'dsManager.presetsAria': 'Ajustes preestablecidos oficiales de sistemas de diseño',
  'dsManager.eyebrowLibrary': 'Biblioteca',
  'dsManager.eyebrowTemplates': 'Plantillas',
  'dsManager.yourTemplatesAria': 'Tus plantillas',
  'dsManager.emptyTemplates': 'Aún no hay plantillas. Crea una desde cualquier proyecto generado mediante Compartir cuando se habilite la publicación de plantillas.',
  'dsManager.templateDescFallback': 'Creada a partir de un proyecto',
  'dsManager.comingSoonBadge': 'Próximamente',
  'dsManager.enterpriseDsTitle': 'Sistemas de diseño para empresas',
  'dsManager.enterpriseDsBody': 'Los sistemas de diseño compartidos por equipos y las bibliotecas de marca gobernadas llegarán pronto.',
  'dsManager.enterpriseTplTitle': 'Plantillas para empresas',
  'dsManager.enterpriseTplBody': 'Las plantillas aprobadas por el equipo y la publicación a nivel de organización llegarán pronto.',
  'settings.instructionsTitle': 'Instrucciones y reglas',
  'settings.instructionsSubtitle': 'Comportamiento fijo que el asistente debe seguir',
  'settings.instructionsNavSub': 'Comportamiento fijo del asistente',
  'settings.customInstructionsDesc': 'Instrucciones fijas que Open Design sigue en cada chat. No son memorias guardadas; usa Memoria para hechos, preferencias y contexto del proyecto.',
  'mcpClient.forwardedToLabel': 'Reenviado a:',
  'mcpClient.notForwardedToLabel': 'No reenviado a:',
  'mcpClient.forwardedAcpNote': 'Los adaptadores ACP marcados como stdio solo reciben servidores MCP de stdio de esta lista; las entradas HTTP y SSE se descartan en el momento de la creación.',
  'mcpClient.notForwardedNote': 'Para esos agentes, configura los servidores MCP en el propio archivo de configuración del agente (p. ej. ~/.codex/config.toml, ~/.gemini/settings.json); los servidores de abajo se ignoran de forma silenciosa allí.',

  // Brands library + extraction
  'brand.libraryTitle': 'Kit de marca',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Pega un sitio web, o elige una marca abajo, y extraeremos sus colores, fuentes y logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Kit de marca',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Borrar caché de actualización',
  'settings.clearUpdaterCacheHint': 'Elimina las actualizaciones descargadas y las cachés obsoletas del actualizador, y restablece el estado de actualización. Úsalo cuando las actualizaciones parezcan atascadas.',
  'settings.clearUpdaterCacheButton': 'Borrar caché',
  'settings.clearUpdaterCacheConfirmButton': 'Confirmar borrado',
  'settings.clearUpdaterCacheSuccess': 'Caché de actualización borrada.',
  'settings.clearUpdaterCacheFailed': 'No se pudo borrar la caché de actualización.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Créalo una vez, constrúyelo en todas partes',
  'onboarding.buildBody': 'Open Design convierte tu marca en un sistema de diseño reutilizable y mantiene coherente y fiel a la marca todo lo que creas.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Crear un sistema de diseño',
  'onboarding.buildHome': 'Ir al inicio',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Empieza con una marca que te encante',
  'brandPicker.subtext': 'Haz clic en cualquier marca para extraer su kit directamente de su sitio web.',
  'brandPicker.quickPicksLabel': 'Marcas populares: haz clic para extraer',
  'brandPicker.searchPlaceholder': 'Buscar marcas…',
  'brandPicker.allCategories': 'Todas',
  'brandPicker.extractAction': 'Extraer',
  'brandPicker.showMore': 'Mostrar más',
  'brandPicker.opening': 'Iniciando la extracción: abriendo {brand}…',
  'ds.kitVisualize': 'Visualizar',
  'ds.kitEdit': 'Editar',
  'ds.kitSource': 'Código',
  'ds.saveDesignMd': 'Guardar DESIGN.md',
  'ds.saving': 'Guardando…',
  'ds.copyDesignMd': 'Copiar DESIGN.md',
  'ds.editDesignMd': 'Editar DESIGN.md',
  'ds.openDesignMd': 'Abrir DESIGN.md',
  'ds.copyDesignMdModule': 'Copiar sección {module}',
  'ds.editDesignMdModule': 'Editar sección {module}',
  'ds.openDesignMdModule': 'Abrir sección {module}',
  'ds.uploadMd': 'Subir MD',
  'ds.uploadFont': 'Añadir archivo de fuente',
  'ds.pasteImage': 'Pegar imagen',
  'ds.refresh': 'Actualizar',
  'ds.download': 'Descargar',
  'ds.importFolder': 'Importar carpeta',
  'ds.reset': 'Restablecer',
  'ds.editingDesignMdHint': 'Editar este Markdown actualiza los módulos renderizados del kit.',
  'ds.editingModuleHint': 'Solo se está editando el módulo {module}.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Guardar módulo',
  'ds.uploadLogo': 'Subir logo',
  'ds.uploadImage': 'Subir imagen',
  'ds.uploading': 'Subiendo…',
  'ds.moduleEmptyLogo': 'Aún no hay logo',
  'ds.moduleEmptyFonts': 'No se capturaron fuentes.',
  'ds.actionDone': 'Listo',
  'ds.actionFailed': 'Algo salió mal. Inténtalo de nuevo.',
  'ds.uploadDone': 'Subido',
  'ds.uploadFailed': 'Error al subir. Inténtalo de nuevo.',
  'ds.deleteLogo': 'Eliminar logo',
  'ds.deleteImage': 'Eliminar {caption}',
  'ds.deleteProjectConfirm': '¿Eliminar "{title}"? Esto quitará permanentemente este sistema de diseño y su proyecto de este dispositivo.',
  'ds.deleteProjectAction': 'Eliminar {title}',
  'ds.editColor': 'Editar {name}',
  'ds.colorLabel': 'Color',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Valor Hex',
  'ds.saveColor': 'Guardar color',
  'ds.invalidHexColor': 'Introduce un color Hex válido, como #FF6A3D.',
  'ds.colorSaveFailed': 'No se pudo guardar este color.',
  'ds.colorResetFailed': 'No se pudo restablecer este color.',
  'ds.designMdSectionLabel': 'Sección {module} de DESIGN.md',
  'ds.kitErrorTitle': 'Esta vista encontró un problema.',
  'ds.kitErrorRetry': 'Recargar',
  'ds.shortcutsLabel': 'Atajos de teclado',
  'ds.shortcutsHint': 'Atajos: E editar · C copiar · U subir · R actualizar · ⌫ eliminar logo',
  'ds.moduleEmptyImages': 'Aún no hay imágenes',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Empezar desde',
  'newproj.startBlank': 'En blanco',
  'newproj.startBlankHint': 'Empezar desde cero',
  'workspace.pages': 'Páginas',
  'workspace.allProjectFiles': 'Todos los archivos del proyecto',
  'workspace.newBlankPage': 'Nueva página en blanco',
  'workspace.noPagesYet': 'Aún no hay páginas',
  'workspace.pageCreateFailed': 'No se pudo crear la página.',
  'workspace.pageCreatorTitle': 'Crear página',
  'workspace.pageCreatorSearch': 'Buscar plantillas',
  'workspace.pageCreatorCategoryAll': 'Todos los escenarios',
  'workspace.pageCreatorEmpty': 'Ningún tipo de página coincide con tu búsqueda.',
  'workspace.pageCreatorPreview': 'Vista previa',
  'workspace.pageCreatorUse': 'Usar',
  'fileViewer.presentInTabDeckHint': 'Notas del orador en ventana emergente',
  'fileViewer.presentEscHint': 'Pulsa Esc para salir',
  'fileViewer.presenterPause': 'Pausar',
  'fileViewer.presenterResume': 'Reanudar',
  'fileViewer.presenterPrevious': 'Anterior',
  'fileViewer.presenterNext': 'Siguiente',
  'questions.uploadingFiles': 'Subiendo archivos…',
  'questions.uploadNeedsProject': 'La subida de archivos necesita un proyecto activo.',
  'questions.uploadPartialFailed': 'Se subieron {uploaded} archivo(s), pero {failed} fallaron.',
  'questions.uploadFailed': 'Falló la subida de {failed} archivo(s).',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'Usar prompt',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the Open Design Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the Open Design Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and Open Design will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'Open Design will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'Open Design will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'Open Design account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by Open Design; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'Open Design is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'Open Design is rebuilding tokens',
  'dsFlow.jobRevising': 'Open Design is revising',
  'dsFlow.jobStillWorking': 'Open Design is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask Open Design to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'Open Design is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'Open Design is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'Open Design is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'Open Design is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'Open Design official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'Esta vez, inteligencia de primer nivel. Sin límites.',
  'campaign.deepseekV4Flash.description': 'Landings, sitios, decks e imágenes — tanto como necesites.',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro y V4 Flash ilimitados',
  'campaign.deepseekV4Flash.timing': '13–27 ago: uso gratuito durante la campaña',
  'campaign.deepseekV4Flash.ruleSummary': 'Del 13 al 27 de ago, los usuarios de pago pueden usar DeepSeek V4 Pro y V4 Flash gratis en Open Design. El abuso a gran escala puede pausar el acceso a la campaña.',
  'campaign.deepseekV4Flash.windowLabel': '13–27 ago',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'dos semanas gratis',
  'campaign.deepseekV4Flash.boundary': 'La cuota ilimitada del modelo y las generaciones gratuitas del plan solo aplican dentro de Open Design — no vía MCP, CLI, API u otras superficies. La interpretación final corresponde a Open Design. Algunos modelos pueden requerir espera en horas punta.',
  'campaign.deepseekV4Flash.countdownLabel': 'Cuenta regresiva',
  'campaign.deepseekV4Flash.countdownEnded': 'Campaña finalizada',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}d {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Cerrar',
  'campaign.deepseekV4Flash.unlocked': 'Desbloqueado',
  'campaign.deepseekV4Flash.locked': 'Bloqueado',
  'campaign.deepseekV4Flash.later': 'Más tarde',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Dos semanas gratis',
  'campaign.deepseekV4Flash.paid.status': 'Desbloqueado · 13–27 ago',
  'campaign.deepseekV4Flash.paid.cta': 'Usar ahora',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Ilimitado',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Gratis en planes de pago',
  'campaign.deepseekV4Flash.unpaid.status': 'Mejora el plan para desbloquear · hasta el 27 ago',
  'campaign.deepseekV4Flash.unpaid.cta': 'Mejorar plan y usar',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Requiere mejora',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Suscríbete durante la campaña para usarlo gratis; termina el 27 ago.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'En pausa',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Se detectó un uso de alto volumen inusual y el acceso a la campaña está en pausa. Contacta con soporte si necesitas ayuda.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash ilimitados y gratis',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro y V4 Flash ilimitados y gratis — ver precios',

  'experienceSurvey.tag': "Nos encantaría tu opinión: ayúdanos a mejorar Open Design",
  'experienceSurvey.close': "Cerrar",
  'experienceSurvey.recommendation': "¿Qué probabilidad hay de que recomiendes Open Design a un colega o amigo?",
  'experienceSurvey.recommendationLow': "Nada probable",
  'experienceSurvey.recommendationHigh': "Muy probable",
  'experienceSurvey.improvement': "¿Qué deberíamos mejorar primero?",
  'experienceSurvey.improvement.wrongOutput': "No es lo que pedí",
  'experienceSurvey.improvement.falseDone': "Dice que terminó y no cambió nada",
  'experienceSurvey.improvement.hardToUse': "Incómodo de usar",
  'experienceSurvey.improvement.upgradePrompts': "Demasiados avisos de pago",
  'experienceSurvey.improvement.stuck': "Se atasca o falla",
  'experienceSurvey.improvement.slow': "Demasiado lento",
  'experienceSurvey.improvement.looks': "El resultado no se ve bien",
  'experienceSurvey.improvement.regression': "Rompe otras cosas",
  'experienceSurvey.improvement.other': "Otra cosa",
  'experienceSurvey.otherPlaceholder': "Cuéntanoslo con tus palabras",
  'experienceSurvey.submit': "Enviar",
  'experienceSurvey.skip': "Omitir",
  'experienceSurvey.thanksTitle': "¡Gracias!",
  'experienceSurvey.thanksBody': "Tu opinión llega directamente al equipo.",
};
